/* tslint:disable */
/* eslint-disable */
/**
 * NETS(EFT) Project Admin REST API
 * \"This module is used to maintain and manage project level components  \"
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AdditionalProjectDetailsDto
 */
export interface AdditionalProjectDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof AdditionalProjectDetailsDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalProjectDetailsDto
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalProjectDetailsDto
     */
    'practice'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalProjectDetailsDto
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalProjectDetailsDto
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface AlignedElementUiStateDto
 */
export interface AlignedElementUiStateDto {
    /**
     * 
     * @type {number}
     * @memberof AlignedElementUiStateDto
     */
    'alignmentElementId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementUiStateDto
     */
    'alignmentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementUiStateDto
     */
    'channelShape'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementUiStateDto
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementUiStateDto
     */
    'endDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementUiStateDto
     */
    'peakFlow'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementUiStateDto
     */
    'startDistance'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementUiStateDto
     */
    'tableView'?: string;
    /**
     * 
     * @type {UiSettingsDto}
     * @memberof AlignedElementUiStateDto
     */
    'uiSettingsDto'?: UiSettingsDto;
}
/**
 * 
 * @export
 * @interface Alignment
 */
export interface Alignment {
    /**
     * 
     * @type {number}
     * @memberof Alignment
     */
    'alignmentId'?: number;
    /**
     * 
     * @type {number}
     * @memberof Alignment
     */
    'autoCreated'?: number;
    /**
     * 
     * @type {string}
     * @memberof Alignment
     */
    'autoGrow'?: string;
    /**
     * 
     * @type {number}
     * @memberof Alignment
     */
    'beginningX'?: number;
    /**
     * 
     * @type {number}
     * @memberof Alignment
     */
    'beginningY'?: number;
    /**
     * 
     * @type {string}
     * @memberof Alignment
     */
    'createdBy'?: string;
    /**
     * 
     * @type {Array<CrossSlope>}
     * @memberof Alignment
     */
    'crossSlopes'?: Array<CrossSlope>;
    /**
     * 
     * @type {string}
     * @memberof Alignment
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alignment
     */
    'entryMethod'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alignment
     */
    'increasing'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alignment
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alignment
     */
    'name'?: string;
    /**
     * 
     * @type {Array<OffsetStation>}
     * @memberof Alignment
     */
    'offsetStations'?: Array<OffsetStation>;
    /**
     * 
     * @type {Array<AlignmentStation>}
     * @memberof Alignment
     */
    'stations'?: Array<AlignmentStation>;
    /**
     * 
     * @type {Survey}
     * @memberof Alignment
     */
    'survey'?: Survey;
}
/**
 * 
 * @export
 * @interface AlignmentStation
 */
export interface AlignmentStation {
    /**
     * 
     * @type {Alignment}
     * @memberof AlignmentStation
     */
    'alignment'?: Alignment;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStation
     */
    'alignmentStationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStation
     */
    'angle'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStation
     */
    'angleType'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentStation
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStation
     */
    'curveType'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStation
     */
    'curveValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStation
     */
    'distance'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStation
     */
    'distanceToPiStation'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentStation
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignmentStation
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStation
     */
    'stationDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStation
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStation
     */
    'y'?: number;
}
/**
 * 
 * @export
 * @interface AnnouncementDto
 */
export interface AnnouncementDto {
    /**
     * 
     * @type {number}
     * @memberof AnnouncementDto
     */
    'announcementId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementDto
     */
    'announcementText'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementDto
     */
    'announcementTextLink'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof AnnouncementDto
     */
    'creationDateUtc'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AnnouncementDto
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AnnouncementDto
     */
    'lastChangeDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof AnnouncementDto
     */
    'priority'?: number;
    /**
     * 
     * @type {number}
     * @memberof AnnouncementDto
     */
    'viewOrder'?: number;
}
/**
 * 
 * @export
 * @interface AnnouncementRequestDto
 */
export interface AnnouncementRequestDto {
    /**
     * 
     * @type {number}
     * @memberof AnnouncementRequestDto
     */
    'announcementId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementRequestDto
     */
    'announcementText'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementRequestDto
     */
    'announcementTextLink'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementRequestDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementRequestDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof AnnouncementRequestDto
     */
    'overwriteAnnouncementId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AnnouncementRequestDto
     */
    'priority'?: number;
    /**
     * 
     * @type {number}
     * @memberof AnnouncementRequestDto
     */
    'viewOrder'?: number;
}
/**
 * 
 * @export
 * @interface AnnouncementResponseDto
 */
export interface AnnouncementResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AnnouncementResponseDto
     */
    'announcementText'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementResponseDto
     */
    'announcementTextLink'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementResponseDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof AnnouncementResponseDto
     */
    'creationDateUtc'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AnnouncementResponseDto
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AnnouncementResponseDto
     */
    'lastChangeDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementResponseDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof AnnouncementResponseDto
     */
    'priority'?: number;
    /**
     * 
     * @type {number}
     * @memberof AnnouncementResponseDto
     */
    'viewOrder'?: number;
}
/**
 * 
 * @export
 * @interface BreaklineEntity
 */
export interface BreaklineEntity {
    /**
     * 
     * @type {string}
     * @memberof BreaklineEntity
     */
    'breaklineJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreaklineEntity
     */
    'breaklineTypeCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreaklineEntity
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreaklineEntity
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreaklineEntity
     */
    'featureDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreaklineEntity
     */
    'featureName'?: string;
    /**
     * 
     * @type {number}
     * @memberof BreaklineEntity
     */
    'featureTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BreaklineEntity
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreaklineEntity
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {SurfaceDef}
     * @memberof BreaklineEntity
     */
    'surfaceDef'?: SurfaceDef;
}
/**
 * 
 * @export
 * @interface CrossSlope
 */
export interface CrossSlope {
    /**
     * 
     * @type {Alignment}
     * @memberof CrossSlope
     */
    'alignment'?: Alignment;
    /**
     * 
     * @type {string}
     * @memberof CrossSlope
     */
    'createdBy'?: string;
    /**
     * 
     * @type {Array<CrossSlopeStation>}
     * @memberof CrossSlope
     */
    'crossSlopeStations'?: Array<CrossSlopeStation>;
    /**
     * 
     * @type {string}
     * @memberof CrossSlope
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrossSlope
     */
    'entryMode'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrossSlope
     */
    'hiElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlope
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrossSlope
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrossSlope
     */
    'offsetType'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrossSlope
     */
    'singleShotOffset'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlope
     */
    'slopeWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlope
     */
    'stationDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlope
     */
    'stationStep'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrossSlope
     */
    'uphillsTo'?: string;
}
/**
 * 
 * @export
 * @interface CrossSlopeStation
 */
export interface CrossSlopeStation {
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeStation
     */
    'createdBy'?: string;
    /**
     * 
     * @type {CrossSlope}
     * @memberof CrossSlopeStation
     */
    'crossSlope'?: CrossSlope;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStation
     */
    'crossSlopeStationOffset'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStation
     */
    'crossSlopeStationSlope'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeStation
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStation
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeStation
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStation
     */
    'z'?: number;
}
/**
 * 
 * @export
 * @interface DefaultParametersDto
 */
export interface DefaultParametersDto {
    /**
     * 
     * @type {string}
     * @memberof DefaultParametersDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof DefaultParametersDto
     */
    'creationDateUtc'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultParametersDto
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DefaultParametersDto
     */
    'json'?: string;
    /**
     * 
     * @type {number}
     * @memberof DefaultParametersDto
     */
    'lastChangeDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof DefaultParametersDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof DefaultParametersDto
     */
    'parameterDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof DefaultParametersDto
     */
    'parameterId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DefaultParametersDto
     */
    'parameterName'?: string;
}
/**
 * 
 * @export
 * @interface DefaultParametersRequestDto
 */
export interface DefaultParametersRequestDto {
    /**
     * 
     * @type {string}
     * @memberof DefaultParametersRequestDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultParametersRequestDto
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DefaultParametersRequestDto
     */
    'json'?: string;
    /**
     * 
     * @type {string}
     * @memberof DefaultParametersRequestDto
     */
    'parameterDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof DefaultParametersRequestDto
     */
    'parameterName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DefaultParametersRequestDto
     */
    'updatedBy'?: string;
}
/**
 * 
 * @export
 * @interface DemMetadataResponseDto
 */
export interface DemMetadataResponseDto {
    /**
     * 
     * @type {number}
     * @memberof DemMetadataResponseDto
     */
    'acquisitionDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataResponseDto
     */
    'browseUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataResponseDto
     */
    'collectionDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataResponseDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataResponseDto
     */
    'creationDateUtc'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DemMetadataResponseDto
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataResponseDto
     */
    'demMetadataSummaryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataResponseDto
     */
    'demResolution'?: number;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataResponseDto
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataResponseDto
     */
    'elevationUnit'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof DemMetadataResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataResponseDto
     */
    'horizontalAccuracy'?: number;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataResponseDto
     */
    'lastChangeDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataResponseDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataResponseDto
     */
    'meets3dep'?: number;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataResponseDto
     */
    'meets3depLc'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataResponseDto
     */
    'metadataUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataResponseDto
     */
    'pixelSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataResponseDto
     */
    'projection'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataResponseDto
     */
    'qualityLevel3dep'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataResponseDto
     */
    'reasonDataDoesordoesNotMeet2dep'?: string;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataResponseDto
     */
    'verticalAccuracy'?: number;
}
/**
 * 
 * @export
 * @interface DemMetadataSummaryEntity
 */
export interface DemMetadataSummaryEntity {
    /**
     * 
     * @type {number}
     * @memberof DemMetadataSummaryEntity
     */
    'acquisitionDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataSummaryEntity
     */
    'browseUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataSummaryEntity
     */
    'collectionDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataSummaryEntity
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataSummaryEntity
     */
    'creationDateUtc'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DemMetadataSummaryEntity
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataSummaryEntity
     */
    'demMetadataSummaryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataSummaryEntity
     */
    'demResolution'?: number;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataSummaryEntity
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataSummaryEntity
     */
    'elevationUnit'?: string;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataSummaryEntity
     */
    'horizontalAccuracy'?: number;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataSummaryEntity
     */
    'lastChangeDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataSummaryEntity
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataSummaryEntity
     */
    'meets3dep'?: number;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataSummaryEntity
     */
    'meets3depLc'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataSummaryEntity
     */
    'metadataUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataSummaryEntity
     */
    'pixelSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataSummaryEntity
     */
    'projection'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataSummaryEntity
     */
    'qualityLevel3dep'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataSummaryEntity
     */
    'reasonDataDoesordoesNotMeet2dep'?: string;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataSummaryEntity
     */
    'verticalAccuracy'?: number;
}
/**
 * 
 * @export
 * @interface DemMetadataSummaryRequest
 */
export interface DemMetadataSummaryRequest {
    /**
     * 
     * @type {number}
     * @memberof DemMetadataSummaryRequest
     */
    'acquisitionDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataSummaryRequest
     */
    'browseUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataSummaryRequest
     */
    'collectionDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataSummaryRequest
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataSummaryRequest
     */
    'demMetadataSummaryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataSummaryRequest
     */
    'demResolution'?: number;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataSummaryRequest
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataSummaryRequest
     */
    'elevationUnit'?: string;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataSummaryRequest
     */
    'horizontalAccuracy'?: number;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataSummaryRequest
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataSummaryRequest
     */
    'meets3dep'?: number;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataSummaryRequest
     */
    'meets3depLc'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataSummaryRequest
     */
    'metadataUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataSummaryRequest
     */
    'pixelSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataSummaryRequest
     */
    'projection'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataSummaryRequest
     */
    'qualityLevel3dep'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemMetadataSummaryRequest
     */
    'reasonDataDoesordoesNotMeet2dep'?: string;
    /**
     * 
     * @type {number}
     * @memberof DemMetadataSummaryRequest
     */
    'verticalAccuracy'?: number;
}
/**
 * 
 * @export
 * @interface EditProjectSummaryResponseDto
 */
export interface EditProjectSummaryResponseDto {
    /**
     * 
     * @type {string}
     * @memberof EditProjectSummaryResponseDto
     */
    'clientName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditProjectSummaryResponseDto
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditProjectSummaryResponseDto
     */
    'designBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof EditProjectSummaryResponseDto
     */
    'jobClass'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditProjectSummaryResponseDto
     */
    'lastChangeDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof EditProjectSummaryResponseDto
     */
    'projectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditProjectSummaryResponseDto
     */
    'projectOwner'?: string;
    /**
     * 
     * @type {number}
     * @memberof EditProjectSummaryResponseDto
     */
    'projectStatus'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditProjectSummaryResponseDto
     */
    'projectType'?: number;
    /**
     * 
     * @type {string}
     * @memberof EditProjectSummaryResponseDto
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditProjectSummaryResponseDto
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditProjectSummaryResponseDto
     */
    'updateStatus'?: string;
}
/**
 * 
 * @export
 * @interface EftAddSessionResourceRequest
 */
export interface EftAddSessionResourceRequest {
    /**
     * 
     * @type {string}
     * @memberof EftAddSessionResourceRequest
     */
    'currentUser'?: string;
    /**
     * 
     * @type {Array<EftSessionResourceDto>}
     * @memberof EftAddSessionResourceRequest
     */
    'sessionResources'?: Array<EftSessionResourceDto>;
    /**
     * 
     * @type {string}
     * @memberof EftAddSessionResourceRequest
     */
    'sessionUuid'?: string;
}
/**
 * 
 * @export
 * @interface EftAddSessionResourceResponse
 */
export interface EftAddSessionResourceResponse {
    /**
     * 
     * @type {Array<EftSessionResourceResponseDto>}
     * @memberof EftAddSessionResourceResponse
     */
    'eftSessionResourceResponseDtoList'?: Array<EftSessionResourceResponseDto>;
    /**
     * 
     * @type {string}
     * @memberof EftAddSessionResourceResponse
     */
    'sessionUuid'?: string;
}
/**
 * 
 * @export
 * @interface EftCreateProjectDto
 */
export interface EftCreateProjectDto {
    /**
     * 
     * @type {string}
     * @memberof EftCreateProjectDto
     */
    'client'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftCreateProjectDto
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftCreateProjectDto
     */
    'currentUser'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftCreateProjectDto
     */
    'practice'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftCreateProjectDto
     */
    'projectClassId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftCreateProjectDto
     */
    'projectTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftCreateProjectDto
     */
    'state'?: string;
}
/**
 * 
 * @export
 * @interface EftGetProjectReponseDto
 */
export interface EftGetProjectReponseDto {
    /**
     * 
     * @type {string}
     * @memberof EftGetProjectReponseDto
     */
    'client'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftGetProjectReponseDto
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftGetProjectReponseDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftGetProjectReponseDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftGetProjectReponseDto
     */
    'designedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftGetProjectReponseDto
     */
    'jobClass'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftGetProjectReponseDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftGetProjectReponseDto
     */
    'lastChangedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftGetProjectReponseDto
     */
    'practice'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftGetProjectReponseDto
     */
    'projectClassId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftGetProjectReponseDto
     */
    'projectClassType'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftGetProjectReponseDto
     */
    'projectOwnerFirstName'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftGetProjectReponseDto
     */
    'projectOwnerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftGetProjectReponseDto
     */
    'projectOwnerLastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftGetProjectReponseDto
     */
    'projectStatus'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftGetProjectReponseDto
     */
    'projectStatusId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftGetProjectReponseDto
     */
    'projectTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftGetProjectReponseDto
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftGetProjectReponseDto
     */
    'projectionText'?: string;
    /**
     * 
     * @type {Array<EftSessionResponseDto>}
     * @memberof EftGetProjectReponseDto
     */
    'sessionList'?: Array<EftSessionResponseDto>;
    /**
     * 
     * @type {string}
     * @memberof EftGetProjectReponseDto
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftGetProjectReponseDto
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface EftProjUserInputDto
 */
export interface EftProjUserInputDto {
    /**
     * 
     * @type {AlignedElementUiStateDto}
     * @memberof EftProjUserInputDto
     */
    'alignedElementUiStateDto'?: AlignedElementUiStateDto;
    /**
     * 
     * @type {string}
     * @memberof EftProjUserInputDto
     */
    'errorCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftProjUserInputDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftProjUserInputDto
     */
    'sessionUiStateValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjUserInputDto
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjUserInputDto
     */
    'uiStateType'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjUserInputDto
     */
    'userId'?: string;
}
/**
 * 
 * @export
 * @interface EftProject
 */
export interface EftProject {
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'aoiImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'client'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'creationDate'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EftProject
     */
    'deletedFlag'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'designedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'duhName'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'jobClassId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'lastChangeDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'parentProjectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'practice'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'practices'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'projectClassId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'projectOwnerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'projectStatusDateUtc'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'projectStatusTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'projectStatusUpdatedBy'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'projectTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'projectionText'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'rdtSmoothing'?: string;
    /**
     * 
     * @type {Array<EftSession>}
     * @memberof EftProject
     */
    'sessions'?: Array<EftSession>;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'srid'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'userInputNotes'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'xMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'xMin'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'yMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'yMin'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'zUnits'?: number;
}
/**
 * 
 * @export
 * @interface EftProjectCountDto
 */
export interface EftProjectCountDto {
    /**
     * 
     * @type {number}
     * @memberof EftProjectCountDto
     */
    'coreUserId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProjectCountDto
     */
    'projectCount'?: number;
}
/**
 * 
 * @export
 * @interface EftProjectEditDto
 */
export interface EftProjectEditDto {
    /**
     * 
     * @type {string}
     * @memberof EftProjectEditDto
     */
    'clientName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjectEditDto
     */
    'designBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftProjectEditDto
     */
    'jobClass'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftProjectEditDto
     */
    'projectName'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftProjectEditDto
     */
    'projectStatus'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftProjectEditDto
     */
    'projectUuid'?: string;
}
/**
 * 
 * @export
 * @interface EftProjectEditResponseDto
 */
export interface EftProjectEditResponseDto {
    /**
     * 
     * @type {string}
     * @memberof EftProjectEditResponseDto
     */
    'clientName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjectEditResponseDto
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjectEditResponseDto
     */
    'designBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftProjectEditResponseDto
     */
    'jobClass'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftProjectEditResponseDto
     */
    'projectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjectEditResponseDto
     */
    'projectOwner'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftProjectEditResponseDto
     */
    'projectStatus'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProjectEditResponseDto
     */
    'projectType'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftProjectEditResponseDto
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {Array<EftSessionResponseDto>}
     * @memberof EftProjectEditResponseDto
     */
    'sessionList'?: Array<EftSessionResponseDto>;
    /**
     * 
     * @type {string}
     * @memberof EftProjectEditResponseDto
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjectEditResponseDto
     */
    'updateStatus'?: string;
}
/**
 * 
 * @export
 * @interface EftProjectProjectionTextDto
 */
export interface EftProjectProjectionTextDto {
    /**
     * 
     * @type {string}
     * @memberof EftProjectProjectionTextDto
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjectProjectionTextDto
     */
    'projectionText'?: string;
}
/**
 * 
 * @export
 * @interface EftProjectStateCountyProjectDto
 */
export interface EftProjectStateCountyProjectDto {
    /**
     * 
     * @type {number}
     * @memberof EftProjectStateCountyProjectDto
     */
    'latY'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProjectStateCountyProjectDto
     */
    'lonX'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProjectStateCountyProjectDto
     */
    'projectClassId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftProjectStateCountyProjectDto
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjectStateCountyProjectDto
     */
    'projectionText'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftProjectStateCountyProjectDto
     */
    'rainfallCellId'?: number;
}
/**
 * 
 * @export
 * @interface EftProjectUpdateDto
 */
export interface EftProjectUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof EftProjectUpdateDto
     */
    'client'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjectUpdateDto
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjectUpdateDto
     */
    'duhName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjectUpdateDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjectUpdateDto
     */
    'practice'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftProjectUpdateDto
     */
    'projectClassId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProjectUpdateDto
     */
    'projectStatusTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftProjectUpdateDto
     */
    'projectTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjectUpdateDto
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjectUpdateDto
     */
    'rdtSmoothing'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftProjectUpdateDto
     */
    'srid'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftProjectUpdateDto
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjectUpdateDto
     */
    'userInputNotes'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftProjectUpdateDto
     */
    'xmax'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProjectUpdateDto
     */
    'xmin'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProjectUpdateDto
     */
    'ymax'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProjectUpdateDto
     */
    'ymin'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProjectUpdateDto
     */
    'zUnits'?: number;
}
/**
 * 
 * @export
 * @interface EftProjectUpdateOwnerReqDto
 */
export interface EftProjectUpdateOwnerReqDto {
    /**
     * 
     * @type {number}
     * @memberof EftProjectUpdateOwnerReqDto
     */
    'coreUserId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof EftProjectUpdateOwnerReqDto
     */
    'projectUuidList'?: Array<string>;
}
/**
 * 
 * @export
 * @interface EftProjectUpdateResponseDto
 */
export interface EftProjectUpdateResponseDto {
    /**
     * 
     * @type {string}
     * @memberof EftProjectUpdateResponseDto
     */
    'client'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjectUpdateResponseDto
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjectUpdateResponseDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjectUpdateResponseDto
     */
    'practice'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftProjectUpdateResponseDto
     */
    'projectClassId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftProjectUpdateResponseDto
     */
    'projectTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjectUpdateResponseDto
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {Array<EftSessionResponseDto>}
     * @memberof EftProjectUpdateResponseDto
     */
    'sessionList'?: Array<EftSessionResponseDto>;
    /**
     * 
     * @type {string}
     * @memberof EftProjectUpdateResponseDto
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjectUpdateResponseDto
     */
    'updateStatus'?: string;
}
/**
 * 
 * @export
 * @interface EftProjectUserInputNotesDTO
 */
export interface EftProjectUserInputNotesDTO {
    /**
     * 
     * @type {string}
     * @memberof EftProjectUserInputNotesDTO
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProjectUserInputNotesDTO
     */
    'userInputNotes'?: string;
}
/**
 * 
 * @export
 * @interface EftSession
 */
export interface EftSession {
    /**
     * 
     * @type {string}
     * @memberof EftSession
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftSession
     */
    'creationDate'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EftSession
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EftSession
     */
    'lastChangeDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftSession
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {EftProject}
     * @memberof EftSession
     */
    'project'?: EftProject;
    /**
     * 
     * @type {Array<EftSessionResource>}
     * @memberof EftSession
     */
    'sessionResources'?: Array<EftSessionResource>;
    /**
     * 
     * @type {string}
     * @memberof EftSession
     */
    'sessionTitle'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftSession
     */
    'sessionTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftSession
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftSession
     */
    'stepCodeId'?: number;
    /**
     * 
     * @type {Array<SurfaceDef>}
     * @memberof EftSession
     */
    'surfaceDefs'?: Array<SurfaceDef>;
}
/**
 * 
 * @export
 * @interface EftSessionResource
 */
export interface EftSessionResource {
    /**
     * 
     * @type {string}
     * @memberof EftSessionResource
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftSessionResource
     */
    'creationDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResource
     */
    'dataSourceType'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EftSessionResource
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResource
     */
    'horizontalMeasurementUnit'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftSessionResource
     */
    'lastChangeDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResource
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResource
     */
    'metadata'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftSessionResource
     */
    'pixelSize'?: number;
    /**
     * 
     * @type {EftSession}
     * @memberof EftSessionResource
     */
    'session'?: EftSession;
    /**
     * 
     * @type {number}
     * @memberof EftSessionResource
     */
    'sessionResourceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftSessionResource
     */
    'sessionResourceTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResource
     */
    'sessionResourceValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResource
     */
    'verticalMeasurementUnit'?: string;
}
/**
 * 
 * @export
 * @interface EftSessionResourceDto
 */
export interface EftSessionResourceDto {
    /**
     * 
     * @type {number}
     * @memberof EftSessionResourceDto
     */
    'sessionResourceTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResourceDto
     */
    'sessionResourceValue'?: string;
}
/**
 * 
 * @export
 * @interface EftSessionResourceResponseDto
 */
export interface EftSessionResourceResponseDto {
    /**
     * 
     * @type {string}
     * @memberof EftSessionResourceResponseDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftSessionResourceResponseDto
     */
    'creationDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResourceResponseDto
     */
    'dataSourceType'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EftSessionResourceResponseDto
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResourceResponseDto
     */
    'elevationUnit'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftSessionResourceResponseDto
     */
    'lastChangeDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResourceResponseDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResourceResponseDto
     */
    'linearUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResourceResponseDto
     */
    'metadata'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftSessionResourceResponseDto
     */
    'pixelSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftSessionResourceResponseDto
     */
    'sessionResourceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftSessionResourceResponseDto
     */
    'sessionResourceTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResourceResponseDto
     */
    'sessionResourceValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResourceResponseDto
     */
    'sessionUuid'?: string;
}
/**
 * 
 * @export
 * @interface EftSessionResponseDto
 */
export interface EftSessionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof EftSessionResponseDto
     */
    'sessionTitle'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftSessionResponseDto
     */
    'sessionTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResponseDto
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResponseDto
     */
    'stepCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftSessionResponseDto
     */
    'stepCodeId'?: number;
}
/**
 * 
 * @export
 * @interface EftStatusResponse
 */
export interface EftStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof EftStatusResponse
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'errorType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'urlPath'?: string;
}
/**
 * 
 * @export
 * @interface FeatureFlagEntity
 */
export interface FeatureFlagEntity {
    /**
     * 
     * @type {number}
     * @memberof FeatureFlagEntity
     */
    'applicationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FeatureFlagEntity
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof FeatureFlagEntity
     */
    'createdDateTimeUtc'?: number;
    /**
     * 
     * @type {number}
     * @memberof FeatureFlagEntity
     */
    'effectiveVersion'?: number;
    /**
     * 
     * @type {number}
     * @memberof FeatureFlagEntity
     */
    'environmentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FeatureFlagEntity
     */
    'flagDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof FeatureFlagEntity
     */
    'flagId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FeatureFlagEntity
     */
    'flagKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureFlagEntity
     */
    'flagName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureFlagEntity
     */
    'flagValue'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FeatureFlagEntity
     */
    'flagValueId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FeatureFlagEntity
     */
    'modifiedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof FeatureFlagEntity
     */
    'modifiedDateTimeUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof FeatureFlagEntity
     */
    'netsWrapperStatusMessage'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureFlagEntity
     */
    'test'?: boolean;
}
/**
 * 
 * @export
 * @interface FlagDto
 */
export interface FlagDto {
    /**
     * 
     * @type {number}
     * @memberof FlagDto
     */
    'errorCode'?: number;
    /**
     * 
     * @type {Array<FlagResult>}
     * @memberof FlagDto
     */
    'result'?: Array<FlagResult>;
}
/**
 * 
 * @export
 * @interface FlagRequest
 */
export interface FlagRequest {
    /**
     * 
     * @type {string}
     * @memberof FlagRequest
     */
    'appId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlagRequest
     */
    'appVersion'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlagRequest
     */
    'environment'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlagRequest
     */
    'isTest'?: string;
}
/**
 * 
 * @export
 * @interface FlagResult
 */
export interface FlagResult {
    /**
     * 
     * @type {string}
     * @memberof FlagResult
     */
    'keyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlagResult
     */
    'keyValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlagResult
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface GlossaryCategorySummaryDto
 */
export interface GlossaryCategorySummaryDto {
    /**
     * 
     * @type {string}
     * @memberof GlossaryCategorySummaryDto
     */
    'categoryName'?: string;
    /**
     * 
     * @type {number}
     * @memberof GlossaryCategorySummaryDto
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface GlossaryHelpValidationDto
 */
export interface GlossaryHelpValidationDto {
    /**
     * 
     * @type {Array<GlossaryValidationDto>}
     * @memberof GlossaryHelpValidationDto
     */
    'invalidLinkList'?: Array<GlossaryValidationDto>;
    /**
     * 
     * @type {Array<GlossaryValidationDto>}
     * @memberof GlossaryHelpValidationDto
     */
    'validLinkList'?: Array<GlossaryValidationDto>;
}
/**
 * 
 * @export
 * @interface GlossaryLinkRequestDto
 */
export interface GlossaryLinkRequestDto {
    /**
     * 
     * @type {boolean}
     * @memberof GlossaryLinkRequestDto
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GlossaryLinkRequestDto
     */
    'glossaryLink'?: string;
    /**
     * 
     * @type {string}
     * @memberof GlossaryLinkRequestDto
     */
    'glossaryLinkDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof GlossaryLinkRequestDto
     */
    'glossaryLinkId'?: number;
}
/**
 * 
 * @export
 * @interface GlossaryLinkResponseDto
 */
export interface GlossaryLinkResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GlossaryLinkResponseDto
     */
    'glossaryLink'?: string;
    /**
     * 
     * @type {string}
     * @memberof GlossaryLinkResponseDto
     */
    'glossaryLinkDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof GlossaryLinkResponseDto
     */
    'glossaryLinkd'?: number;
}
/**
 * 
 * @export
 * @interface GlossaryRequestDto
 */
export interface GlossaryRequestDto {
    /**
     * 
     * @type {string}
     * @memberof GlossaryRequestDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GlossaryRequestDto
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GlossaryRequestDto
     */
    'glossaryCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof GlossaryRequestDto
     */
    'glossaryDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof GlossaryRequestDto
     */
    'glossaryId'?: number;
    /**
     * 
     * @type {Array<GlossaryLinkRequestDto>}
     * @memberof GlossaryRequestDto
     */
    'glossaryLinkRequestDto'?: Array<GlossaryLinkRequestDto>;
    /**
     * 
     * @type {string}
     * @memberof GlossaryRequestDto
     */
    'glossaryTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof GlossaryRequestDto
     */
    'titleChar'?: string;
}
/**
 * 
 * @export
 * @interface GlossaryResponseDto
 */
export interface GlossaryResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GlossaryResponseDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GlossaryResponseDto
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GlossaryResponseDto
     */
    'glossaryCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof GlossaryResponseDto
     */
    'glossaryDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof GlossaryResponseDto
     */
    'glossaryId'?: number;
    /**
     * 
     * @type {Array<GlossaryLinkResponseDto>}
     * @memberof GlossaryResponseDto
     */
    'glossaryLinkResponseDto'?: Array<GlossaryLinkResponseDto>;
    /**
     * 
     * @type {string}
     * @memberof GlossaryResponseDto
     */
    'glossaryTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof GlossaryResponseDto
     */
    'titleChar'?: string;
}
/**
 * 
 * @export
 * @interface GlossaryValidationDto
 */
export interface GlossaryValidationDto {
    /**
     * 
     * @type {string}
     * @memberof GlossaryValidationDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof GlossaryValidationDto
     */
    'creationDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof GlossaryValidationDto
     */
    'glossaryLink'?: string;
    /**
     * 
     * @type {string}
     * @memberof GlossaryValidationDto
     */
    'glossaryLinkDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof GlossaryValidationDto
     */
    'glossaryLinkId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GlossaryValidationDto
     */
    'lastChangeDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof GlossaryValidationDto
     */
    'lastChangedBy'?: string;
}
/**
 * 
 * @export
 * @interface HealthCheckResponse
 */
export interface HealthCheckResponse {
    /**
     * 
     * @type {string}
     * @memberof HealthCheckResponse
     */
    'environment'?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthCheckResponse
     */
    'overallStatus'?: string;
    /**
     * 
     * @type {{ [key: string]: ServiceStatus; }}
     * @memberof HealthCheckResponse
     */
    'services'?: { [key: string]: ServiceStatus; };
    /**
     * 
     * @type {string}
     * @memberof HealthCheckResponse
     */
    'timestamp'?: string;
}
/**
 * 
 * @export
 * @interface HydroProjectMetadataReqDTO
 */
export interface HydroProjectMetadataReqDTO {
    /**
     * 
     * @type {number}
     * @memberof HydroProjectMetadataReqDTO
     */
    'frequencyInYrs'?: number;
    /**
     * 
     * @type {string}
     * @memberof HydroProjectMetadataReqDTO
     */
    'projectUuid'?: string;
}
/**
 * 
 * @export
 * @interface HydroProjectMetadataRespDTO
 */
export interface HydroProjectMetadataRespDTO {
    /**
     * 
     * @type {string}
     * @memberof HydroProjectMetadataRespDTO
     */
    'county'?: string;
    /**
     * 
     * @type {number}
     * @memberof HydroProjectMetadataRespDTO
     */
    'drainageArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof HydroProjectMetadataRespDTO
     */
    'frequencyInYrs'?: number;
    /**
     * 
     * @type {string}
     * @memberof HydroProjectMetadataRespDTO
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydroProjectMetadataRespDTO
     */
    'lastChangedDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof HydroProjectMetadataRespDTO
     */
    'peakFlow'?: number;
    /**
     * 
     * @type {string}
     * @memberof HydroProjectMetadataRespDTO
     */
    'projectOwner'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydroProjectMetadataRespDTO
     */
    'projectStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydroProjectMetadataRespDTO
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof HydroProjectMetadataRespDTO
     */
    'runOff'?: number;
    /**
     * 
     * @type {string}
     * @memberof HydroProjectMetadataRespDTO
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydroProjectMetadataRespDTO
     */
    'waterShedUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof HydroProjectMetadataRespDTO
     */
    'watershedCentroid'?: number;
    /**
     * 
     * @type {number}
     * @memberof HydroProjectMetadataRespDTO
     */
    'watershedLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof HydroProjectMetadataRespDTO
     */
    'watershedSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof HydroProjectMetadataRespDTO
     */
    'weightedCurveNumber'?: number;
}
/**
 * 
 * @export
 * @interface HydroUserInputsDto
 */
export interface HydroUserInputsDto {
    /**
     * 
     * @type {string}
     * @memberof HydroUserInputsDto
     */
    'duhName'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydroUserInputsDto
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydroUserInputsDto
     */
    'rdtSmoothing'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydroUserInputsDto
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydroUserInputsDto
     */
    'userInputNotes'?: string;
}
/**
 * 
 * @export
 * @interface LandLevelingDto
 */
export interface LandLevelingDto {
    /**
     * 
     * @type {number}
     * @memberof LandLevelingDto
     */
    'llStakeoutGrid'?: number;
}
/**
 * 
 * @export
 * @interface LoggerRequestDTO
 */
export interface LoggerRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof LoggerRequestDTO
     */
    'appName'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoggerRequestDTO
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoggerRequestDTO
     */
    'gpSessionUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoggerRequestDTO
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoggerRequestDTO
     */
    'shortDescription'?: string;
}
/**
 * 
 * @export
 * @interface MetaDataDto
 */
export interface MetaDataDto {
    /**
     * 
     * @type {string}
     * @memberof MetaDataDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof MetaDataDto
     */
    'creationDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof MetaDataDto
     */
    'dataOwner'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaDataDto
     */
    'dataOwnerContact'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaDataDto
     */
    'dataPublicationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaDataDto
     */
    'dataSource'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaDataDto
     */
    'dataType'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaDataDto
     */
    'deleted'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaDataDto
     */
    'elevationUnits'?: string;
    /**
     * 
     * @type {number}
     * @memberof MetaDataDto
     */
    'lastChangeDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof MetaDataDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaDataDto
     */
    'lastLoadedDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof MetaDataDto
     */
    'metadataId'?: number;
    /**
     * 
     * @type {string}
     * @memberof MetaDataDto
     */
    'projection'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaDataDto
     */
    'refreshFrequency'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaDataDto
     */
    'resolution'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaDataDto
     */
    'scale'?: string;
}
/**
 * 
 * @export
 * @interface NetsPreferenceDto
 */
export interface NetsPreferenceDto {
    /**
     * 
     * @type {string}
     * @memberof NetsPreferenceDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof NetsPreferenceDto
     */
    'creationDateUtc'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NetsPreferenceDto
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NetsPreferenceDto
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetsPreferenceDto
     */
    'lastChangeDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof NetsPreferenceDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof NetsPreferenceDto
     */
    'netsPreferenceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetsPreferenceDto
     */
    'ownerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetsPreferenceDto
     */
    'preferenceKeyTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetsPreferenceDto
     */
    'preferenceScopeTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetsPreferenceDto
     */
    'preferenceTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof NetsPreferenceDto
     */
    'preferenceValueJson'?: string;
    /**
     * 
     * @type {number}
     * @memberof NetsPreferenceDto
     */
    'projectTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof NetsPreferenceDto
     */
    'stateCode'?: string;
}
/**
 * 
 * @export
 * @interface OffsetStation
 */
export interface OffsetStation {
    /**
     * 
     * @type {Alignment}
     * @memberof OffsetStation
     */
    'alignment'?: Alignment;
    /**
     * 
     * @type {string}
     * @memberof OffsetStation
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof OffsetStation
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof OffsetStation
     */
    'entryMode'?: string;
    /**
     * 
     * @type {number}
     * @memberof OffsetStation
     */
    'hiElevation'?: number;
    /**
     * 
     * @type {string}
     * @memberof OffsetStation
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof OffsetStation
     */
    'offsetStationId'?: number;
    /**
     * 
     * @type {Array<OffsetStationOffset>}
     * @memberof OffsetStation
     */
    'offsetStationOffsets'?: Array<OffsetStationOffset>;
    /**
     * 
     * @type {string}
     * @memberof OffsetStation
     */
    'offsetType'?: string;
    /**
     * 
     * @type {number}
     * @memberof OffsetStation
     */
    'stationDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof OffsetStation
     */
    'stationStep'?: number;
    /**
     * 
     * @type {number}
     * @memberof OffsetStation
     */
    'tangentAzimuth'?: number;
    /**
     * 
     * @type {number}
     * @memberof OffsetStation
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof OffsetStation
     */
    'y'?: number;
}
/**
 * 
 * @export
 * @interface OffsetStationOffset
 */
export interface OffsetStationOffset {
    /**
     * 
     * @type {string}
     * @memberof OffsetStationOffset
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof OffsetStationOffset
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof OffsetStationOffset
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof OffsetStationOffset
     */
    'offsetDistance'?: number;
    /**
     * 
     * @type {OffsetStation}
     * @memberof OffsetStationOffset
     */
    'offsetStation'?: OffsetStation;
    /**
     * 
     * @type {number}
     * @memberof OffsetStationOffset
     */
    'offsetStationOffsetID'?: number;
    /**
     * 
     * @type {number}
     * @memberof OffsetStationOffset
     */
    'offsetStationOffsetId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OffsetStationOffset
     */
    'z'?: number;
}
/**
 * 
 * @export
 * @interface PreferenceTypeValueDto
 */
export interface PreferenceTypeValueDto {
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof PreferenceTypeValueDto
     */
    'general'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof PreferenceTypeValueDto
     */
    'landLeveling'?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof PreferenceTypeValueDto
     */
    'layer_visibilities'?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ProjectAttachmentDto
 */
export interface ProjectAttachmentDto {
    /**
     * 
     * @type {string}
     * @memberof ProjectAttachmentDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectAttachmentDto
     */
    'projectFileExt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectAttachmentDto
     */
    'projectFileName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectAttachmentDto
     */
    'projectMimeTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectAttachmentDto
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectAttachmentDto
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface ProjectCommentRequest
 */
export interface ProjectCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof ProjectCommentRequest
     */
    'commentAuthor'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectCommentRequest
     */
    'commentTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectCommentRequest
     */
    'editStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCommentRequest
     */
    'projectComment'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCommentRequest
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCommentRequest
     */
    'workflowStep'?: string;
}
/**
 * 
 * @export
 * @interface ProjectCommentResponse
 */
export interface ProjectCommentResponse {
    /**
     * 
     * @type {string}
     * @memberof ProjectCommentResponse
     */
    'commentAuthor'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectCommentResponse
     */
    'commentTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectCommentResponse
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCommentResponse
     */
    'creationDateUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCommentResponse
     */
    'editStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCommentResponse
     */
    'lastChangeDateUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCommentResponse
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCommentResponse
     */
    'projectComment'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectCommentResponse
     */
    'projectCommentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectCommentResponse
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCommentResponse
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCommentResponse
     */
    'workflowStep'?: string;
}
/**
 * 
 * @export
 * @interface ProjectCommentsDeleteRequest
 */
export interface ProjectCommentsDeleteRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ProjectCommentsDeleteRequest
     */
    'projectCommentIdList'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof ProjectCommentsDeleteRequest
     */
    'projectUuid'?: string;
}
/**
 * 
 * @export
 * @interface ProjectElementCommentRequest
 */
export interface ProjectElementCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof ProjectElementCommentRequest
     */
    'commentAuthor'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectElementCommentRequest
     */
    'commentTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectElementCommentRequest
     */
    'designElementId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectElementCommentRequest
     */
    'designTypeAndStructureName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectElementCommentRequest
     */
    'editStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectElementCommentRequest
     */
    'projectComment'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectElementCommentRequest
     */
    'projectUuid'?: string;
}
/**
 * 
 * @export
 * @interface ProjectElementCommentResponse
 */
export interface ProjectElementCommentResponse {
    /**
     * 
     * @type {string}
     * @memberof ProjectElementCommentResponse
     */
    'commentAuthor'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectElementCommentResponse
     */
    'commentTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectElementCommentResponse
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectElementCommentResponse
     */
    'creationDateUtc'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectElementCommentResponse
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProjectElementCommentResponse
     */
    'designElementId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectElementCommentResponse
     */
    'designTypeAndStructureName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectElementCommentResponse
     */
    'editStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectElementCommentResponse
     */
    'lastChangeDateUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectElementCommentResponse
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectElementCommentResponse
     */
    'projectComment'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectElementCommentResponse
     */
    'projectElementCommentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectElementCommentResponse
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectElementCommentResponse
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface ProjectElementCommentsDeleteRequest
 */
export interface ProjectElementCommentsDeleteRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ProjectElementCommentsDeleteRequest
     */
    'projectElementCommentIdList'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof ProjectElementCommentsDeleteRequest
     */
    'projectUuid'?: string;
}
/**
 * 
 * @export
 * @interface ProjectStatusLogRequestDTO
 */
export interface ProjectStatusLogRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof ProjectStatusLogRequestDTO
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectStatusLogRequestDTO
     */
    'projectStatusBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectStatusLogRequestDTO
     */
    'projectStatusTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectStatusLogRequestDTO
     */
    'projectUuid'?: string;
}
/**
 * 
 * @export
 * @interface ProjectStatusLogResponseDTO
 */
export interface ProjectStatusLogResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof ProjectStatusLogResponseDTO
     */
    'creationDateUtc'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectStatusLogResponseDTO
     */
    'deleted'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectStatusLogResponseDTO
     */
    'lastChangeDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectStatusLogResponseDTO
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectStatusLogResponseDTO
     */
    'projectStatusBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectStatusLogResponseDTO
     */
    'projectStatusLogId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectStatusLogResponseDTO
     */
    'projectStatusTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectStatusLogResponseDTO
     */
    'projectUuid'?: string;
}
/**
 * 
 * @export
 * @interface ProjectionMetadataCustomizedRequestDto
 */
export interface ProjectionMetadataCustomizedRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ProjectionMetadataCustomizedRequestDto
     */
    'coordinateType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionMetadataCustomizedRequestDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionMetadataCustomizedRequestDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectionMetadataCustomizedRequestDto
     */
    'projectionMetadataCustomizedId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectionMetadataCustomizedRequestDto
     */
    'projectionName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionMetadataCustomizedRequestDto
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionMetadataCustomizedRequestDto
     */
    'wktJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionMetadataCustomizedRequestDto
     */
    'zone'?: string;
}
/**
 * 
 * @export
 * @interface ProjectionMetadataCustomizedResponseDto
 */
export interface ProjectionMetadataCustomizedResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ProjectionMetadataCustomizedResponseDto
     */
    'coordinateType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionMetadataCustomizedResponseDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectionMetadataCustomizedResponseDto
     */
    'creationDateUtc'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectionMetadataCustomizedResponseDto
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProjectionMetadataCustomizedResponseDto
     */
    'lastChangeDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectionMetadataCustomizedResponseDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectionMetadataCustomizedResponseDto
     */
    'projectionMetadataCustomizedId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectionMetadataCustomizedResponseDto
     */
    'projectionName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionMetadataCustomizedResponseDto
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionMetadataCustomizedResponseDto
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionMetadataCustomizedResponseDto
     */
    'wktJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionMetadataCustomizedResponseDto
     */
    'zone'?: string;
}
/**
 * 
 * @export
 * @interface ProjectionMetadataReqDto
 */
export interface ProjectionMetadataReqDto {
    /**
     * 
     * @type {number}
     * @memberof ProjectionMetadataReqDto
     */
    'centroidX'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectionMetadataReqDto
     */
    'centroidY'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectionMetadataReqDto
     */
    'coordinateType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionMetadataReqDto
     */
    'state'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectionMetadataReqDto
     */
    'xmax'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectionMetadataReqDto
     */
    'xmin'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectionMetadataReqDto
     */
    'ymax'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectionMetadataReqDto
     */
    'ymin'?: number;
}
/**
 * 
 * @export
 * @interface ProjectionMetadataRespDto
 */
export interface ProjectionMetadataRespDto {
    /**
     * 
     * @type {number}
     * @memberof ProjectionMetadataRespDto
     */
    'epsgCode'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectionMetadataRespDto
     */
    'esriWkid'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectionMetadataRespDto
     */
    'projectionName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionMetadataRespDto
     */
    'warningMsg'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectionMetadataRespDto
     */
    'zoneName'?: string;
}
/**
 * 
 * @export
 * @interface ProjectsWithCount
 */
export interface ProjectsWithCount {
    /**
     * 
     * @type {number}
     * @memberof ProjectsWithCount
     */
    'coreUserId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectsWithCount
     */
    'projectCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectsWithCount
     */
    'userEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectsWithCount
     */
    'userName'?: string;
}
/**
 * 
 * @export
 * @interface ReleaseNoteDto
 */
export interface ReleaseNoteDto {
    /**
     * 
     * @type {string}
     * @memberof ReleaseNoteDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReleaseNoteDto
     */
    'creationDateUtc'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReleaseNoteDto
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReleaseNoteDto
     */
    'lastChangeDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReleaseNoteDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseNoteDto
     */
    'releaseDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseNoteDto
     */
    'releaseDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReleaseNoteDto
     */
    'releaseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReleaseNoteDto
     */
    'releaseTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseNoteDto
     */
    'releaseVersion'?: string;
}
/**
 * 
 * @export
 * @interface ResponseEntity
 */
export interface ResponseEntity {
    /**
     * 
     * @type {object}
     * @memberof ResponseEntity
     */
    'body'?: object;
    /**
     * 
     * @type {string}
     * @memberof ResponseEntity
     */
    'statusCode'?: ResponseEntityStatusCodeEnum;
    /**
     * 
     * @type {number}
     * @memberof ResponseEntity
     */
    'statusCodeValue'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum ResponseEntityStatusCodeEnum {
    _100Continue = '100 CONTINUE',
    _101SwitchingProtocols = '101 SWITCHING_PROTOCOLS',
    _102Processing = '102 PROCESSING',
    _103Checkpoint = '103 CHECKPOINT',
    _200Ok = '200 OK',
    _201Created = '201 CREATED',
    _202Accepted = '202 ACCEPTED',
    _203NonAuthoritativeInformation = '203 NON_AUTHORITATIVE_INFORMATION',
    _204NoContent = '204 NO_CONTENT',
    _205ResetContent = '205 RESET_CONTENT',
    _206PartialContent = '206 PARTIAL_CONTENT',
    _207MultiStatus = '207 MULTI_STATUS',
    _208AlreadyReported = '208 ALREADY_REPORTED',
    _226ImUsed = '226 IM_USED',
    _300MultipleChoices = '300 MULTIPLE_CHOICES',
    _301MovedPermanently = '301 MOVED_PERMANENTLY',
    _302Found = '302 FOUND',
    _302MovedTemporarily = '302 MOVED_TEMPORARILY',
    _303SeeOther = '303 SEE_OTHER',
    _304NotModified = '304 NOT_MODIFIED',
    _305UseProxy = '305 USE_PROXY',
    _307TemporaryRedirect = '307 TEMPORARY_REDIRECT',
    _308PermanentRedirect = '308 PERMANENT_REDIRECT',
    _400BadRequest = '400 BAD_REQUEST',
    _401Unauthorized = '401 UNAUTHORIZED',
    _402PaymentRequired = '402 PAYMENT_REQUIRED',
    _403Forbidden = '403 FORBIDDEN',
    _404NotFound = '404 NOT_FOUND',
    _405MethodNotAllowed = '405 METHOD_NOT_ALLOWED',
    _406NotAcceptable = '406 NOT_ACCEPTABLE',
    _407ProxyAuthenticationRequired = '407 PROXY_AUTHENTICATION_REQUIRED',
    _408RequestTimeout = '408 REQUEST_TIMEOUT',
    _409Conflict = '409 CONFLICT',
    _410Gone = '410 GONE',
    _411LengthRequired = '411 LENGTH_REQUIRED',
    _412PreconditionFailed = '412 PRECONDITION_FAILED',
    _413PayloadTooLarge = '413 PAYLOAD_TOO_LARGE',
    _413RequestEntityTooLarge = '413 REQUEST_ENTITY_TOO_LARGE',
    _414UriTooLong = '414 URI_TOO_LONG',
    _414RequestUriTooLong = '414 REQUEST_URI_TOO_LONG',
    _415UnsupportedMediaType = '415 UNSUPPORTED_MEDIA_TYPE',
    _416RequestedRangeNotSatisfiable = '416 REQUESTED_RANGE_NOT_SATISFIABLE',
    _417ExpectationFailed = '417 EXPECTATION_FAILED',
    _418IAmATeapot = '418 I_AM_A_TEAPOT',
    _419InsufficientSpaceOnResource = '419 INSUFFICIENT_SPACE_ON_RESOURCE',
    _420MethodFailure = '420 METHOD_FAILURE',
    _421DestinationLocked = '421 DESTINATION_LOCKED',
    _422UnprocessableEntity = '422 UNPROCESSABLE_ENTITY',
    _423Locked = '423 LOCKED',
    _424FailedDependency = '424 FAILED_DEPENDENCY',
    _425TooEarly = '425 TOO_EARLY',
    _426UpgradeRequired = '426 UPGRADE_REQUIRED',
    _428PreconditionRequired = '428 PRECONDITION_REQUIRED',
    _429TooManyRequests = '429 TOO_MANY_REQUESTS',
    _431RequestHeaderFieldsTooLarge = '431 REQUEST_HEADER_FIELDS_TOO_LARGE',
    _451UnavailableForLegalReasons = '451 UNAVAILABLE_FOR_LEGAL_REASONS',
    _500InternalServerError = '500 INTERNAL_SERVER_ERROR',
    _501NotImplemented = '501 NOT_IMPLEMENTED',
    _502BadGateway = '502 BAD_GATEWAY',
    _503ServiceUnavailable = '503 SERVICE_UNAVAILABLE',
    _504GatewayTimeout = '504 GATEWAY_TIMEOUT',
    _505HttpVersionNotSupported = '505 HTTP_VERSION_NOT_SUPPORTED',
    _506VariantAlsoNegotiates = '506 VARIANT_ALSO_NEGOTIATES',
    _507InsufficientStorage = '507 INSUFFICIENT_STORAGE',
    _508LoopDetected = '508 LOOP_DETECTED',
    _509BandwidthLimitExceeded = '509 BANDWIDTH_LIMIT_EXCEEDED',
    _510NotExtended = '510 NOT_EXTENDED',
    _511NetworkAuthenticationRequired = '511 NETWORK_AUTHENTICATION_REQUIRED'
}

/**
 * 
 * @export
 * @interface RoadmapResponseDto
 */
export interface RoadmapResponseDto {
    /**
     * 
     * @type {string}
     * @memberof RoadmapResponseDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof RoadmapResponseDto
     */
    'creationDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RoadmapResponseDto
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoadmapResponseDto
     */
    'lastChangeDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof RoadmapResponseDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof RoadmapResponseDto
     */
    'roadmapDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof RoadmapResponseDto
     */
    'roadmapId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RoadmapResponseDto
     */
    'roadmapName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RoadmapResponseDto
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface SchedulerDto
 */
export interface SchedulerDto {
    /**
     * 
     * @type {number}
     * @memberof SchedulerDto
     */
    'advancedNotificationDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof SchedulerDto
     */
    'cleanServiceConfigId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SchedulerDto
     */
    'cleanServiceDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof SchedulerDto
     */
    'historyLengthDays'?: number;
    /**
     * 
     * @type {string}
     * @memberof SchedulerDto
     */
    'scanTarget'?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerDto
     */
    'scanTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerDto
     */
    'scanType'?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerDto
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface ServiceStatus
 */
export interface ServiceStatus {
    /**
     * 
     * @type {object}
     * @memberof ServiceStatus
     */
    'details'?: object;
    /**
     * 
     * @type {string}
     * @memberof ServiceStatus
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface SpatialRefRequestDto
 */
export interface SpatialRefRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SpatialRefRequestDto
     */
    'coordinateType'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpatialRefRequestDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpatialRefRequestDto
     */
    'espg'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpatialRefRequestDto
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpatialRefRequestDto
     */
    'projectionName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpatialRefRequestDto
     */
    'unit'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpatialRefRequestDto
     */
    'wkid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpatialRefRequestDto
     */
    'zone'?: string;
}
/**
 * 
 * @export
 * @interface SpatialRefResponseDto
 */
export interface SpatialRefResponseDto {
    /**
     * 
     * @type {number}
     * @memberof SpatialRefResponseDto
     */
    'contourInterval'?: number;
    /**
     * 
     * @type {string}
     * @memberof SpatialRefResponseDto
     */
    'coordinateType'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpatialRefResponseDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpatialRefResponseDto
     */
    'creationDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SpatialRefResponseDto
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SpatialRefResponseDto
     */
    'espg'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpatialRefResponseDto
     */
    'lastChangeDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpatialRefResponseDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof SpatialRefResponseDto
     */
    'projectSpatialRefId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SpatialRefResponseDto
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpatialRefResponseDto
     */
    'projectionName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpatialRefResponseDto
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpatialRefResponseDto
     */
    'unit'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpatialRefResponseDto
     */
    'wkid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpatialRefResponseDto
     */
    'wktJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpatialRefResponseDto
     */
    'zone'?: string;
}
/**
 * 
 * @export
 * @interface StateCountyDto
 */
export interface StateCountyDto {
    /**
     * 
     * @type {string}
     * @memberof StateCountyDto
     */
    'county_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof StateCountyDto
     */
    'county_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof StateCountyDto
     */
    'fips'?: string;
    /**
     * 
     * @type {string}
     * @memberof StateCountyDto
     */
    'state_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof StateCountyDto
     */
    'state_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof StateCountyDto
     */
    'xmax'?: number;
    /**
     * 
     * @type {number}
     * @memberof StateCountyDto
     */
    'xmin'?: number;
    /**
     * 
     * @type {number}
     * @memberof StateCountyDto
     */
    'ymax'?: number;
    /**
     * 
     * @type {number}
     * @memberof StateCountyDto
     */
    'ymin'?: number;
}
/**
 * 
 * @export
 * @interface StateCountyXYdto
 */
export interface StateCountyXYdto {
    /**
     * 
     * @type {number}
     * @memberof StateCountyXYdto
     */
    'centroidx'?: number;
    /**
     * 
     * @type {number}
     * @memberof StateCountyXYdto
     */
    'centroidy'?: number;
    /**
     * 
     * @type {string}
     * @memberof StateCountyXYdto
     */
    'countyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof StateCountyXYdto
     */
    'stateCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof StateCountyXYdto
     */
    'xmax'?: number;
    /**
     * 
     * @type {number}
     * @memberof StateCountyXYdto
     */
    'xmin'?: number;
    /**
     * 
     * @type {number}
     * @memberof StateCountyXYdto
     */
    'ymax'?: number;
    /**
     * 
     * @type {number}
     * @memberof StateCountyXYdto
     */
    'ymin'?: number;
}
/**
 * 
 * @export
 * @interface StateDto
 */
export interface StateDto {
    /**
     * 
     * @type {string}
     * @memberof StateDto
     */
    'state_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof StateDto
     */
    'state_name'?: string;
}
/**
 * 
 * @export
 * @interface StatePlaneZoneDTO
 */
export interface StatePlaneZoneDTO {
    /**
     * 
     * @type {string}
     * @memberof StatePlaneZoneDTO
     */
    'fipsZone'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatePlaneZoneDTO
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatePlaneZoneDTO
     */
    'zone'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatePlaneZoneDTO
     */
    'zoneName'?: string;
}
/**
 * 
 * @export
 * @interface StatePlaneZoneRequest
 */
export interface StatePlaneZoneRequest {
    /**
     * 
     * @type {number}
     * @memberof StatePlaneZoneRequest
     */
    'latY'?: number;
    /**
     * 
     * @type {number}
     * @memberof StatePlaneZoneRequest
     */
    'longX'?: number;
    /**
     * 
     * @type {string}
     * @memberof StatePlaneZoneRequest
     */
    'projectUuid'?: string;
}
/**
 * 
 * @export
 * @interface SurfaceDef
 */
export interface SurfaceDef {
    /**
     * 
     * @type {string}
     * @memberof SurfaceDef
     */
    'borderJson'?: string;
    /**
     * 
     * @type {Array<BreaklineEntity>}
     * @memberof SurfaceDef
     */
    'breaklines'?: Array<BreaklineEntity>;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDef
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'creationDate'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'deleted'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'lastChangeDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDef
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {EftSession}
     * @memberof SurfaceDef
     */
    'session'?: EftSession;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'srid'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'surfaceDefClassId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'surfaceDefId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDef
     */
    'surfaceDefTitle'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'surfaceDefTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDef
     */
    'surfaceJson'?: string;
    /**
     * 
     * @type {Array<Survey>}
     * @memberof SurfaceDef
     */
    'surveys'?: Array<Survey>;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'xMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'xMin'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'yMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'yMin'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'zUnits'?: number;
}
/**
 * 
 * @export
 * @interface Survey
 */
export interface Survey {
    /**
     * 
     * @type {Array<Alignment>}
     * @memberof Survey
     */
    'alignments'?: Array<Alignment>;
    /**
     * 
     * @type {string}
     * @memberof Survey
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof Survey
     */
    'creationDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof Survey
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {number}
     * @memberof Survey
     */
    'lastChangeDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof Survey
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof Survey
     */
    'numberOfGroundPoints'?: number;
    /**
     * 
     * @type {SurfaceDef}
     * @memberof Survey
     */
    'surfaceDef'?: SurfaceDef;
    /**
     * 
     * @type {string}
     * @memberof Survey
     */
    'surveyCoordinateSystem'?: string;
    /**
     * 
     * @type {Array<SurveyFeature>}
     * @memberof Survey
     */
    'surveyFeatures'?: Array<SurveyFeature>;
    /**
     * 
     * @type {string}
     * @memberof Survey
     */
    'surveyName'?: string;
    /**
     * 
     * @type {number}
     * @memberof Survey
     */
    'surveyTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Survey
     */
    'surveyUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Survey
     */
    'surveyorInformation'?: string;
}
/**
 * 
 * @export
 * @interface SurveyFeature
 */
export interface SurveyFeature {
    /**
     * 
     * @type {string}
     * @memberof SurveyFeature
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyFeature
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyFeature
     */
    'featureDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurveyFeature
     */
    'featureTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyFeature
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurveyFeature
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyFeature
     */
    'pointName'?: string;
    /**
     * 
     * @type {Survey}
     * @memberof SurveyFeature
     */
    'survey'?: Survey;
    /**
     * 
     * @type {number}
     * @memberof SurveyFeature
     */
    'tinable'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyFeature
     */
    'visible'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyFeature
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyFeature
     */
    'y'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyFeature
     */
    'z'?: number;
}
/**
 * 
 * @export
 * @interface UiSettingsDto
 */
export interface UiSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof UiSettingsDto
     */
    'bankProfile'?: string;
    /**
     * 
     * @type {number}
     * @memberof UiSettingsDto
     */
    'fineGrid'?: number;
    /**
     * 
     * @type {number}
     * @memberof UiSettingsDto
     */
    'lowBankOffset'?: number;
    /**
     * 
     * @type {number}
     * @memberof UiSettingsDto
     */
    'sampleInterval'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UiSettingsDto
     */
    'showCoord'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UiSettingsDto
     */
    'verticalInterval'?: number;
}
/**
 * 
 * @export
 * @interface UpdateSessionResourceDto
 */
export interface UpdateSessionResourceDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateSessionResourceDto
     */
    'currentUser'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSessionResourceDto
     */
    'dataSourceType'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSessionResourceDto
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateSessionResourceDto
     */
    'elevationUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSessionResourceDto
     */
    'linearUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSessionResourceDto
     */
    'metadata'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateSessionResourceDto
     */
    'pixelSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateSessionResourceDto
     */
    'sessionResourceID'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateSessionResourceDto
     */
    'sessionResourceTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateSessionResourceDto
     */
    'sessionResourceValue'?: string;
}
/**
 * 
 * @export
 * @interface UserInfoDto
 */
export interface UserInfoDto {
    /**
     * 
     * @type {number}
     * @memberof UserInfoDto
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserInfoDto
     */
    'userName'?: string;
}
/**
 * 
 * @export
 * @interface UserPreferenceDto
 */
export interface UserPreferenceDto {
    /**
     * 
     * @type {string}
     * @memberof UserPreferenceDto
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserPreferenceDto
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface UserPreferencesDto
 */
export interface UserPreferencesDto {
    /**
     * 
     * @type {string}
     * @memberof UserPreferencesDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof UserPreferencesDto
     */
    'ownerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserPreferencesDto
     */
    'preferenceTypeId'?: number;
    /**
     * 
     * @type {Array<PreferenceTypeValueDto>}
     * @memberof UserPreferencesDto
     */
    'preferenceValueTypeValue'?: Array<PreferenceTypeValueDto>;
}
/**
 * 
 * @export
 * @interface ValueDomainDictionaryDto
 */
export interface ValueDomainDictionaryDto {
    /**
     * 
     * @type {Array<ValueDomainItemDto>}
     * @memberof ValueDomainDictionaryDto
     */
    'dataSourceTypes'?: Array<ValueDomainItemDto>;
    /**
     * 
     * @type {Array<ValueDomainItemDto>}
     * @memberof ValueDomainDictionaryDto
     */
    'designElementClasses'?: Array<ValueDomainItemDto>;
    /**
     * 
     * @type {Array<ValueDomainItemDto>}
     * @memberof ValueDomainDictionaryDto
     */
    'projectClasses'?: Array<ValueDomainItemDto>;
    /**
     * 
     * @type {Array<ValueDomainItemDto>}
     * @memberof ValueDomainDictionaryDto
     */
    'projectStatusTypes'?: Array<ValueDomainItemDto>;
    /**
     * 
     * @type {Array<ValueDomainItemDto>}
     * @memberof ValueDomainDictionaryDto
     */
    'resourceTypes'?: Array<ValueDomainItemDto>;
    /**
     * 
     * @type {Array<ValueDomainItemDto>}
     * @memberof ValueDomainDictionaryDto
     */
    'sessionTypes'?: Array<ValueDomainItemDto>;
    /**
     * 
     * @type {Array<ValueDomainItemDto>}
     * @memberof ValueDomainDictionaryDto
     */
    'surfaceDefClasses'?: Array<ValueDomainItemDto>;
    /**
     * 
     * @type {Array<ValueDomainItemDto>}
     * @memberof ValueDomainDictionaryDto
     */
    'surfaceDefTypes'?: Array<ValueDomainItemDto>;
    /**
     * 
     * @type {Array<ValueDomainItemDto>}
     * @memberof ValueDomainDictionaryDto
     */
    'userInputStateTypes'?: Array<ValueDomainItemDto>;
    /**
     * 
     * @type {Array<ValueDomainItemDto>}
     * @memberof ValueDomainDictionaryDto
     */
    'userPreferenceTypes'?: Array<ValueDomainItemDto>;
    /**
     * 
     * @type {Array<ValueDomainItemDto>}
     * @memberof ValueDomainDictionaryDto
     */
    'zunitTypes'?: Array<ValueDomainItemDto>;
}
/**
 * 
 * @export
 * @interface ValueDomainItemDto
 */
export interface ValueDomainItemDto {
    /**
     * 
     * @type {string}
     * @memberof ValueDomainItemDto
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ValueDomainItemDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ValueDomainItemDto
     */
    'name'?: string;
}

/**
 * AddtionalProjectDetailsControllerApi - axios parameter creator
 * @export
 */
export const AddtionalProjectDetailsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createAdditionalProjectDetailsByProjectUuid
         * @param {AdditionalProjectDetailsDto} additionalProjectDetailsJson additionalProjectDetailsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdditionalProjectDetailsByProjectUuidUsingPOST: async (additionalProjectDetailsJson: AdditionalProjectDetailsDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'additionalProjectDetailsJson' is not null or undefined
            assertParamExists('createAdditionalProjectDetailsByProjectUuidUsingPOST', 'additionalProjectDetailsJson', additionalProjectDetailsJson)
            const localVarPath = `/project/createAdditionalProjectDetailsByProjectUuid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(additionalProjectDetailsJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteAdditionalProjectDetailsByProjectUuid
         * @param {AdditionalProjectDetailsDto} additionalProjectDetailsJson additionalProjectDetailsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdditionalProjectDetailsByProjectUuidUsingPOST: async (additionalProjectDetailsJson: AdditionalProjectDetailsDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'additionalProjectDetailsJson' is not null or undefined
            assertParamExists('deleteAdditionalProjectDetailsByProjectUuidUsingPOST', 'additionalProjectDetailsJson', additionalProjectDetailsJson)
            const localVarPath = `/project/deleteAdditionalProjectDetailsByProjectUuid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(additionalProjectDetailsJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary editAdditionalProjectDetailsByProjectUuid
         * @param {AdditionalProjectDetailsDto} additionalProjectDetailsJson additionalProjectDetailsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdditionalProjectDetailsByProjectUuidUsingPOST: async (additionalProjectDetailsJson: AdditionalProjectDetailsDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'additionalProjectDetailsJson' is not null or undefined
            assertParamExists('editAdditionalProjectDetailsByProjectUuidUsingPOST', 'additionalProjectDetailsJson', additionalProjectDetailsJson)
            const localVarPath = `/project/editAdditionalProjectDetailsByProjectUuid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(additionalProjectDetailsJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAdditionalProjectDetailsByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdditionalProjectDetailsByProjectUuidUsingGET: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('getAdditionalProjectDetailsByProjectUuidUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/project/getAdditionalProjectDetailsByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddtionalProjectDetailsControllerApi - functional programming interface
 * @export
 */
export const AddtionalProjectDetailsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AddtionalProjectDetailsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createAdditionalProjectDetailsByProjectUuid
         * @param {AdditionalProjectDetailsDto} additionalProjectDetailsJson additionalProjectDetailsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAdditionalProjectDetailsByProjectUuidUsingPOST(additionalProjectDetailsJson: AdditionalProjectDetailsDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalProjectDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAdditionalProjectDetailsByProjectUuidUsingPOST(additionalProjectDetailsJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteAdditionalProjectDetailsByProjectUuid
         * @param {AdditionalProjectDetailsDto} additionalProjectDetailsJson additionalProjectDetailsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdditionalProjectDetailsByProjectUuidUsingPOST(additionalProjectDetailsJson: AdditionalProjectDetailsDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalProjectDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdditionalProjectDetailsByProjectUuidUsingPOST(additionalProjectDetailsJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary editAdditionalProjectDetailsByProjectUuid
         * @param {AdditionalProjectDetailsDto} additionalProjectDetailsJson additionalProjectDetailsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editAdditionalProjectDetailsByProjectUuidUsingPOST(additionalProjectDetailsJson: AdditionalProjectDetailsDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalProjectDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editAdditionalProjectDetailsByProjectUuidUsingPOST(additionalProjectDetailsJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAdditionalProjectDetailsByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdditionalProjectDetailsByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalProjectDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdditionalProjectDetailsByProjectUuidUsingGET(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AddtionalProjectDetailsControllerApi - factory interface
 * @export
 */
export const AddtionalProjectDetailsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AddtionalProjectDetailsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createAdditionalProjectDetailsByProjectUuid
         * @param {AdditionalProjectDetailsDto} additionalProjectDetailsJson additionalProjectDetailsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdditionalProjectDetailsByProjectUuidUsingPOST(additionalProjectDetailsJson: AdditionalProjectDetailsDto, authorization?: string, options?: any): AxiosPromise<AdditionalProjectDetailsDto> {
            return localVarFp.createAdditionalProjectDetailsByProjectUuidUsingPOST(additionalProjectDetailsJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteAdditionalProjectDetailsByProjectUuid
         * @param {AdditionalProjectDetailsDto} additionalProjectDetailsJson additionalProjectDetailsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdditionalProjectDetailsByProjectUuidUsingPOST(additionalProjectDetailsJson: AdditionalProjectDetailsDto, authorization?: string, options?: any): AxiosPromise<AdditionalProjectDetailsDto> {
            return localVarFp.deleteAdditionalProjectDetailsByProjectUuidUsingPOST(additionalProjectDetailsJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary editAdditionalProjectDetailsByProjectUuid
         * @param {AdditionalProjectDetailsDto} additionalProjectDetailsJson additionalProjectDetailsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdditionalProjectDetailsByProjectUuidUsingPOST(additionalProjectDetailsJson: AdditionalProjectDetailsDto, authorization?: string, options?: any): AxiosPromise<AdditionalProjectDetailsDto> {
            return localVarFp.editAdditionalProjectDetailsByProjectUuidUsingPOST(additionalProjectDetailsJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAdditionalProjectDetailsByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdditionalProjectDetailsByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: any): AxiosPromise<AdditionalProjectDetailsDto> {
            return localVarFp.getAdditionalProjectDetailsByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AddtionalProjectDetailsControllerApi - object-oriented interface
 * @export
 * @class AddtionalProjectDetailsControllerApi
 * @extends {BaseAPI}
 */
export class AddtionalProjectDetailsControllerApi extends BaseAPI {
    /**
     * 
     * @summary createAdditionalProjectDetailsByProjectUuid
     * @param {AdditionalProjectDetailsDto} additionalProjectDetailsJson additionalProjectDetailsJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddtionalProjectDetailsControllerApi
     */
    public createAdditionalProjectDetailsByProjectUuidUsingPOST(additionalProjectDetailsJson: AdditionalProjectDetailsDto, authorization?: string, options?: AxiosRequestConfig) {
        return AddtionalProjectDetailsControllerApiFp(this.configuration).createAdditionalProjectDetailsByProjectUuidUsingPOST(additionalProjectDetailsJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteAdditionalProjectDetailsByProjectUuid
     * @param {AdditionalProjectDetailsDto} additionalProjectDetailsJson additionalProjectDetailsJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddtionalProjectDetailsControllerApi
     */
    public deleteAdditionalProjectDetailsByProjectUuidUsingPOST(additionalProjectDetailsJson: AdditionalProjectDetailsDto, authorization?: string, options?: AxiosRequestConfig) {
        return AddtionalProjectDetailsControllerApiFp(this.configuration).deleteAdditionalProjectDetailsByProjectUuidUsingPOST(additionalProjectDetailsJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary editAdditionalProjectDetailsByProjectUuid
     * @param {AdditionalProjectDetailsDto} additionalProjectDetailsJson additionalProjectDetailsJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddtionalProjectDetailsControllerApi
     */
    public editAdditionalProjectDetailsByProjectUuidUsingPOST(additionalProjectDetailsJson: AdditionalProjectDetailsDto, authorization?: string, options?: AxiosRequestConfig) {
        return AddtionalProjectDetailsControllerApiFp(this.configuration).editAdditionalProjectDetailsByProjectUuidUsingPOST(additionalProjectDetailsJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAdditionalProjectDetailsByProjectUuid
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddtionalProjectDetailsControllerApi
     */
    public getAdditionalProjectDetailsByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return AddtionalProjectDetailsControllerApiFp(this.configuration).getAdditionalProjectDetailsByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminReportControllerApi - axios parameter creator
 * @export
 */
export const AdminReportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary generateAndDownloadUserActivityAdminReportCSV
         * @param {number} [filterTypeCode] filterTypeCode
         * @param {string} [startDate] startDate
         * @param {string} [endDate] endDate
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAndDownloadUserActivityAdminReportCSVUsingGET: async (filterTypeCode?: number, startDate?: string, endDate?: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/adminReport/generateAndDownloadUserActivityAdminReportCSV`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterTypeCode !== undefined) {
                localVarQueryParameter['filterTypeCode'] = filterTypeCode;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used within admin panel to generate a user login report for all the time as a csv file
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        generateUserActivityAdminReportAllTimeCSVUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/adminReport/generateUserActivityAdminReportAllTimeCSV`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminReportControllerApi - functional programming interface
 * @export
 */
export const AdminReportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminReportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary generateAndDownloadUserActivityAdminReportCSV
         * @param {number} [filterTypeCode] filterTypeCode
         * @param {string} [startDate] startDate
         * @param {string} [endDate] endDate
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateAndDownloadUserActivityAdminReportCSVUsingGET(filterTypeCode?: number, startDate?: string, endDate?: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateAndDownloadUserActivityAdminReportCSVUsingGET(filterTypeCode, startDate, endDate, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used within admin panel to generate a user login report for all the time as a csv file
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async generateUserActivityAdminReportAllTimeCSVUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateUserActivityAdminReportAllTimeCSVUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminReportControllerApi - factory interface
 * @export
 */
export const AdminReportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminReportControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary generateAndDownloadUserActivityAdminReportCSV
         * @param {number} [filterTypeCode] filterTypeCode
         * @param {string} [startDate] startDate
         * @param {string} [endDate] endDate
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAndDownloadUserActivityAdminReportCSVUsingGET(filterTypeCode?: number, startDate?: string, endDate?: string, authorization?: string, options?: any): AxiosPromise<void> {
            return localVarFp.generateAndDownloadUserActivityAdminReportCSVUsingGET(filterTypeCode, startDate, endDate, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used within admin panel to generate a user login report for all the time as a csv file
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        generateUserActivityAdminReportAllTimeCSVUsingGET(authorization?: string, options?: any): AxiosPromise<void> {
            return localVarFp.generateUserActivityAdminReportAllTimeCSVUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminReportControllerApi - object-oriented interface
 * @export
 * @class AdminReportControllerApi
 * @extends {BaseAPI}
 */
export class AdminReportControllerApi extends BaseAPI {
    /**
     * 
     * @summary generateAndDownloadUserActivityAdminReportCSV
     * @param {number} [filterTypeCode] filterTypeCode
     * @param {string} [startDate] startDate
     * @param {string} [endDate] endDate
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportControllerApi
     */
    public generateAndDownloadUserActivityAdminReportCSVUsingGET(filterTypeCode?: number, startDate?: string, endDate?: string, authorization?: string, options?: AxiosRequestConfig) {
        return AdminReportControllerApiFp(this.configuration).generateAndDownloadUserActivityAdminReportCSVUsingGET(filterTypeCode, startDate, endDate, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used within admin panel to generate a user login report for all the time as a csv file
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdminReportControllerApi
     */
    public generateUserActivityAdminReportAllTimeCSVUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return AdminReportControllerApiFp(this.configuration).generateUserActivityAdminReportAllTimeCSVUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AnnouncementControllerApi - axios parameter creator
 * @export
 */
export const AnnouncementControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary This service is used to create or update an announcement record
         * @param {AnnouncementRequestDto} requestDto requestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrUpdateNewAnnouncementUsingPOST: async (requestDto: AnnouncementRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestDto' is not null or undefined
            assertParamExists('addOrUpdateNewAnnouncementUsingPOST', 'requestDto', requestDto)
            const localVarPath = `/announcements/addOrUpdateAnnouncement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to create an announcement record
         * @param {AnnouncementDto} announcementDto announcementDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewAnnouncementUsingPOST: async (announcementDto: AnnouncementDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'announcementDto' is not null or undefined
            assertParamExists('createNewAnnouncementUsingPOST', 'announcementDto', announcementDto)
            const localVarPath = `/announcements/createAnnouncement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(announcementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to delete an announcement record by Id
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnnouncementByIdUsingDELETE: async (id: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAnnouncementByIdUsingDELETE', 'id', id)
            const localVarPath = `/announcements/remove/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to retrieve all available announcements records.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAnnouncementsUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/announcements/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to retrieve an announcement record by Id.
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnouncementByIdUsingGET: async (id: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAnnouncementByIdUsingGET', 'id', id)
            const localVarPath = `/announcements/fetch/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to run a report.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        performAnnouncementValidationReportUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/announcements/performValidationReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to update an announcement record by Id
         * @param {number} id id
         * @param {AnnouncementDto} announcementDto announcementDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnnouncementByIdUsingPUT: async (id: number, announcementDto: AnnouncementDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAnnouncementByIdUsingPUT', 'id', id)
            // verify required parameter 'announcementDto' is not null or undefined
            assertParamExists('updateAnnouncementByIdUsingPUT', 'announcementDto', announcementDto)
            const localVarPath = `/announcements/updateAnnouncement/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(announcementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnnouncementControllerApi - functional programming interface
 * @export
 */
export const AnnouncementControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnnouncementControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary This service is used to create or update an announcement record
         * @param {AnnouncementRequestDto} requestDto requestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrUpdateNewAnnouncementUsingPOST(requestDto: AnnouncementRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnouncementResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrUpdateNewAnnouncementUsingPOST(requestDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to create an announcement record
         * @param {AnnouncementDto} announcementDto announcementDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNewAnnouncementUsingPOST(announcementDto: AnnouncementDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnouncementDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNewAnnouncementUsingPOST(announcementDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to delete an announcement record by Id
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAnnouncementByIdUsingDELETE(id: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAnnouncementByIdUsingDELETE(id, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to retrieve all available announcements records.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAnnouncementsUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnnouncementDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAnnouncementsUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to retrieve an announcement record by Id.
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnnouncementByIdUsingGET(id: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnouncementDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnnouncementByIdUsingGET(id, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to run a report.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async performAnnouncementValidationReportUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.performAnnouncementValidationReportUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to update an announcement record by Id
         * @param {number} id id
         * @param {AnnouncementDto} announcementDto announcementDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAnnouncementByIdUsingPUT(id: number, announcementDto: AnnouncementDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnouncementDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAnnouncementByIdUsingPUT(id, announcementDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AnnouncementControllerApi - factory interface
 * @export
 */
export const AnnouncementControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnnouncementControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary This service is used to create or update an announcement record
         * @param {AnnouncementRequestDto} requestDto requestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrUpdateNewAnnouncementUsingPOST(requestDto: AnnouncementRequestDto, authorization?: string, options?: any): AxiosPromise<AnnouncementResponseDto> {
            return localVarFp.addOrUpdateNewAnnouncementUsingPOST(requestDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to create an announcement record
         * @param {AnnouncementDto} announcementDto announcementDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewAnnouncementUsingPOST(announcementDto: AnnouncementDto, authorization?: string, options?: any): AxiosPromise<AnnouncementDto> {
            return localVarFp.createNewAnnouncementUsingPOST(announcementDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to delete an announcement record by Id
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnnouncementByIdUsingDELETE(id: number, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteAnnouncementByIdUsingDELETE(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to retrieve all available announcements records.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAnnouncementsUsingGET(authorization?: string, options?: any): AxiosPromise<Array<AnnouncementDto>> {
            return localVarFp.getAllAnnouncementsUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to retrieve an announcement record by Id.
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnouncementByIdUsingGET(id: number, authorization?: string, options?: any): AxiosPromise<AnnouncementDto> {
            return localVarFp.getAnnouncementByIdUsingGET(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to run a report.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        performAnnouncementValidationReportUsingGET(authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.performAnnouncementValidationReportUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to update an announcement record by Id
         * @param {number} id id
         * @param {AnnouncementDto} announcementDto announcementDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnnouncementByIdUsingPUT(id: number, announcementDto: AnnouncementDto, authorization?: string, options?: any): AxiosPromise<AnnouncementDto> {
            return localVarFp.updateAnnouncementByIdUsingPUT(id, announcementDto, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnnouncementControllerApi - object-oriented interface
 * @export
 * @class AnnouncementControllerApi
 * @extends {BaseAPI}
 */
export class AnnouncementControllerApi extends BaseAPI {
    /**
     * 
     * @summary This service is used to create or update an announcement record
     * @param {AnnouncementRequestDto} requestDto requestDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementControllerApi
     */
    public addOrUpdateNewAnnouncementUsingPOST(requestDto: AnnouncementRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return AnnouncementControllerApiFp(this.configuration).addOrUpdateNewAnnouncementUsingPOST(requestDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to create an announcement record
     * @param {AnnouncementDto} announcementDto announcementDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementControllerApi
     */
    public createNewAnnouncementUsingPOST(announcementDto: AnnouncementDto, authorization?: string, options?: AxiosRequestConfig) {
        return AnnouncementControllerApiFp(this.configuration).createNewAnnouncementUsingPOST(announcementDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to delete an announcement record by Id
     * @param {number} id id
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementControllerApi
     */
    public deleteAnnouncementByIdUsingDELETE(id: number, authorization?: string, options?: AxiosRequestConfig) {
        return AnnouncementControllerApiFp(this.configuration).deleteAnnouncementByIdUsingDELETE(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to retrieve all available announcements records.
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementControllerApi
     */
    public getAllAnnouncementsUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return AnnouncementControllerApiFp(this.configuration).getAllAnnouncementsUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to retrieve an announcement record by Id.
     * @param {number} id id
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementControllerApi
     */
    public getAnnouncementByIdUsingGET(id: number, authorization?: string, options?: AxiosRequestConfig) {
        return AnnouncementControllerApiFp(this.configuration).getAnnouncementByIdUsingGET(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to run a report.
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementControllerApi
     */
    public performAnnouncementValidationReportUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return AnnouncementControllerApiFp(this.configuration).performAnnouncementValidationReportUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to update an announcement record by Id
     * @param {number} id id
     * @param {AnnouncementDto} announcementDto announcementDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementControllerApi
     */
    public updateAnnouncementByIdUsingPUT(id: number, announcementDto: AnnouncementDto, authorization?: string, options?: AxiosRequestConfig) {
        return AnnouncementControllerApiFp(this.configuration).updateAnnouncementByIdUsingPUT(id, announcementDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BaseControllerApi - axios parameter creator
 * @export
 */
export const BaseControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary baseSvc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseSvcUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/healthcheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseControllerApi - functional programming interface
 * @export
 */
export const BaseControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary baseSvc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async baseSvcUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.baseSvcUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseControllerApi - factory interface
 * @export
 */
export const BaseControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary baseSvc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseSvcUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.baseSvcUsingGET(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseControllerApi - object-oriented interface
 * @export
 * @class BaseControllerApi
 * @extends {BaseAPI}
 */
export class BaseControllerApi extends BaseAPI {
    /**
     * 
     * @summary baseSvc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseControllerApi
     */
    public baseSvcUsingGET(options?: AxiosRequestConfig) {
        return BaseControllerApiFp(this.configuration).baseSvcUsingGET(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DataSourceControllerApi - axios parameter creator
 * @export
 */
export const DataSourceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary triggerSecretsManagerTest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerSecretsManagerTestUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/test/netsSecrets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataSourceControllerApi - functional programming interface
 * @export
 */
export const DataSourceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataSourceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary triggerSecretsManagerTest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerSecretsManagerTestUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerSecretsManagerTestUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DataSourceControllerApi - factory interface
 * @export
 */
export const DataSourceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataSourceControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary triggerSecretsManagerTest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerSecretsManagerTestUsingGET(authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.triggerSecretsManagerTestUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataSourceControllerApi - object-oriented interface
 * @export
 * @class DataSourceControllerApi
 * @extends {BaseAPI}
 */
export class DataSourceControllerApi extends BaseAPI {
    /**
     * 
     * @summary triggerSecretsManagerTest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceControllerApi
     */
    public triggerSecretsManagerTestUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return DataSourceControllerApiFp(this.configuration).triggerSecretsManagerTestUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DefaultParameterControllerApi - axios parameter creator
 * @export
 */
export const DefaultParameterControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary This service is used to create a parameter record
         * @param {DefaultParametersRequestDto} requestDto requestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDefaultParameterUsingPOST: async (requestDto: DefaultParametersRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestDto' is not null or undefined
            assertParamExists('createDefaultParameterUsingPOST', 'requestDto', requestDto)
            const localVarPath = `/parameters/createParameter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to delete a parameter record by Id
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParameterByIdUsingDELETE: async (id: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteParameterByIdUsingDELETE', 'id', id)
            const localVarPath = `/parameters/removeParameterById/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to retrieve all available NETS default parameters.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDefaultParametersUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/parameters/getAllParameters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to retrieve available NETS default parameter by Id.
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultParameterByIdUsingGET: async (id: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDefaultParameterByIdUsingGET', 'id', id)
            const localVarPath = `/parameters/getParameterById/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to retrieve available NETS default parameter by item name.
         * @param {string} name name
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultParameterByNameUsingGET: async (name: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getDefaultParameterByNameUsingGET', 'name', name)
            const localVarPath = `/parameters/getParameterByName/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to update an existing parameter record by id.
         * @param {number} id id
         * @param {DefaultParametersRequestDto} requestDto requestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefaultParameterUsingPOST: async (id: number, requestDto: DefaultParametersRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDefaultParameterUsingPOST', 'id', id)
            // verify required parameter 'requestDto' is not null or undefined
            assertParamExists('updateDefaultParameterUsingPOST', 'requestDto', requestDto)
            const localVarPath = `/parameters/updateParameter/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultParameterControllerApi - functional programming interface
 * @export
 */
export const DefaultParameterControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultParameterControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary This service is used to create a parameter record
         * @param {DefaultParametersRequestDto} requestDto requestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDefaultParameterUsingPOST(requestDto: DefaultParametersRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultParametersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDefaultParameterUsingPOST(requestDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to delete a parameter record by Id
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteParameterByIdUsingDELETE(id: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteParameterByIdUsingDELETE(id, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to retrieve all available NETS default parameters.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDefaultParametersUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DefaultParametersDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDefaultParametersUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to retrieve available NETS default parameter by Id.
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultParameterByIdUsingGET(id: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultParametersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultParameterByIdUsingGET(id, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to retrieve available NETS default parameter by item name.
         * @param {string} name name
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultParameterByNameUsingGET(name: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultParametersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultParameterByNameUsingGET(name, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to update an existing parameter record by id.
         * @param {number} id id
         * @param {DefaultParametersRequestDto} requestDto requestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDefaultParameterUsingPOST(id: number, requestDto: DefaultParametersRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultParametersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDefaultParameterUsingPOST(id, requestDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultParameterControllerApi - factory interface
 * @export
 */
export const DefaultParameterControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultParameterControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary This service is used to create a parameter record
         * @param {DefaultParametersRequestDto} requestDto requestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDefaultParameterUsingPOST(requestDto: DefaultParametersRequestDto, authorization?: string, options?: any): AxiosPromise<DefaultParametersDto> {
            return localVarFp.createDefaultParameterUsingPOST(requestDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to delete a parameter record by Id
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParameterByIdUsingDELETE(id: number, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteParameterByIdUsingDELETE(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to retrieve all available NETS default parameters.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDefaultParametersUsingGET(authorization?: string, options?: any): AxiosPromise<Array<DefaultParametersDto>> {
            return localVarFp.getAllDefaultParametersUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to retrieve available NETS default parameter by Id.
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultParameterByIdUsingGET(id: number, authorization?: string, options?: any): AxiosPromise<DefaultParametersDto> {
            return localVarFp.getDefaultParameterByIdUsingGET(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to retrieve available NETS default parameter by item name.
         * @param {string} name name
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultParameterByNameUsingGET(name: string, authorization?: string, options?: any): AxiosPromise<DefaultParametersDto> {
            return localVarFp.getDefaultParameterByNameUsingGET(name, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to update an existing parameter record by id.
         * @param {number} id id
         * @param {DefaultParametersRequestDto} requestDto requestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefaultParameterUsingPOST(id: number, requestDto: DefaultParametersRequestDto, authorization?: string, options?: any): AxiosPromise<DefaultParametersDto> {
            return localVarFp.updateDefaultParameterUsingPOST(id, requestDto, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultParameterControllerApi - object-oriented interface
 * @export
 * @class DefaultParameterControllerApi
 * @extends {BaseAPI}
 */
export class DefaultParameterControllerApi extends BaseAPI {
    /**
     * 
     * @summary This service is used to create a parameter record
     * @param {DefaultParametersRequestDto} requestDto requestDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultParameterControllerApi
     */
    public createDefaultParameterUsingPOST(requestDto: DefaultParametersRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return DefaultParameterControllerApiFp(this.configuration).createDefaultParameterUsingPOST(requestDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to delete a parameter record by Id
     * @param {number} id id
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultParameterControllerApi
     */
    public deleteParameterByIdUsingDELETE(id: number, authorization?: string, options?: AxiosRequestConfig) {
        return DefaultParameterControllerApiFp(this.configuration).deleteParameterByIdUsingDELETE(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to retrieve all available NETS default parameters.
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultParameterControllerApi
     */
    public getAllDefaultParametersUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return DefaultParameterControllerApiFp(this.configuration).getAllDefaultParametersUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to retrieve available NETS default parameter by Id.
     * @param {number} id id
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultParameterControllerApi
     */
    public getDefaultParameterByIdUsingGET(id: number, authorization?: string, options?: AxiosRequestConfig) {
        return DefaultParameterControllerApiFp(this.configuration).getDefaultParameterByIdUsingGET(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to retrieve available NETS default parameter by item name.
     * @param {string} name name
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultParameterControllerApi
     */
    public getDefaultParameterByNameUsingGET(name: string, authorization?: string, options?: AxiosRequestConfig) {
        return DefaultParameterControllerApiFp(this.configuration).getDefaultParameterByNameUsingGET(name, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to update an existing parameter record by id.
     * @param {number} id id
     * @param {DefaultParametersRequestDto} requestDto requestDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultParameterControllerApi
     */
    public updateDefaultParameterUsingPOST(id: number, requestDto: DefaultParametersRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return DefaultParameterControllerApiFp(this.configuration).updateDefaultParameterUsingPOST(id, requestDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DemMetadataControllerApi - axios parameter creator
 * @export
 */
export const DemMetadataControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createDemMetadataSummary
         * @param {DemMetadataSummaryRequest} demMetadataSummaryRequestList demMetadataSummaryRequestList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemMetadataSummaryUsingPOST: async (demMetadataSummaryRequestList: DemMetadataSummaryRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'demMetadataSummaryRequestList' is not null or undefined
            assertParamExists('createDemMetadataSummaryUsingPOST', 'demMetadataSummaryRequestList', demMetadataSummaryRequestList)
            const localVarPath = `/metadata/createDemMetadataSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(demMetadataSummaryRequestList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteDemMetadataById
         * @param {number} demMetadataSummaryId demMetadataSummaryId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemMetadataByIdUsingGET: async (demMetadataSummaryId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'demMetadataSummaryId' is not null or undefined
            assertParamExists('deleteDemMetadataByIdUsingGET', 'demMetadataSummaryId', demMetadataSummaryId)
            const localVarPath = `/metadata/deleteDemMetadataById/{demMetadataSummaryId}`
                .replace(`{${"demMetadataSummaryId"}}`, encodeURIComponent(String(demMetadataSummaryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllDemMetadata
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDemMetadataUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/metadata/getAllDemMetadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getDemMetadataById
         * @param {number} demMetadataSummaryId demMetadataSummaryId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemMetadataByIdUsingGET: async (demMetadataSummaryId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'demMetadataSummaryId' is not null or undefined
            assertParamExists('getDemMetadataByIdUsingGET', 'demMetadataSummaryId', demMetadataSummaryId)
            const localVarPath = `/metadata/getDemMetadataById/{demMetadataSummaryId}`
                .replace(`{${"demMetadataSummaryId"}}`, encodeURIComponent(String(demMetadataSummaryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateDemMetadataSummary
         * @param {DemMetadataSummaryRequest} demMetadataSummaryRequestList demMetadataSummaryRequestList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDemMetadataSummaryUsingPOST: async (demMetadataSummaryRequestList: DemMetadataSummaryRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'demMetadataSummaryRequestList' is not null or undefined
            assertParamExists('updateDemMetadataSummaryUsingPOST', 'demMetadataSummaryRequestList', demMetadataSummaryRequestList)
            const localVarPath = `/metadata/updateDemMetadataSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(demMetadataSummaryRequestList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DemMetadataControllerApi - functional programming interface
 * @export
 */
export const DemMetadataControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DemMetadataControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createDemMetadataSummary
         * @param {DemMetadataSummaryRequest} demMetadataSummaryRequestList demMetadataSummaryRequestList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDemMetadataSummaryUsingPOST(demMetadataSummaryRequestList: DemMetadataSummaryRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DemMetadataSummaryEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDemMetadataSummaryUsingPOST(demMetadataSummaryRequestList, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteDemMetadataById
         * @param {number} demMetadataSummaryId demMetadataSummaryId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDemMetadataByIdUsingGET(demMetadataSummaryId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DemMetadataSummaryEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDemMetadataByIdUsingGET(demMetadataSummaryId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllDemMetadata
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDemMetadataUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DemMetadataResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDemMetadataUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getDemMetadataById
         * @param {number} demMetadataSummaryId demMetadataSummaryId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDemMetadataByIdUsingGET(demMetadataSummaryId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DemMetadataResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDemMetadataByIdUsingGET(demMetadataSummaryId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateDemMetadataSummary
         * @param {DemMetadataSummaryRequest} demMetadataSummaryRequestList demMetadataSummaryRequestList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDemMetadataSummaryUsingPOST(demMetadataSummaryRequestList: DemMetadataSummaryRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DemMetadataSummaryEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDemMetadataSummaryUsingPOST(demMetadataSummaryRequestList, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DemMetadataControllerApi - factory interface
 * @export
 */
export const DemMetadataControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DemMetadataControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createDemMetadataSummary
         * @param {DemMetadataSummaryRequest} demMetadataSummaryRequestList demMetadataSummaryRequestList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemMetadataSummaryUsingPOST(demMetadataSummaryRequestList: DemMetadataSummaryRequest, authorization?: string, options?: any): AxiosPromise<DemMetadataSummaryEntity> {
            return localVarFp.createDemMetadataSummaryUsingPOST(demMetadataSummaryRequestList, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteDemMetadataById
         * @param {number} demMetadataSummaryId demMetadataSummaryId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemMetadataByIdUsingGET(demMetadataSummaryId: number, authorization?: string, options?: any): AxiosPromise<DemMetadataSummaryEntity> {
            return localVarFp.deleteDemMetadataByIdUsingGET(demMetadataSummaryId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllDemMetadata
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDemMetadataUsingGET(authorization?: string, options?: any): AxiosPromise<Array<DemMetadataResponseDto>> {
            return localVarFp.getAllDemMetadataUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getDemMetadataById
         * @param {number} demMetadataSummaryId demMetadataSummaryId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemMetadataByIdUsingGET(demMetadataSummaryId: number, authorization?: string, options?: any): AxiosPromise<Array<DemMetadataResponseDto>> {
            return localVarFp.getDemMetadataByIdUsingGET(demMetadataSummaryId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateDemMetadataSummary
         * @param {DemMetadataSummaryRequest} demMetadataSummaryRequestList demMetadataSummaryRequestList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDemMetadataSummaryUsingPOST(demMetadataSummaryRequestList: DemMetadataSummaryRequest, authorization?: string, options?: any): AxiosPromise<DemMetadataSummaryEntity> {
            return localVarFp.updateDemMetadataSummaryUsingPOST(demMetadataSummaryRequestList, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DemMetadataControllerApi - object-oriented interface
 * @export
 * @class DemMetadataControllerApi
 * @extends {BaseAPI}
 */
export class DemMetadataControllerApi extends BaseAPI {
    /**
     * 
     * @summary createDemMetadataSummary
     * @param {DemMetadataSummaryRequest} demMetadataSummaryRequestList demMetadataSummaryRequestList
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemMetadataControllerApi
     */
    public createDemMetadataSummaryUsingPOST(demMetadataSummaryRequestList: DemMetadataSummaryRequest, authorization?: string, options?: AxiosRequestConfig) {
        return DemMetadataControllerApiFp(this.configuration).createDemMetadataSummaryUsingPOST(demMetadataSummaryRequestList, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteDemMetadataById
     * @param {number} demMetadataSummaryId demMetadataSummaryId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemMetadataControllerApi
     */
    public deleteDemMetadataByIdUsingGET(demMetadataSummaryId: number, authorization?: string, options?: AxiosRequestConfig) {
        return DemMetadataControllerApiFp(this.configuration).deleteDemMetadataByIdUsingGET(demMetadataSummaryId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllDemMetadata
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemMetadataControllerApi
     */
    public getAllDemMetadataUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return DemMetadataControllerApiFp(this.configuration).getAllDemMetadataUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getDemMetadataById
     * @param {number} demMetadataSummaryId demMetadataSummaryId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemMetadataControllerApi
     */
    public getDemMetadataByIdUsingGET(demMetadataSummaryId: number, authorization?: string, options?: AxiosRequestConfig) {
        return DemMetadataControllerApiFp(this.configuration).getDemMetadataByIdUsingGET(demMetadataSummaryId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateDemMetadataSummary
     * @param {DemMetadataSummaryRequest} demMetadataSummaryRequestList demMetadataSummaryRequestList
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemMetadataControllerApi
     */
    public updateDemMetadataSummaryUsingPOST(demMetadataSummaryRequestList: DemMetadataSummaryRequest, authorization?: string, options?: AxiosRequestConfig) {
        return DemMetadataControllerApiFp(this.configuration).updateDemMetadataSummaryUsingPOST(demMetadataSummaryRequestList, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EftProjUserInputControllerApi - axios parameter creator
 * @export
 */
export const EftProjUserInputControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary This API Call Creates a NEW project Input record in DB with associated Project
         * @param {Array<EftProjUserInputDto>} eftProjUserInputList eftProjUserInputList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectInputUsingPOST: async (eftProjUserInputList: Array<EftProjUserInputDto>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eftProjUserInputList' is not null or undefined
            assertParamExists('createProjectInputUsingPOST', 'eftProjUserInputList', eftProjUserInputList)
            const localVarPath = `/projectInput/saveProjectUserInput`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eftProjUserInputList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Call deletes(soft delete) project user input details by the  Project UUID & Project User Input Type
         * @param {string} sessionUuid sessionUuid
         * @param {string} [uiStateType] uiStateType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjUserInputByUuuidAndTypeUsingDELETE: async (sessionUuid: string, uiStateType?: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('deleteProjUserInputByUuuidAndTypeUsingDELETE', 'sessionUuid', sessionUuid)
            const localVarPath = `/projectInput/deleteProjectUserInput`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sessionUuid !== undefined) {
                localVarQueryParameter['sessionUuid'] = sessionUuid;
            }

            if (uiStateType !== undefined) {
                localVarQueryParameter['uiStateType'] = uiStateType;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getDesignUiState
         * @param {string} sessionUuid sessionUuid
         * @param {string} waterwayOrTerrace waterwayOrTerrace
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignUiStateUsingGET: async (sessionUuid: string, waterwayOrTerrace: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('getDesignUiStateUsingGET', 'sessionUuid', sessionUuid)
            // verify required parameter 'waterwayOrTerrace' is not null or undefined
            assertParamExists('getDesignUiStateUsingGET', 'waterwayOrTerrace', waterwayOrTerrace)
            const localVarPath = `/projectInput/getAllDesignUiStatesBySessionUuid/{sessionUuid}/{waterwayOrTerrace}`
                .replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)))
                .replace(`{${"waterwayOrTerrace"}}`, encodeURIComponent(String(waterwayOrTerrace)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getDesignUiState
         * @param {string} sessionUuid sessionUuid
         * @param {number} alignmentElementId alignmentElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignUiStateUsingGET1: async (sessionUuid: string, alignmentElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('getDesignUiStateUsingGET1', 'sessionUuid', sessionUuid)
            // verify required parameter 'alignmentElementId' is not null or undefined
            assertParamExists('getDesignUiStateUsingGET1', 'alignmentElementId', alignmentElementId)
            const localVarPath = `/projectInput/getDesignUiState/{sessionUuid}/{alignmentElementId}`
                .replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)))
                .replace(`{${"alignmentElementId"}}`, encodeURIComponent(String(alignmentElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Call retrieves project user input details by the  Project UUID & Project User Input Type
         * @param {string} sessionUuid sessionUuid
         * @param {string} [uiStateType] uiStateType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjUserInputByUuuidAndTypeUsingGET: async (sessionUuid: string, uiStateType?: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('getProjUserInputByUuuidAndTypeUsingGET', 'sessionUuid', sessionUuid)
            const localVarPath = `/projectInput/getProjectUserInput`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sessionUuid !== undefined) {
                localVarQueryParameter['sessionUuid'] = sessionUuid;
            }

            if (uiStateType !== undefined) {
                localVarQueryParameter['uiStateType'] = uiStateType;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary saveDesignUiState
         * @param {EftProjUserInputDto} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDesignUiStateUsingPOST: async (input: EftProjUserInputDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'input' is not null or undefined
            assertParamExists('saveDesignUiStateUsingPOST', 'input', input)
            const localVarPath = `/projectInput/saveDesignUiState`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(input, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EftProjUserInputControllerApi - functional programming interface
 * @export
 */
export const EftProjUserInputControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EftProjUserInputControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary This API Call Creates a NEW project Input record in DB with associated Project
         * @param {Array<EftProjUserInputDto>} eftProjUserInputList eftProjUserInputList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProjectInputUsingPOST(eftProjUserInputList: Array<EftProjUserInputDto>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProjectInputUsingPOST(eftProjUserInputList, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Call deletes(soft delete) project user input details by the  Project UUID & Project User Input Type
         * @param {string} sessionUuid sessionUuid
         * @param {string} [uiStateType] uiStateType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProjUserInputByUuuidAndTypeUsingDELETE(sessionUuid: string, uiStateType?: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProjUserInputByUuuidAndTypeUsingDELETE(sessionUuid, uiStateType, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getDesignUiState
         * @param {string} sessionUuid sessionUuid
         * @param {string} waterwayOrTerrace waterwayOrTerrace
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDesignUiStateUsingGET(sessionUuid: string, waterwayOrTerrace: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EftProjUserInputDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDesignUiStateUsingGET(sessionUuid, waterwayOrTerrace, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getDesignUiState
         * @param {string} sessionUuid sessionUuid
         * @param {number} alignmentElementId alignmentElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDesignUiStateUsingGET1(sessionUuid: string, alignmentElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EftProjUserInputDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDesignUiStateUsingGET1(sessionUuid, alignmentElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Call retrieves project user input details by the  Project UUID & Project User Input Type
         * @param {string} sessionUuid sessionUuid
         * @param {string} [uiStateType] uiStateType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjUserInputByUuuidAndTypeUsingGET(sessionUuid: string, uiStateType?: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjUserInputByUuuidAndTypeUsingGET(sessionUuid, uiStateType, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary saveDesignUiState
         * @param {EftProjUserInputDto} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDesignUiStateUsingPOST(input: EftProjUserInputDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EftProjUserInputDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDesignUiStateUsingPOST(input, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EftProjUserInputControllerApi - factory interface
 * @export
 */
export const EftProjUserInputControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EftProjUserInputControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary This API Call Creates a NEW project Input record in DB with associated Project
         * @param {Array<EftProjUserInputDto>} eftProjUserInputList eftProjUserInputList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectInputUsingPOST(eftProjUserInputList: Array<EftProjUserInputDto>, authorization?: string, options?: any): AxiosPromise<ResponseEntity> {
            return localVarFp.createProjectInputUsingPOST(eftProjUserInputList, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Call deletes(soft delete) project user input details by the  Project UUID & Project User Input Type
         * @param {string} sessionUuid sessionUuid
         * @param {string} [uiStateType] uiStateType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjUserInputByUuuidAndTypeUsingDELETE(sessionUuid: string, uiStateType?: string, authorization?: string, options?: any): AxiosPromise<ResponseEntity> {
            return localVarFp.deleteProjUserInputByUuuidAndTypeUsingDELETE(sessionUuid, uiStateType, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getDesignUiState
         * @param {string} sessionUuid sessionUuid
         * @param {string} waterwayOrTerrace waterwayOrTerrace
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignUiStateUsingGET(sessionUuid: string, waterwayOrTerrace: string, authorization?: string, options?: any): AxiosPromise<Array<EftProjUserInputDto>> {
            return localVarFp.getDesignUiStateUsingGET(sessionUuid, waterwayOrTerrace, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getDesignUiState
         * @param {string} sessionUuid sessionUuid
         * @param {number} alignmentElementId alignmentElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignUiStateUsingGET1(sessionUuid: string, alignmentElementId: number, authorization?: string, options?: any): AxiosPromise<EftProjUserInputDto> {
            return localVarFp.getDesignUiStateUsingGET1(sessionUuid, alignmentElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Call retrieves project user input details by the  Project UUID & Project User Input Type
         * @param {string} sessionUuid sessionUuid
         * @param {string} [uiStateType] uiStateType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjUserInputByUuuidAndTypeUsingGET(sessionUuid: string, uiStateType?: string, authorization?: string, options?: any): AxiosPromise<ResponseEntity> {
            return localVarFp.getProjUserInputByUuuidAndTypeUsingGET(sessionUuid, uiStateType, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary saveDesignUiState
         * @param {EftProjUserInputDto} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDesignUiStateUsingPOST(input: EftProjUserInputDto, authorization?: string, options?: any): AxiosPromise<EftProjUserInputDto> {
            return localVarFp.saveDesignUiStateUsingPOST(input, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EftProjUserInputControllerApi - object-oriented interface
 * @export
 * @class EftProjUserInputControllerApi
 * @extends {BaseAPI}
 */
export class EftProjUserInputControllerApi extends BaseAPI {
    /**
     * 
     * @summary This API Call Creates a NEW project Input record in DB with associated Project
     * @param {Array<EftProjUserInputDto>} eftProjUserInputList eftProjUserInputList
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjUserInputControllerApi
     */
    public createProjectInputUsingPOST(eftProjUserInputList: Array<EftProjUserInputDto>, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjUserInputControllerApiFp(this.configuration).createProjectInputUsingPOST(eftProjUserInputList, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Call deletes(soft delete) project user input details by the  Project UUID & Project User Input Type
     * @param {string} sessionUuid sessionUuid
     * @param {string} [uiStateType] uiStateType
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjUserInputControllerApi
     */
    public deleteProjUserInputByUuuidAndTypeUsingDELETE(sessionUuid: string, uiStateType?: string, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjUserInputControllerApiFp(this.configuration).deleteProjUserInputByUuuidAndTypeUsingDELETE(sessionUuid, uiStateType, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getDesignUiState
     * @param {string} sessionUuid sessionUuid
     * @param {string} waterwayOrTerrace waterwayOrTerrace
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjUserInputControllerApi
     */
    public getDesignUiStateUsingGET(sessionUuid: string, waterwayOrTerrace: string, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjUserInputControllerApiFp(this.configuration).getDesignUiStateUsingGET(sessionUuid, waterwayOrTerrace, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getDesignUiState
     * @param {string} sessionUuid sessionUuid
     * @param {number} alignmentElementId alignmentElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjUserInputControllerApi
     */
    public getDesignUiStateUsingGET1(sessionUuid: string, alignmentElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjUserInputControllerApiFp(this.configuration).getDesignUiStateUsingGET1(sessionUuid, alignmentElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Call retrieves project user input details by the  Project UUID & Project User Input Type
     * @param {string} sessionUuid sessionUuid
     * @param {string} [uiStateType] uiStateType
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjUserInputControllerApi
     */
    public getProjUserInputByUuuidAndTypeUsingGET(sessionUuid: string, uiStateType?: string, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjUserInputControllerApiFp(this.configuration).getProjUserInputByUuuidAndTypeUsingGET(sessionUuid, uiStateType, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary saveDesignUiState
     * @param {EftProjUserInputDto} input input
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjUserInputControllerApi
     */
    public saveDesignUiStateUsingPOST(input: EftProjUserInputDto, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjUserInputControllerApiFp(this.configuration).saveDesignUiStateUsingPOST(input, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EftProjectControllerApi - axios parameter creator
 * @export
 */
export const EftProjectControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary This API Call Creates a NEW project record in DB with associated Session details, please provide req body when calling this API
         * @param {EftCreateProjectDto} createProjectDto createProjectDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectUsingPOST: async (createProjectDto: EftCreateProjectDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProjectDto' is not null or undefined
            assertParamExists('createProjectUsingPOST', 'createProjectDto', createProjectDto)
            const localVarPath = `/project/saveProject`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProjectDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Call edits an existing project record in DB, please provide req body when calling this API
         * @param {EftProjectEditDto} editProjectSummary editProjectSummary
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editProjectSummaryUsingPOST: async (editProjectSummary: EftProjectEditDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editProjectSummary' is not null or undefined
            assertParamExists('editProjectSummaryUsingPOST', 'editProjectSummary', editProjectSummary)
            const localVarPath = `/project/editProjectSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editProjectSummary, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Call edits an existing project record in DB, please provide req body when calling this API
         * @param {EftProjectEditDto} editProject editProject
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editProjectUsingPOST: async (editProject: EftProjectEditDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'editProject' is not null or undefined
            assertParamExists('editProjectUsingPOST', 'editProject', editProject)
            const localVarPath = `/project/editProject`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editProject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is finding state plane zone info
         * @param {StatePlaneZoneRequest} statePlaneZoneRequest statePlaneZoneRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStatePlaneZoneByLatLongUsingPOST: async (statePlaneZoneRequest: StatePlaneZoneRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'statePlaneZoneRequest' is not null or undefined
            assertParamExists('findStatePlaneZoneByLatLongUsingPOST', 'statePlaneZoneRequest', statePlaneZoneRequest)
            const localVarPath = `/project/findStatePlaneZoneByLatLong`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(statePlaneZoneRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllProjectsByOwnerName
         * @param {string} ownerName ownerName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectsByOwnerNameUsingGET: async (ownerName: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ownerName' is not null or undefined
            assertParamExists('getAllProjectsByOwnerNameUsingGET', 'ownerName', ownerName)
            const localVarPath = `/project/getAllProjectsByOwnerName/{ownerName}`
                .replace(`{${"ownerName"}}`, encodeURIComponent(String(ownerName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Call retrieves project details by User Id for ALL projects in the EFT Project Database, please provide project owner id as parameter when calling this API
         * @param {number} projectOwnerId projectOwnerId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectsByUserIdUsingGET: async (projectOwnerId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectOwnerId' is not null or undefined
            assertParamExists('getAllProjectsByUserIdUsingGET', 'projectOwnerId', projectOwnerId)
            const localVarPath = `/project/getProjectByUserId/{projectOwnerId}`
                .replace(`{${"projectOwnerId"}}`, encodeURIComponent(String(projectOwnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Call retrieves project details for ALL projects in the EFT Project Database, no parameter needed
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectsUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/project/getAllProjects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Call retrieves project details by User Id for ALL projects in the EFT Project Database, please provide project owner id as parameter when calling this API
         * @param {string} ownerName ownerName
         * @param {number} [status] status
         * @param {number} [type] type
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredProjectsUsingGET: async (ownerName: string, status?: number, type?: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ownerName' is not null or undefined
            assertParamExists('getFilteredProjectsUsingGET', 'ownerName', ownerName)
            const localVarPath = `/project/getFilteredProjects/{ownerName}`
                .replace(`{${"ownerName"}}`, encodeURIComponent(String(ownerName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This call will return Hydro Project Metadata information
         * @param {HydroProjectMetadataReqDTO} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHydroProjectMetadataUsingPOST: async (req: HydroProjectMetadataReqDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('getHydroProjectMetadataUsingPOST', 'req', req)
            const localVarPath = `/project/getHydroProjectMetadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Call retrieves project details by User Id for ALL projects in the EFT Project Database, please provide project owner id as parameter when calling this API
         * @param {string} ownerName ownerName
         * @param {number} [size] size
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestProjectsForUserUsingGET: async (ownerName: string, size?: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ownerName' is not null or undefined
            assertParamExists('getLatestProjectsForUserUsingGET', 'ownerName', ownerName)
            const localVarPath = `/project/getLatestProjectsForUser/{ownerName}`
                .replace(`{${"ownerName"}}`, encodeURIComponent(String(ownerName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Call retrieves project details by the ProjectUuid, please provide projectUuid as parameter when calling this API
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectByIdUsingGET: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('getProjectByIdUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/project/getProjectByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This call will return EFT Project Count group by EFT Project Owner Id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectCountUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/project/getProjectOwnerIdAndProjectCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Call retrieves projects owner and their projects count
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectsWithCountByOwnerUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/project/getProjectsWithCountByOwner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is getting TR20 results by project and return them to FE in Json String
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTR20ResultsJsonByProjectUuidUsingGET: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('getTR20ResultsJsonByProjectUuidUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/project/getTR20ResultsJsonByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary softDeleteProject
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softDeleteProjectUsingDELETE: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('softDeleteProjectUsingDELETE', 'projectUuid', projectUuid)
            const localVarPath = `/project/softDeleteProject/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Call Permanently deletes a project, session, and associated session resources by projectUuid. Please provide project uuid when calling this API This call is permanent and should only be used in development and testing  
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trueDeleteProjectByProjectUuidUsingDELETE: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('trueDeleteProjectByProjectUuidUsingDELETE', 'projectUuid', projectUuid)
            const localVarPath = `/project/trueDeleteProjectByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is updating project\'s Last Changed Date
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLastChangedDateForProjectByProjectUuidUsingPOST: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('updateLastChangedDateForProjectByProjectUuidUsingPOST', 'projectUuid', projectUuid)
            const localVarPath = `/project/updateLastChangedDateForProjectByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is updating project\'s Last Changed Date
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLastChangedDateForProjectBySessionUuidUsingPOST: async (sessionUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('updateLastChangedDateForProjectBySessionUuidUsingPOST', 'sessionUuid', sessionUuid)
            const localVarPath = `/project/updateLastChangedDateForProjectBySessionUuid/{sessionUuid}`
                .replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service updates project(s) owner to the coreUserId from the given request. Request might contain one or list of projects
         * @param {EftProjectUpdateOwnerReqDto} eftProjectUpdateOwnerReqDto eftProjectUpdateOwnerReqDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectOwnerUsingPOST: async (eftProjectUpdateOwnerReqDto: EftProjectUpdateOwnerReqDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eftProjectUpdateOwnerReqDto' is not null or undefined
            assertParamExists('updateProjectOwnerUsingPOST', 'eftProjectUpdateOwnerReqDto', eftProjectUpdateOwnerReqDto)
            const localVarPath = `/project/updateProjectOwner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eftProjectUpdateOwnerReqDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is updating project\'s projection text
         * @param {EftProjectProjectionTextDto} eftProjectProjectionTextDto eftProjectProjectionTextDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectProjectionTextUsingPOST: async (eftProjectProjectionTextDto: EftProjectProjectionTextDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eftProjectProjectionTextDto' is not null or undefined
            assertParamExists('updateProjectProjectionTextUsingPOST', 'eftProjectProjectionTextDto', eftProjectProjectionTextDto)
            const localVarPath = `/project/updateProjectionText`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eftProjectProjectionTextDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Call updates an existing project record in DB, please provide req body when calling this API
         * @param {EftProjectUpdateDto} projectUpdate projectUpdate
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectUsingPOST: async (projectUpdate: EftProjectUpdateDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUpdate' is not null or undefined
            assertParamExists('updateProjectUsingPOST', 'projectUpdate', projectUpdate)
            const localVarPath = `/project/updateProject`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is updating project\'s State and County
         * @param {EftProjectStateCountyProjectDto} eftProjectStateCountyProjectionDto eftProjectStateCountyProjectionDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStateCountyByProjectUuidUsingPOST: async (eftProjectStateCountyProjectionDto: EftProjectStateCountyProjectDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eftProjectStateCountyProjectionDto' is not null or undefined
            assertParamExists('updateStateCountyByProjectUuidUsingPOST', 'eftProjectStateCountyProjectionDto', eftProjectStateCountyProjectionDto)
            const localVarPath = `/project/updateStateCountyByProjectUuid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eftProjectStateCountyProjectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is updating project\'s projection text
         * @param {EftProjectUserInputNotesDTO} eftProjectUserInputNotesDTO eftProjectUserInputNotesDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserInputNotesByProjectUuidUsingPOST: async (eftProjectUserInputNotesDTO: EftProjectUserInputNotesDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eftProjectUserInputNotesDTO' is not null or undefined
            assertParamExists('updateUserInputNotesByProjectUuidUsingPOST', 'eftProjectUserInputNotesDTO', eftProjectUserInputNotesDTO)
            const localVarPath = `/project/updateUserInputNotesByProjectUuid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eftProjectUserInputNotesDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EftProjectControllerApi - functional programming interface
 * @export
 */
export const EftProjectControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EftProjectControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary This API Call Creates a NEW project record in DB with associated Session details, please provide req body when calling this API
         * @param {EftCreateProjectDto} createProjectDto createProjectDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProjectUsingPOST(createProjectDto: EftCreateProjectDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EftGetProjectReponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProjectUsingPOST(createProjectDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Call edits an existing project record in DB, please provide req body when calling this API
         * @param {EftProjectEditDto} editProjectSummary editProjectSummary
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editProjectSummaryUsingPOST(editProjectSummary: EftProjectEditDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EditProjectSummaryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editProjectSummaryUsingPOST(editProjectSummary, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Call edits an existing project record in DB, please provide req body when calling this API
         * @param {EftProjectEditDto} editProject editProject
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editProjectUsingPOST(editProject: EftProjectEditDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EftProjectEditResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editProjectUsingPOST(editProject, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is finding state plane zone info
         * @param {StatePlaneZoneRequest} statePlaneZoneRequest statePlaneZoneRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findStatePlaneZoneByLatLongUsingPOST(statePlaneZoneRequest: StatePlaneZoneRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatePlaneZoneDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findStatePlaneZoneByLatLongUsingPOST(statePlaneZoneRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllProjectsByOwnerName
         * @param {string} ownerName ownerName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProjectsByOwnerNameUsingGET(ownerName: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EftGetProjectReponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProjectsByOwnerNameUsingGET(ownerName, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Call retrieves project details by User Id for ALL projects in the EFT Project Database, please provide project owner id as parameter when calling this API
         * @param {number} projectOwnerId projectOwnerId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProjectsByUserIdUsingGET(projectOwnerId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EftGetProjectReponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProjectsByUserIdUsingGET(projectOwnerId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Call retrieves project details for ALL projects in the EFT Project Database, no parameter needed
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProjectsUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EftGetProjectReponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProjectsUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Call retrieves project details by User Id for ALL projects in the EFT Project Database, please provide project owner id as parameter when calling this API
         * @param {string} ownerName ownerName
         * @param {number} [status] status
         * @param {number} [type] type
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilteredProjectsUsingGET(ownerName: string, status?: number, type?: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EftGetProjectReponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilteredProjectsUsingGET(ownerName, status, type, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This call will return Hydro Project Metadata information
         * @param {HydroProjectMetadataReqDTO} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHydroProjectMetadataUsingPOST(req: HydroProjectMetadataReqDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HydroProjectMetadataRespDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHydroProjectMetadataUsingPOST(req, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Call retrieves project details by User Id for ALL projects in the EFT Project Database, please provide project owner id as parameter when calling this API
         * @param {string} ownerName ownerName
         * @param {number} [size] size
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestProjectsForUserUsingGET(ownerName: string, size?: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EftGetProjectReponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestProjectsForUserUsingGET(ownerName, size, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Call retrieves project details by the ProjectUuid, please provide projectUuid as parameter when calling this API
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectByIdUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EftGetProjectReponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectByIdUsingGET(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This call will return EFT Project Count group by EFT Project Owner Id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectCountUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EftProjectCountDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectCountUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Call retrieves projects owner and their projects count
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectsWithCountByOwnerUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectsWithCount>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectsWithCountByOwnerUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is getting TR20 results by project and return them to FE in Json String
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTR20ResultsJsonByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTR20ResultsJsonByProjectUuidUsingGET(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary softDeleteProject
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async softDeleteProjectUsingDELETE(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EftStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.softDeleteProjectUsingDELETE(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Call Permanently deletes a project, session, and associated session resources by projectUuid. Please provide project uuid when calling this API This call is permanent and should only be used in development and testing  
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trueDeleteProjectByProjectUuidUsingDELETE(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EftStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trueDeleteProjectByProjectUuidUsingDELETE(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is updating project\'s Last Changed Date
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLastChangedDateForProjectByProjectUuidUsingPOST(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLastChangedDateForProjectByProjectUuidUsingPOST(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is updating project\'s Last Changed Date
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLastChangedDateForProjectBySessionUuidUsingPOST(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLastChangedDateForProjectBySessionUuidUsingPOST(sessionUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service updates project(s) owner to the coreUserId from the given request. Request might contain one or list of projects
         * @param {EftProjectUpdateOwnerReqDto} eftProjectUpdateOwnerReqDto eftProjectUpdateOwnerReqDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProjectOwnerUsingPOST(eftProjectUpdateOwnerReqDto: EftProjectUpdateOwnerReqDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProjectOwnerUsingPOST(eftProjectUpdateOwnerReqDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is updating project\'s projection text
         * @param {EftProjectProjectionTextDto} eftProjectProjectionTextDto eftProjectProjectionTextDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProjectProjectionTextUsingPOST(eftProjectProjectionTextDto: EftProjectProjectionTextDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProjectProjectionTextUsingPOST(eftProjectProjectionTextDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Call updates an existing project record in DB, please provide req body when calling this API
         * @param {EftProjectUpdateDto} projectUpdate projectUpdate
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProjectUsingPOST(projectUpdate: EftProjectUpdateDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EftProjectUpdateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProjectUsingPOST(projectUpdate, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is updating project\'s State and County
         * @param {EftProjectStateCountyProjectDto} eftProjectStateCountyProjectionDto eftProjectStateCountyProjectionDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStateCountyByProjectUuidUsingPOST(eftProjectStateCountyProjectionDto: EftProjectStateCountyProjectDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStateCountyByProjectUuidUsingPOST(eftProjectStateCountyProjectionDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is updating project\'s projection text
         * @param {EftProjectUserInputNotesDTO} eftProjectUserInputNotesDTO eftProjectUserInputNotesDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserInputNotesByProjectUuidUsingPOST(eftProjectUserInputNotesDTO: EftProjectUserInputNotesDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserInputNotesByProjectUuidUsingPOST(eftProjectUserInputNotesDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EftProjectControllerApi - factory interface
 * @export
 */
export const EftProjectControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EftProjectControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary This API Call Creates a NEW project record in DB with associated Session details, please provide req body when calling this API
         * @param {EftCreateProjectDto} createProjectDto createProjectDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectUsingPOST(createProjectDto: EftCreateProjectDto, authorization?: string, options?: any): AxiosPromise<EftGetProjectReponseDto> {
            return localVarFp.createProjectUsingPOST(createProjectDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Call edits an existing project record in DB, please provide req body when calling this API
         * @param {EftProjectEditDto} editProjectSummary editProjectSummary
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editProjectSummaryUsingPOST(editProjectSummary: EftProjectEditDto, authorization?: string, options?: any): AxiosPromise<EditProjectSummaryResponseDto> {
            return localVarFp.editProjectSummaryUsingPOST(editProjectSummary, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Call edits an existing project record in DB, please provide req body when calling this API
         * @param {EftProjectEditDto} editProject editProject
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editProjectUsingPOST(editProject: EftProjectEditDto, authorization?: string, options?: any): AxiosPromise<EftProjectEditResponseDto> {
            return localVarFp.editProjectUsingPOST(editProject, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is finding state plane zone info
         * @param {StatePlaneZoneRequest} statePlaneZoneRequest statePlaneZoneRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStatePlaneZoneByLatLongUsingPOST(statePlaneZoneRequest: StatePlaneZoneRequest, authorization?: string, options?: any): AxiosPromise<StatePlaneZoneDTO> {
            return localVarFp.findStatePlaneZoneByLatLongUsingPOST(statePlaneZoneRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllProjectsByOwnerName
         * @param {string} ownerName ownerName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectsByOwnerNameUsingGET(ownerName: string, authorization?: string, options?: any): AxiosPromise<Array<EftGetProjectReponseDto>> {
            return localVarFp.getAllProjectsByOwnerNameUsingGET(ownerName, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Call retrieves project details by User Id for ALL projects in the EFT Project Database, please provide project owner id as parameter when calling this API
         * @param {number} projectOwnerId projectOwnerId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectsByUserIdUsingGET(projectOwnerId: number, authorization?: string, options?: any): AxiosPromise<Array<EftGetProjectReponseDto>> {
            return localVarFp.getAllProjectsByUserIdUsingGET(projectOwnerId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Call retrieves project details for ALL projects in the EFT Project Database, no parameter needed
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectsUsingGET(authorization?: string, options?: any): AxiosPromise<Array<EftGetProjectReponseDto>> {
            return localVarFp.getAllProjectsUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Call retrieves project details by User Id for ALL projects in the EFT Project Database, please provide project owner id as parameter when calling this API
         * @param {string} ownerName ownerName
         * @param {number} [status] status
         * @param {number} [type] type
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredProjectsUsingGET(ownerName: string, status?: number, type?: number, authorization?: string, options?: any): AxiosPromise<Array<EftGetProjectReponseDto>> {
            return localVarFp.getFilteredProjectsUsingGET(ownerName, status, type, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This call will return Hydro Project Metadata information
         * @param {HydroProjectMetadataReqDTO} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHydroProjectMetadataUsingPOST(req: HydroProjectMetadataReqDTO, authorization?: string, options?: any): AxiosPromise<HydroProjectMetadataRespDTO> {
            return localVarFp.getHydroProjectMetadataUsingPOST(req, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Call retrieves project details by User Id for ALL projects in the EFT Project Database, please provide project owner id as parameter when calling this API
         * @param {string} ownerName ownerName
         * @param {number} [size] size
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestProjectsForUserUsingGET(ownerName: string, size?: number, authorization?: string, options?: any): AxiosPromise<Array<EftGetProjectReponseDto>> {
            return localVarFp.getLatestProjectsForUserUsingGET(ownerName, size, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Call retrieves project details by the ProjectUuid, please provide projectUuid as parameter when calling this API
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectByIdUsingGET(projectUuid: string, authorization?: string, options?: any): AxiosPromise<EftGetProjectReponseDto> {
            return localVarFp.getProjectByIdUsingGET(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This call will return EFT Project Count group by EFT Project Owner Id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectCountUsingGET(authorization?: string, options?: any): AxiosPromise<Array<EftProjectCountDto>> {
            return localVarFp.getProjectCountUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Call retrieves projects owner and their projects count
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectsWithCountByOwnerUsingGET(authorization?: string, options?: any): AxiosPromise<Array<ProjectsWithCount>> {
            return localVarFp.getProjectsWithCountByOwnerUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is getting TR20 results by project and return them to FE in Json String
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTR20ResultsJsonByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.getTR20ResultsJsonByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary softDeleteProject
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softDeleteProjectUsingDELETE(projectUuid: string, authorization?: string, options?: any): AxiosPromise<EftStatusResponse> {
            return localVarFp.softDeleteProjectUsingDELETE(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Call Permanently deletes a project, session, and associated session resources by projectUuid. Please provide project uuid when calling this API This call is permanent and should only be used in development and testing  
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trueDeleteProjectByProjectUuidUsingDELETE(projectUuid: string, authorization?: string, options?: any): AxiosPromise<EftStatusResponse> {
            return localVarFp.trueDeleteProjectByProjectUuidUsingDELETE(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is updating project\'s Last Changed Date
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLastChangedDateForProjectByProjectUuidUsingPOST(projectUuid: string, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.updateLastChangedDateForProjectByProjectUuidUsingPOST(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is updating project\'s Last Changed Date
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLastChangedDateForProjectBySessionUuidUsingPOST(sessionUuid: string, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.updateLastChangedDateForProjectBySessionUuidUsingPOST(sessionUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service updates project(s) owner to the coreUserId from the given request. Request might contain one or list of projects
         * @param {EftProjectUpdateOwnerReqDto} eftProjectUpdateOwnerReqDto eftProjectUpdateOwnerReqDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectOwnerUsingPOST(eftProjectUpdateOwnerReqDto: EftProjectUpdateOwnerReqDto, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.updateProjectOwnerUsingPOST(eftProjectUpdateOwnerReqDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is updating project\'s projection text
         * @param {EftProjectProjectionTextDto} eftProjectProjectionTextDto eftProjectProjectionTextDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectProjectionTextUsingPOST(eftProjectProjectionTextDto: EftProjectProjectionTextDto, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.updateProjectProjectionTextUsingPOST(eftProjectProjectionTextDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Call updates an existing project record in DB, please provide req body when calling this API
         * @param {EftProjectUpdateDto} projectUpdate projectUpdate
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectUsingPOST(projectUpdate: EftProjectUpdateDto, authorization?: string, options?: any): AxiosPromise<EftProjectUpdateResponseDto> {
            return localVarFp.updateProjectUsingPOST(projectUpdate, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is updating project\'s State and County
         * @param {EftProjectStateCountyProjectDto} eftProjectStateCountyProjectionDto eftProjectStateCountyProjectionDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStateCountyByProjectUuidUsingPOST(eftProjectStateCountyProjectionDto: EftProjectStateCountyProjectDto, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.updateStateCountyByProjectUuidUsingPOST(eftProjectStateCountyProjectionDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is updating project\'s projection text
         * @param {EftProjectUserInputNotesDTO} eftProjectUserInputNotesDTO eftProjectUserInputNotesDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserInputNotesByProjectUuidUsingPOST(eftProjectUserInputNotesDTO: EftProjectUserInputNotesDTO, authorization?: string, options?: any): AxiosPromise<object> {
            return localVarFp.updateUserInputNotesByProjectUuidUsingPOST(eftProjectUserInputNotesDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EftProjectControllerApi - object-oriented interface
 * @export
 * @class EftProjectControllerApi
 * @extends {BaseAPI}
 */
export class EftProjectControllerApi extends BaseAPI {
    /**
     * 
     * @summary This API Call Creates a NEW project record in DB with associated Session details, please provide req body when calling this API
     * @param {EftCreateProjectDto} createProjectDto createProjectDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public createProjectUsingPOST(createProjectDto: EftCreateProjectDto, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).createProjectUsingPOST(createProjectDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Call edits an existing project record in DB, please provide req body when calling this API
     * @param {EftProjectEditDto} editProjectSummary editProjectSummary
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public editProjectSummaryUsingPOST(editProjectSummary: EftProjectEditDto, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).editProjectSummaryUsingPOST(editProjectSummary, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Call edits an existing project record in DB, please provide req body when calling this API
     * @param {EftProjectEditDto} editProject editProject
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public editProjectUsingPOST(editProject: EftProjectEditDto, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).editProjectUsingPOST(editProject, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is finding state plane zone info
     * @param {StatePlaneZoneRequest} statePlaneZoneRequest statePlaneZoneRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public findStatePlaneZoneByLatLongUsingPOST(statePlaneZoneRequest: StatePlaneZoneRequest, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).findStatePlaneZoneByLatLongUsingPOST(statePlaneZoneRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllProjectsByOwnerName
     * @param {string} ownerName ownerName
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public getAllProjectsByOwnerNameUsingGET(ownerName: string, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).getAllProjectsByOwnerNameUsingGET(ownerName, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Call retrieves project details by User Id for ALL projects in the EFT Project Database, please provide project owner id as parameter when calling this API
     * @param {number} projectOwnerId projectOwnerId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public getAllProjectsByUserIdUsingGET(projectOwnerId: number, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).getAllProjectsByUserIdUsingGET(projectOwnerId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Call retrieves project details for ALL projects in the EFT Project Database, no parameter needed
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public getAllProjectsUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).getAllProjectsUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Call retrieves project details by User Id for ALL projects in the EFT Project Database, please provide project owner id as parameter when calling this API
     * @param {string} ownerName ownerName
     * @param {number} [status] status
     * @param {number} [type] type
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public getFilteredProjectsUsingGET(ownerName: string, status?: number, type?: number, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).getFilteredProjectsUsingGET(ownerName, status, type, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This call will return Hydro Project Metadata information
     * @param {HydroProjectMetadataReqDTO} req req
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public getHydroProjectMetadataUsingPOST(req: HydroProjectMetadataReqDTO, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).getHydroProjectMetadataUsingPOST(req, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Call retrieves project details by User Id for ALL projects in the EFT Project Database, please provide project owner id as parameter when calling this API
     * @param {string} ownerName ownerName
     * @param {number} [size] size
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public getLatestProjectsForUserUsingGET(ownerName: string, size?: number, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).getLatestProjectsForUserUsingGET(ownerName, size, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Call retrieves project details by the ProjectUuid, please provide projectUuid as parameter when calling this API
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public getProjectByIdUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).getProjectByIdUsingGET(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This call will return EFT Project Count group by EFT Project Owner Id
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public getProjectCountUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).getProjectCountUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Call retrieves projects owner and their projects count
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public getProjectsWithCountByOwnerUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).getProjectsWithCountByOwnerUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is getting TR20 results by project and return them to FE in Json String
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public getTR20ResultsJsonByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).getTR20ResultsJsonByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary softDeleteProject
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public softDeleteProjectUsingDELETE(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).softDeleteProjectUsingDELETE(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Call Permanently deletes a project, session, and associated session resources by projectUuid. Please provide project uuid when calling this API This call is permanent and should only be used in development and testing  
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public trueDeleteProjectByProjectUuidUsingDELETE(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).trueDeleteProjectByProjectUuidUsingDELETE(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is updating project\'s Last Changed Date
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public updateLastChangedDateForProjectByProjectUuidUsingPOST(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).updateLastChangedDateForProjectByProjectUuidUsingPOST(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is updating project\'s Last Changed Date
     * @param {string} sessionUuid sessionUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public updateLastChangedDateForProjectBySessionUuidUsingPOST(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).updateLastChangedDateForProjectBySessionUuidUsingPOST(sessionUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service updates project(s) owner to the coreUserId from the given request. Request might contain one or list of projects
     * @param {EftProjectUpdateOwnerReqDto} eftProjectUpdateOwnerReqDto eftProjectUpdateOwnerReqDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public updateProjectOwnerUsingPOST(eftProjectUpdateOwnerReqDto: EftProjectUpdateOwnerReqDto, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).updateProjectOwnerUsingPOST(eftProjectUpdateOwnerReqDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is updating project\'s projection text
     * @param {EftProjectProjectionTextDto} eftProjectProjectionTextDto eftProjectProjectionTextDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public updateProjectProjectionTextUsingPOST(eftProjectProjectionTextDto: EftProjectProjectionTextDto, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).updateProjectProjectionTextUsingPOST(eftProjectProjectionTextDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Call updates an existing project record in DB, please provide req body when calling this API
     * @param {EftProjectUpdateDto} projectUpdate projectUpdate
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public updateProjectUsingPOST(projectUpdate: EftProjectUpdateDto, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).updateProjectUsingPOST(projectUpdate, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is updating project\'s State and County
     * @param {EftProjectStateCountyProjectDto} eftProjectStateCountyProjectionDto eftProjectStateCountyProjectionDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public updateStateCountyByProjectUuidUsingPOST(eftProjectStateCountyProjectionDto: EftProjectStateCountyProjectDto, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).updateStateCountyByProjectUuidUsingPOST(eftProjectStateCountyProjectionDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is updating project\'s projection text
     * @param {EftProjectUserInputNotesDTO} eftProjectUserInputNotesDTO eftProjectUserInputNotesDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftProjectControllerApi
     */
    public updateUserInputNotesByProjectUuidUsingPOST(eftProjectUserInputNotesDTO: EftProjectUserInputNotesDTO, authorization?: string, options?: AxiosRequestConfig) {
        return EftProjectControllerApiFp(this.configuration).updateUserInputNotesByProjectUuidUsingPOST(eftProjectUserInputNotesDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EftSessionControllerApi - axios parameter creator
 * @export
 */
export const EftSessionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary addSessionResource
         * @param {EftAddSessionResourceRequest} resourceRequest resourceRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSessionResourceUsingPOST: async (resourceRequest: EftAddSessionResourceRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceRequest' is not null or undefined
            assertParamExists('addSessionResourceUsingPOST', 'resourceRequest', resourceRequest)
            const localVarPath = `/session/addSessionResources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resourceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary createEftSession
         * @param {EftSession} eftSession eftSession
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEftSessionUsingPOST: async (eftSession: EftSession, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eftSession' is not null or undefined
            assertParamExists('createEftSessionUsingPOST', 'eftSession', eftSession)
            const localVarPath = `/session/savesession`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eftSession, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteSession
         * @param {string} uuid uuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSessionUsingDELETE: async (uuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('deleteSessionUsingDELETE', 'uuid', uuid)
            const localVarPath = `/session/deleteSession/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllSessions
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSessionsUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/session/getAllsessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getSessionResourcesBySessionUuidAndTypeId
         * @param {string} sessionUuid sessionUuid
         * @param {number} resourceType resourceType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionResourcesBySessionUuidAndTypeIdUsingGET: async (sessionUuid: string, resourceType: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('getSessionResourcesBySessionUuidAndTypeIdUsingGET', 'sessionUuid', sessionUuid)
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('getSessionResourcesBySessionUuidAndTypeIdUsingGET', 'resourceType', resourceType)
            const localVarPath = `/session/getSessionResourceBySessionUuidAndResourceType/{sessionUuid}/{resourceType}`
                .replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)))
                .replace(`{${"resourceType"}}`, encodeURIComponent(String(resourceType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getSessionResources
         * @param {string} uuid uuid
         * @param {number} [resourceType] resourceType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionResourcesUsingGET: async (uuid: string, resourceType?: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getSessionResourcesUsingGET', 'uuid', uuid)
            const localVarPath = `/session/sessionResource/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (resourceType !== undefined) {
                localVarQueryParameter['resourceType'] = resourceType;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getSession
         * @param {string} uuid uuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionUsingGET: async (uuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getSessionUsingGET', 'uuid', uuid)
            const localVarPath = `/session/session/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateSessionByProjUuid
         * @param {EftSession} eftSession eftSession
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSessionByProjUuidUsingPOST: async (eftSession: EftSession, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eftSession' is not null or undefined
            assertParamExists('updateSessionByProjUuidUsingPOST', 'eftSession', eftSession)
            const localVarPath = `/session/updateSessionByProjUuid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eftSession, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateSessionResource
         * @param {UpdateSessionResourceDto} resourceUpdate resourceUpdate
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSessionResourceUsingPOST: async (resourceUpdate: UpdateSessionResourceDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceUpdate' is not null or undefined
            assertParamExists('updateSessionResourceUsingPOST', 'resourceUpdate', resourceUpdate)
            const localVarPath = `/session/updateSessionResource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resourceUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateSessionStep
         * @param {string} sessionId sessionId
         * @param {string} sessionStep sessionStep
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSessionStepUsingPOST: async (sessionId: string, sessionStep: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('updateSessionStepUsingPOST', 'sessionId', sessionId)
            // verify required parameter 'sessionStep' is not null or undefined
            assertParamExists('updateSessionStepUsingPOST', 'sessionStep', sessionStep)
            const localVarPath = `/session/{sessionId}/updateSessionStep/{sessionStep}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"sessionStep"}}`, encodeURIComponent(String(sessionStep)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateSession
         * @param {EftSession} eftSession eftSession
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSessionUsingPOST: async (eftSession: EftSession, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eftSession' is not null or undefined
            assertParamExists('updateSessionUsingPOST', 'eftSession', eftSession)
            const localVarPath = `/session/updatesession`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eftSession, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EftSessionControllerApi - functional programming interface
 * @export
 */
export const EftSessionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EftSessionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary addSessionResource
         * @param {EftAddSessionResourceRequest} resourceRequest resourceRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSessionResourceUsingPOST(resourceRequest: EftAddSessionResourceRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EftAddSessionResourceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSessionResourceUsingPOST(resourceRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary createEftSession
         * @param {EftSession} eftSession eftSession
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEftSessionUsingPOST(eftSession: EftSession, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EftSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEftSessionUsingPOST(eftSession, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteSession
         * @param {string} uuid uuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSessionUsingDELETE(uuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSessionUsingDELETE(uuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllSessions
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSessionsUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EftSession>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSessionsUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getSessionResourcesBySessionUuidAndTypeId
         * @param {string} sessionUuid sessionUuid
         * @param {number} resourceType resourceType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionResourcesBySessionUuidAndTypeIdUsingGET(sessionUuid: string, resourceType: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EftSessionResourceResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionResourcesBySessionUuidAndTypeIdUsingGET(sessionUuid, resourceType, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getSessionResources
         * @param {string} uuid uuid
         * @param {number} [resourceType] resourceType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionResourcesUsingGET(uuid: string, resourceType?: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EftSessionResourceResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionResourcesUsingGET(uuid, resourceType, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getSession
         * @param {string} uuid uuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionUsingGET(uuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EftSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionUsingGET(uuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateSessionByProjUuid
         * @param {EftSession} eftSession eftSession
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSessionByProjUuidUsingPOST(eftSession: EftSession, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSessionByProjUuidUsingPOST(eftSession, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateSessionResource
         * @param {UpdateSessionResourceDto} resourceUpdate resourceUpdate
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSessionResourceUsingPOST(resourceUpdate: UpdateSessionResourceDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EftSessionResourceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSessionResourceUsingPOST(resourceUpdate, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateSessionStep
         * @param {string} sessionId sessionId
         * @param {string} sessionStep sessionStep
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSessionStepUsingPOST(sessionId: string, sessionStep: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EftStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSessionStepUsingPOST(sessionId, sessionStep, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateSession
         * @param {EftSession} eftSession eftSession
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSessionUsingPOST(eftSession: EftSession, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EftSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSessionUsingPOST(eftSession, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EftSessionControllerApi - factory interface
 * @export
 */
export const EftSessionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EftSessionControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary addSessionResource
         * @param {EftAddSessionResourceRequest} resourceRequest resourceRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSessionResourceUsingPOST(resourceRequest: EftAddSessionResourceRequest, authorization?: string, options?: any): AxiosPromise<EftAddSessionResourceResponse> {
            return localVarFp.addSessionResourceUsingPOST(resourceRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary createEftSession
         * @param {EftSession} eftSession eftSession
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEftSessionUsingPOST(eftSession: EftSession, authorization?: string, options?: any): AxiosPromise<EftSession> {
            return localVarFp.createEftSessionUsingPOST(eftSession, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteSession
         * @param {string} uuid uuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSessionUsingDELETE(uuid: string, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteSessionUsingDELETE(uuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllSessions
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSessionsUsingGET(authorization?: string, options?: any): AxiosPromise<Array<EftSession>> {
            return localVarFp.getAllSessionsUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getSessionResourcesBySessionUuidAndTypeId
         * @param {string} sessionUuid sessionUuid
         * @param {number} resourceType resourceType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionResourcesBySessionUuidAndTypeIdUsingGET(sessionUuid: string, resourceType: number, authorization?: string, options?: any): AxiosPromise<Array<EftSessionResourceResponseDto>> {
            return localVarFp.getSessionResourcesBySessionUuidAndTypeIdUsingGET(sessionUuid, resourceType, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getSessionResources
         * @param {string} uuid uuid
         * @param {number} [resourceType] resourceType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionResourcesUsingGET(uuid: string, resourceType?: number, authorization?: string, options?: any): AxiosPromise<Array<EftSessionResourceResponseDto>> {
            return localVarFp.getSessionResourcesUsingGET(uuid, resourceType, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getSession
         * @param {string} uuid uuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionUsingGET(uuid: string, authorization?: string, options?: any): AxiosPromise<EftSession> {
            return localVarFp.getSessionUsingGET(uuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateSessionByProjUuid
         * @param {EftSession} eftSession eftSession
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSessionByProjUuidUsingPOST(eftSession: EftSession, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.updateSessionByProjUuidUsingPOST(eftSession, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateSessionResource
         * @param {UpdateSessionResourceDto} resourceUpdate resourceUpdate
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSessionResourceUsingPOST(resourceUpdate: UpdateSessionResourceDto, authorization?: string, options?: any): AxiosPromise<EftSessionResourceResponseDto> {
            return localVarFp.updateSessionResourceUsingPOST(resourceUpdate, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateSessionStep
         * @param {string} sessionId sessionId
         * @param {string} sessionStep sessionStep
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSessionStepUsingPOST(sessionId: string, sessionStep: string, authorization?: string, options?: any): AxiosPromise<EftStatusResponse> {
            return localVarFp.updateSessionStepUsingPOST(sessionId, sessionStep, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateSession
         * @param {EftSession} eftSession eftSession
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSessionUsingPOST(eftSession: EftSession, authorization?: string, options?: any): AxiosPromise<EftSession> {
            return localVarFp.updateSessionUsingPOST(eftSession, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EftSessionControllerApi - object-oriented interface
 * @export
 * @class EftSessionControllerApi
 * @extends {BaseAPI}
 */
export class EftSessionControllerApi extends BaseAPI {
    /**
     * 
     * @summary addSessionResource
     * @param {EftAddSessionResourceRequest} resourceRequest resourceRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftSessionControllerApi
     */
    public addSessionResourceUsingPOST(resourceRequest: EftAddSessionResourceRequest, authorization?: string, options?: AxiosRequestConfig) {
        return EftSessionControllerApiFp(this.configuration).addSessionResourceUsingPOST(resourceRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary createEftSession
     * @param {EftSession} eftSession eftSession
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftSessionControllerApi
     */
    public createEftSessionUsingPOST(eftSession: EftSession, authorization?: string, options?: AxiosRequestConfig) {
        return EftSessionControllerApiFp(this.configuration).createEftSessionUsingPOST(eftSession, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteSession
     * @param {string} uuid uuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftSessionControllerApi
     */
    public deleteSessionUsingDELETE(uuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return EftSessionControllerApiFp(this.configuration).deleteSessionUsingDELETE(uuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllSessions
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftSessionControllerApi
     */
    public getAllSessionsUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return EftSessionControllerApiFp(this.configuration).getAllSessionsUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getSessionResourcesBySessionUuidAndTypeId
     * @param {string} sessionUuid sessionUuid
     * @param {number} resourceType resourceType
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftSessionControllerApi
     */
    public getSessionResourcesBySessionUuidAndTypeIdUsingGET(sessionUuid: string, resourceType: number, authorization?: string, options?: AxiosRequestConfig) {
        return EftSessionControllerApiFp(this.configuration).getSessionResourcesBySessionUuidAndTypeIdUsingGET(sessionUuid, resourceType, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getSessionResources
     * @param {string} uuid uuid
     * @param {number} [resourceType] resourceType
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftSessionControllerApi
     */
    public getSessionResourcesUsingGET(uuid: string, resourceType?: number, authorization?: string, options?: AxiosRequestConfig) {
        return EftSessionControllerApiFp(this.configuration).getSessionResourcesUsingGET(uuid, resourceType, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getSession
     * @param {string} uuid uuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftSessionControllerApi
     */
    public getSessionUsingGET(uuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return EftSessionControllerApiFp(this.configuration).getSessionUsingGET(uuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateSessionByProjUuid
     * @param {EftSession} eftSession eftSession
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftSessionControllerApi
     */
    public updateSessionByProjUuidUsingPOST(eftSession: EftSession, authorization?: string, options?: AxiosRequestConfig) {
        return EftSessionControllerApiFp(this.configuration).updateSessionByProjUuidUsingPOST(eftSession, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateSessionResource
     * @param {UpdateSessionResourceDto} resourceUpdate resourceUpdate
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftSessionControllerApi
     */
    public updateSessionResourceUsingPOST(resourceUpdate: UpdateSessionResourceDto, authorization?: string, options?: AxiosRequestConfig) {
        return EftSessionControllerApiFp(this.configuration).updateSessionResourceUsingPOST(resourceUpdate, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateSessionStep
     * @param {string} sessionId sessionId
     * @param {string} sessionStep sessionStep
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftSessionControllerApi
     */
    public updateSessionStepUsingPOST(sessionId: string, sessionStep: string, authorization?: string, options?: AxiosRequestConfig) {
        return EftSessionControllerApiFp(this.configuration).updateSessionStepUsingPOST(sessionId, sessionStep, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateSession
     * @param {EftSession} eftSession eftSession
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EftSessionControllerApi
     */
    public updateSessionUsingPOST(eftSession: EftSession, authorization?: string, options?: AxiosRequestConfig) {
        return EftSessionControllerApiFp(this.configuration).updateSessionUsingPOST(eftSession, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FeatureFlagServiceControllerApi - axios parameter creator
 * @export
 */
export const FeatureFlagServiceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Used to fetch all NETS Feature Flags
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetsFeatureFLagsUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/netsFeatureFlags/getAllNetsFeatureFlags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Used to fetch all NETS Feature Flags by Environment
         * @param {number} environmentId environmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlagsByEnvironmentUsingGET: async (environmentId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'environmentId' is not null or undefined
            assertParamExists('getFlagsByEnvironmentUsingGET', 'environmentId', environmentId)
            const localVarPath = `/netsFeatureFlags/getNetsFlags/{environmentId}`
                .replace(`{${"environmentId"}}`, encodeURIComponent(String(environmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeatureFlagServiceControllerApi - functional programming interface
 * @export
 */
export const FeatureFlagServiceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeatureFlagServiceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Used to fetch all NETS Feature Flags
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllNetsFeatureFLagsUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeatureFlagEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllNetsFeatureFLagsUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Used to fetch all NETS Feature Flags by Environment
         * @param {number} environmentId environmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFlagsByEnvironmentUsingGET(environmentId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeatureFlagEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFlagsByEnvironmentUsingGET(environmentId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FeatureFlagServiceControllerApi - factory interface
 * @export
 */
export const FeatureFlagServiceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeatureFlagServiceControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Used to fetch all NETS Feature Flags
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetsFeatureFLagsUsingGET(authorization?: string, options?: any): AxiosPromise<Array<FeatureFlagEntity>> {
            return localVarFp.getAllNetsFeatureFLagsUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Used to fetch all NETS Feature Flags by Environment
         * @param {number} environmentId environmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlagsByEnvironmentUsingGET(environmentId: number, authorization?: string, options?: any): AxiosPromise<Array<FeatureFlagEntity>> {
            return localVarFp.getFlagsByEnvironmentUsingGET(environmentId, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeatureFlagServiceControllerApi - object-oriented interface
 * @export
 * @class FeatureFlagServiceControllerApi
 * @extends {BaseAPI}
 */
export class FeatureFlagServiceControllerApi extends BaseAPI {
    /**
     * 
     * @summary Used to fetch all NETS Feature Flags
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagServiceControllerApi
     */
    public getAllNetsFeatureFLagsUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return FeatureFlagServiceControllerApiFp(this.configuration).getAllNetsFeatureFLagsUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Used to fetch all NETS Feature Flags by Environment
     * @param {number} environmentId environmentId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagServiceControllerApi
     */
    public getFlagsByEnvironmentUsingGET(environmentId: number, authorization?: string, options?: AxiosRequestConfig) {
        return FeatureFlagServiceControllerApiFp(this.configuration).getFlagsByEnvironmentUsingGET(environmentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FfsControllerApi - axios parameter creator
 * @export
 */
export const FfsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary flagRequest
         * @param {FlagRequest} flagRequest flagRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flagRequestUsingGET: async (flagRequest: FlagRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flagRequest' is not null or undefined
            assertParamExists('flagRequestUsingGET', 'flagRequest', flagRequest)
            const localVarPath = `/FeatureFlag/flagRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(flagRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary flagTest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flagTestUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/FeatureFlag/flagTest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllFlags
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFlagsUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/FeatureFlag/getAllFlags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary testCheck
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCheckUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/FeatureFlag/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FfsControllerApi - functional programming interface
 * @export
 */
export const FfsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FfsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary flagRequest
         * @param {FlagRequest} flagRequest flagRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async flagRequestUsingGET(flagRequest: FlagRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlagDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.flagRequestUsingGET(flagRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary flagTest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async flagTestUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlagDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.flagTestUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllFlags
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFlagsUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlagDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllFlagsUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary testCheck
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testCheckUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testCheckUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FfsControllerApi - factory interface
 * @export
 */
export const FfsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FfsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary flagRequest
         * @param {FlagRequest} flagRequest flagRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flagRequestUsingGET(flagRequest: FlagRequest, authorization?: string, options?: any): AxiosPromise<FlagDto> {
            return localVarFp.flagRequestUsingGET(flagRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary flagTest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flagTestUsingGET(authorization?: string, options?: any): AxiosPromise<FlagDto> {
            return localVarFp.flagTestUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllFlags
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFlagsUsingGET(authorization?: string, options?: any): AxiosPromise<FlagDto> {
            return localVarFp.getAllFlagsUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary testCheck
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCheckUsingGET(authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.testCheckUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FfsControllerApi - object-oriented interface
 * @export
 * @class FfsControllerApi
 * @extends {BaseAPI}
 */
export class FfsControllerApi extends BaseAPI {
    /**
     * 
     * @summary flagRequest
     * @param {FlagRequest} flagRequest flagRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FfsControllerApi
     */
    public flagRequestUsingGET(flagRequest: FlagRequest, authorization?: string, options?: AxiosRequestConfig) {
        return FfsControllerApiFp(this.configuration).flagRequestUsingGET(flagRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary flagTest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FfsControllerApi
     */
    public flagTestUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return FfsControllerApiFp(this.configuration).flagTestUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllFlags
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FfsControllerApi
     */
    public getAllFlagsUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return FfsControllerApiFp(this.configuration).getAllFlagsUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary testCheck
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FfsControllerApi
     */
    public testCheckUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return FfsControllerApiFp(this.configuration).testCheckUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GlossaryControllerApi - axios parameter creator
 * @export
 */
export const GlossaryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createGlossary
         * @param {GlossaryRequestDto} requestDtoJson requestDtoJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGlossaryUsingPOST: async (requestDtoJson: GlossaryRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestDtoJson' is not null or undefined
            assertParamExists('createGlossaryUsingPOST', 'requestDtoJson', requestDtoJson)
            const localVarPath = `/glossary/createGlossary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestDtoJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteGlossaryByGlossaryIds
         * @param {Array<number>} glossaryIds glossaryIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGlossaryByGlossaryIdsUsingPOST: async (glossaryIds: Array<number>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'glossaryIds' is not null or undefined
            assertParamExists('deleteGlossaryByGlossaryIdsUsingPOST', 'glossaryIds', glossaryIds)
            const localVarPath = `/glossary/deleteGlossaryByGlossaryIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(glossaryIds, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllGlossary
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGlossaryUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/glossary/getAllGlossaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getByCategory
         * @param {string} category category
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCategoryUsingGET: async (category: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('getByCategoryUsingGET', 'category', category)
            const localVarPath = `/glossary/getGlossaryEntitiesBy/{category}`
                .replace(`{${"category"}}`, encodeURIComponent(String(category)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getCategorySummary
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategorySummaryUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/glossary/getCategorySummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getGlossaryById
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlossaryByIdUsingGET: async (id: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getGlossaryByIdUsingGET', 'id', id)
            const localVarPath = `/glossary/getGlossaryById/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary performGlossaryLinkValidation
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        performGlossaryLinkValidationUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/glossary/performGlossaryLinkValidation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateGlossary
         * @param {GlossaryRequestDto} requestDtoJson requestDtoJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGlossaryUsingPUT: async (requestDtoJson: GlossaryRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestDtoJson' is not null or undefined
            assertParamExists('updateGlossaryUsingPUT', 'requestDtoJson', requestDtoJson)
            const localVarPath = `/glossary/updateGlossary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestDtoJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GlossaryControllerApi - functional programming interface
 * @export
 */
export const GlossaryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GlossaryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createGlossary
         * @param {GlossaryRequestDto} requestDtoJson requestDtoJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGlossaryUsingPOST(requestDtoJson: GlossaryRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlossaryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGlossaryUsingPOST(requestDtoJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteGlossaryByGlossaryIds
         * @param {Array<number>} glossaryIds glossaryIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGlossaryByGlossaryIdsUsingPOST(glossaryIds: Array<number>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGlossaryByGlossaryIdsUsingPOST(glossaryIds, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllGlossary
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllGlossaryUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GlossaryResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllGlossaryUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getByCategory
         * @param {string} category category
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByCategoryUsingGET(category: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GlossaryResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByCategoryUsingGET(category, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getCategorySummary
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategorySummaryUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GlossaryCategorySummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategorySummaryUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getGlossaryById
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGlossaryByIdUsingGET(id: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlossaryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGlossaryByIdUsingGET(id, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary performGlossaryLinkValidation
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async performGlossaryLinkValidationUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlossaryHelpValidationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.performGlossaryLinkValidationUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateGlossary
         * @param {GlossaryRequestDto} requestDtoJson requestDtoJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGlossaryUsingPUT(requestDtoJson: GlossaryRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlossaryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGlossaryUsingPUT(requestDtoJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GlossaryControllerApi - factory interface
 * @export
 */
export const GlossaryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GlossaryControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createGlossary
         * @param {GlossaryRequestDto} requestDtoJson requestDtoJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGlossaryUsingPOST(requestDtoJson: GlossaryRequestDto, authorization?: string, options?: any): AxiosPromise<GlossaryResponseDto> {
            return localVarFp.createGlossaryUsingPOST(requestDtoJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteGlossaryByGlossaryIds
         * @param {Array<number>} glossaryIds glossaryIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGlossaryByGlossaryIdsUsingPOST(glossaryIds: Array<number>, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteGlossaryByGlossaryIdsUsingPOST(glossaryIds, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllGlossary
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGlossaryUsingGET(authorization?: string, options?: any): AxiosPromise<Array<GlossaryResponseDto>> {
            return localVarFp.getAllGlossaryUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getByCategory
         * @param {string} category category
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCategoryUsingGET(category: string, authorization?: string, options?: any): AxiosPromise<Array<GlossaryResponseDto>> {
            return localVarFp.getByCategoryUsingGET(category, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getCategorySummary
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategorySummaryUsingGET(authorization?: string, options?: any): AxiosPromise<Array<GlossaryCategorySummaryDto>> {
            return localVarFp.getCategorySummaryUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getGlossaryById
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlossaryByIdUsingGET(id: number, authorization?: string, options?: any): AxiosPromise<GlossaryResponseDto> {
            return localVarFp.getGlossaryByIdUsingGET(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary performGlossaryLinkValidation
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        performGlossaryLinkValidationUsingGET(authorization?: string, options?: any): AxiosPromise<GlossaryHelpValidationDto> {
            return localVarFp.performGlossaryLinkValidationUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateGlossary
         * @param {GlossaryRequestDto} requestDtoJson requestDtoJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGlossaryUsingPUT(requestDtoJson: GlossaryRequestDto, authorization?: string, options?: any): AxiosPromise<GlossaryResponseDto> {
            return localVarFp.updateGlossaryUsingPUT(requestDtoJson, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GlossaryControllerApi - object-oriented interface
 * @export
 * @class GlossaryControllerApi
 * @extends {BaseAPI}
 */
export class GlossaryControllerApi extends BaseAPI {
    /**
     * 
     * @summary createGlossary
     * @param {GlossaryRequestDto} requestDtoJson requestDtoJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlossaryControllerApi
     */
    public createGlossaryUsingPOST(requestDtoJson: GlossaryRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return GlossaryControllerApiFp(this.configuration).createGlossaryUsingPOST(requestDtoJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteGlossaryByGlossaryIds
     * @param {Array<number>} glossaryIds glossaryIds
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlossaryControllerApi
     */
    public deleteGlossaryByGlossaryIdsUsingPOST(glossaryIds: Array<number>, authorization?: string, options?: AxiosRequestConfig) {
        return GlossaryControllerApiFp(this.configuration).deleteGlossaryByGlossaryIdsUsingPOST(glossaryIds, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllGlossary
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlossaryControllerApi
     */
    public getAllGlossaryUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return GlossaryControllerApiFp(this.configuration).getAllGlossaryUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getByCategory
     * @param {string} category category
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlossaryControllerApi
     */
    public getByCategoryUsingGET(category: string, authorization?: string, options?: AxiosRequestConfig) {
        return GlossaryControllerApiFp(this.configuration).getByCategoryUsingGET(category, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getCategorySummary
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlossaryControllerApi
     */
    public getCategorySummaryUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return GlossaryControllerApiFp(this.configuration).getCategorySummaryUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getGlossaryById
     * @param {number} id id
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlossaryControllerApi
     */
    public getGlossaryByIdUsingGET(id: number, authorization?: string, options?: AxiosRequestConfig) {
        return GlossaryControllerApiFp(this.configuration).getGlossaryByIdUsingGET(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary performGlossaryLinkValidation
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlossaryControllerApi
     */
    public performGlossaryLinkValidationUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return GlossaryControllerApiFp(this.configuration).performGlossaryLinkValidationUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateGlossary
     * @param {GlossaryRequestDto} requestDtoJson requestDtoJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlossaryControllerApi
     */
    public updateGlossaryUsingPUT(requestDtoJson: GlossaryRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return GlossaryControllerApiFp(this.configuration).updateGlossaryUsingPUT(requestDtoJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HealthCheckControllerApi - axios parameter creator
 * @export
 */
export const HealthCheckControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getHealthCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthCheckUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitoring/healthcheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthCheckControllerApi - functional programming interface
 * @export
 */
export const HealthCheckControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthCheckControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getHealthCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHealthCheckUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HealthCheckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHealthCheckUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HealthCheckControllerApi - factory interface
 * @export
 */
export const HealthCheckControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthCheckControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary getHealthCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthCheckUsingGET(options?: any): AxiosPromise<HealthCheckResponse> {
            return localVarFp.getHealthCheckUsingGET(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthCheckControllerApi - object-oriented interface
 * @export
 * @class HealthCheckControllerApi
 * @extends {BaseAPI}
 */
export class HealthCheckControllerApi extends BaseAPI {
    /**
     * 
     * @summary getHealthCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckControllerApi
     */
    public getHealthCheckUsingGET(options?: AxiosRequestConfig) {
        return HealthCheckControllerApiFp(this.configuration).getHealthCheckUsingGET(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LoggerControllerApi - axios parameter creator
 * @export
 */
export const LoggerControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary This service is used to log web api from GP Streamline.
         * @param {LoggerRequestDTO} loggerRequestDTO loggerRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logAppUsingPOST: async (loggerRequestDTO: LoggerRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loggerRequestDTO' is not null or undefined
            assertParamExists('logAppUsingPOST', 'loggerRequestDTO', loggerRequestDTO)
            const localVarPath = `/appErrLogger/logApp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loggerRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoggerControllerApi - functional programming interface
 * @export
 */
export const LoggerControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoggerControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary This service is used to log web api from GP Streamline.
         * @param {LoggerRequestDTO} loggerRequestDTO loggerRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logAppUsingPOST(loggerRequestDTO: LoggerRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logAppUsingPOST(loggerRequestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LoggerControllerApi - factory interface
 * @export
 */
export const LoggerControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoggerControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary This service is used to log web api from GP Streamline.
         * @param {LoggerRequestDTO} loggerRequestDTO loggerRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logAppUsingPOST(loggerRequestDTO: LoggerRequestDTO, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.logAppUsingPOST(loggerRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoggerControllerApi - object-oriented interface
 * @export
 * @class LoggerControllerApi
 * @extends {BaseAPI}
 */
export class LoggerControllerApi extends BaseAPI {
    /**
     * 
     * @summary This service is used to log web api from GP Streamline.
     * @param {LoggerRequestDTO} loggerRequestDTO loggerRequestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoggerControllerApi
     */
    public logAppUsingPOST(loggerRequestDTO: LoggerRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return LoggerControllerApiFp(this.configuration).logAppUsingPOST(loggerRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MessageControllerApi - axios parameter creator
 * @export
 */
export const MessageControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary sendMessage
         * @param {string} projectJson projectJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessageUsingPOST: async (projectJson: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectJson' is not null or undefined
            assertParamExists('sendMessageUsingPOST', 'projectJson', projectJson)
            const localVarPath = `/project/cleanup/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MessageControllerApi - functional programming interface
 * @export
 */
export const MessageControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MessageControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary sendMessage
         * @param {string} projectJson projectJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMessageUsingPOST(projectJson: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMessageUsingPOST(projectJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MessageControllerApi - factory interface
 * @export
 */
export const MessageControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MessageControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary sendMessage
         * @param {string} projectJson projectJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessageUsingPOST(projectJson: string, authorization?: string, options?: any): AxiosPromise<object> {
            return localVarFp.sendMessageUsingPOST(projectJson, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MessageControllerApi - object-oriented interface
 * @export
 * @class MessageControllerApi
 * @extends {BaseAPI}
 */
export class MessageControllerApi extends BaseAPI {
    /**
     * 
     * @summary sendMessage
     * @param {string} projectJson projectJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageControllerApi
     */
    public sendMessageUsingPOST(projectJson: string, authorization?: string, options?: AxiosRequestConfig) {
        return MessageControllerApiFp(this.configuration).sendMessageUsingPOST(projectJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MetadataControllerApi - axios parameter creator
 * @export
 */
export const MetadataControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getAllMetadata
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMetadataUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/metadata/getAllMetadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetadataControllerApi - functional programming interface
 * @export
 */
export const MetadataControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetadataControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getAllMetadata
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMetadataUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MetaDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllMetadataUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MetadataControllerApi - factory interface
 * @export
 */
export const MetadataControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetadataControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary getAllMetadata
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMetadataUsingGET(authorization?: string, options?: any): AxiosPromise<Array<MetaDataDto>> {
            return localVarFp.getAllMetadataUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MetadataControllerApi - object-oriented interface
 * @export
 * @class MetadataControllerApi
 * @extends {BaseAPI}
 */
export class MetadataControllerApi extends BaseAPI {
    /**
     * 
     * @summary getAllMetadata
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataControllerApi
     */
    public getAllMetadataUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return MetadataControllerApiFp(this.configuration).getAllMetadataUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MetadataImageControllerApi - axios parameter creator
 * @export
 */
export const MetadataImageControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getImage
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageUsingGET: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('getImageUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/image/getImage/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary uploadAOIImageBase64String
         * @param {string} projectUuid projectUuid
         * @param {string} aoiImageBase64String aoiImageBase64String
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAOIImageBase64StringUsingPOST: async (projectUuid: string, aoiImageBase64String: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('uploadAOIImageBase64StringUsingPOST', 'projectUuid', projectUuid)
            // verify required parameter 'aoiImageBase64String' is not null or undefined
            assertParamExists('uploadAOIImageBase64StringUsingPOST', 'aoiImageBase64String', aoiImageBase64String)
            const localVarPath = `/image/uploadAOIImageBase64String/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aoiImageBase64String, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to upload AOI file(s) for the given project UUID as multipart files.
         * @param {string} projectUuid projectUuid
         * @param {Array<any>} files files
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAOIImageMultipartFileUsingPOST: async (projectUuid: string, files: Array<any>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('uploadAOIImageMultipartFileUsingPOST', 'projectUuid', projectUuid)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('uploadAOIImageMultipartFileUsingPOST', 'files', files)
            const localVarPath = `/image/uploadAOIImageMultipartFile/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary uploadAOIImage
         * @param {string} projectUuid projectUuid
         * @param {string} imageDataUrl imageDataUrl
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAOIImageUsingPOST: async (projectUuid: string, imageDataUrl: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('uploadAOIImageUsingPOST', 'projectUuid', projectUuid)
            // verify required parameter 'imageDataUrl' is not null or undefined
            assertParamExists('uploadAOIImageUsingPOST', 'imageDataUrl', imageDataUrl)
            const localVarPath = `/image/uploadAOIImage/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(imageDataUrl, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary uploadHydrogrpahImageBase64String
         * @param {string} projectUuid projectUuid
         * @param {string} aoiImageBase64String aoiImageBase64String
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadHydrogrpahImageBase64StringUsingPOST: async (projectUuid: string, aoiImageBase64String: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('uploadHydrogrpahImageBase64StringUsingPOST', 'projectUuid', projectUuid)
            // verify required parameter 'aoiImageBase64String' is not null or undefined
            assertParamExists('uploadHydrogrpahImageBase64StringUsingPOST', 'aoiImageBase64String', aoiImageBase64String)
            const localVarPath = `/image/uploadHydrogrpahImageBase64String/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aoiImageBase64String, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary uploadImage
         * @param {string} projectUuid projectUuid
         * @param {any} image image
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImageUsingPOST: async (projectUuid: string, image: any, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('uploadImageUsingPOST', 'projectUuid', projectUuid)
            // verify required parameter 'image' is not null or undefined
            assertParamExists('uploadImageUsingPOST', 'image', image)
            const localVarPath = `/image/uploadImage/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetadataImageControllerApi - functional programming interface
 * @export
 */
export const MetadataImageControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetadataImageControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getImage
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImageUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImageUsingGET(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary uploadAOIImageBase64String
         * @param {string} projectUuid projectUuid
         * @param {string} aoiImageBase64String aoiImageBase64String
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAOIImageBase64StringUsingPOST(projectUuid: string, aoiImageBase64String: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAOIImageBase64StringUsingPOST(projectUuid, aoiImageBase64String, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to upload AOI file(s) for the given project UUID as multipart files.
         * @param {string} projectUuid projectUuid
         * @param {Array<any>} files files
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAOIImageMultipartFileUsingPOST(projectUuid: string, files: Array<any>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAOIImageMultipartFileUsingPOST(projectUuid, files, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary uploadAOIImage
         * @param {string} projectUuid projectUuid
         * @param {string} imageDataUrl imageDataUrl
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAOIImageUsingPOST(projectUuid: string, imageDataUrl: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAOIImageUsingPOST(projectUuid, imageDataUrl, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary uploadHydrogrpahImageBase64String
         * @param {string} projectUuid projectUuid
         * @param {string} aoiImageBase64String aoiImageBase64String
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadHydrogrpahImageBase64StringUsingPOST(projectUuid: string, aoiImageBase64String: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadHydrogrpahImageBase64StringUsingPOST(projectUuid, aoiImageBase64String, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary uploadImage
         * @param {string} projectUuid projectUuid
         * @param {any} image image
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadImageUsingPOST(projectUuid: string, image: any, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadImageUsingPOST(projectUuid, image, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MetadataImageControllerApi - factory interface
 * @export
 */
export const MetadataImageControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetadataImageControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary getImage
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageUsingGET(projectUuid: string, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.getImageUsingGET(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary uploadAOIImageBase64String
         * @param {string} projectUuid projectUuid
         * @param {string} aoiImageBase64String aoiImageBase64String
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAOIImageBase64StringUsingPOST(projectUuid: string, aoiImageBase64String: string, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.uploadAOIImageBase64StringUsingPOST(projectUuid, aoiImageBase64String, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to upload AOI file(s) for the given project UUID as multipart files.
         * @param {string} projectUuid projectUuid
         * @param {Array<any>} files files
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAOIImageMultipartFileUsingPOST(projectUuid: string, files: Array<any>, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.uploadAOIImageMultipartFileUsingPOST(projectUuid, files, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary uploadAOIImage
         * @param {string} projectUuid projectUuid
         * @param {string} imageDataUrl imageDataUrl
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAOIImageUsingPOST(projectUuid: string, imageDataUrl: string, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.uploadAOIImageUsingPOST(projectUuid, imageDataUrl, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary uploadHydrogrpahImageBase64String
         * @param {string} projectUuid projectUuid
         * @param {string} aoiImageBase64String aoiImageBase64String
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadHydrogrpahImageBase64StringUsingPOST(projectUuid: string, aoiImageBase64String: string, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.uploadHydrogrpahImageBase64StringUsingPOST(projectUuid, aoiImageBase64String, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary uploadImage
         * @param {string} projectUuid projectUuid
         * @param {any} image image
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImageUsingPOST(projectUuid: string, image: any, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.uploadImageUsingPOST(projectUuid, image, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MetadataImageControllerApi - object-oriented interface
 * @export
 * @class MetadataImageControllerApi
 * @extends {BaseAPI}
 */
export class MetadataImageControllerApi extends BaseAPI {
    /**
     * 
     * @summary getImage
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataImageControllerApi
     */
    public getImageUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return MetadataImageControllerApiFp(this.configuration).getImageUsingGET(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary uploadAOIImageBase64String
     * @param {string} projectUuid projectUuid
     * @param {string} aoiImageBase64String aoiImageBase64String
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataImageControllerApi
     */
    public uploadAOIImageBase64StringUsingPOST(projectUuid: string, aoiImageBase64String: string, authorization?: string, options?: AxiosRequestConfig) {
        return MetadataImageControllerApiFp(this.configuration).uploadAOIImageBase64StringUsingPOST(projectUuid, aoiImageBase64String, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to upload AOI file(s) for the given project UUID as multipart files.
     * @param {string} projectUuid projectUuid
     * @param {Array<any>} files files
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataImageControllerApi
     */
    public uploadAOIImageMultipartFileUsingPOST(projectUuid: string, files: Array<any>, authorization?: string, options?: AxiosRequestConfig) {
        return MetadataImageControllerApiFp(this.configuration).uploadAOIImageMultipartFileUsingPOST(projectUuid, files, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary uploadAOIImage
     * @param {string} projectUuid projectUuid
     * @param {string} imageDataUrl imageDataUrl
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataImageControllerApi
     */
    public uploadAOIImageUsingPOST(projectUuid: string, imageDataUrl: string, authorization?: string, options?: AxiosRequestConfig) {
        return MetadataImageControllerApiFp(this.configuration).uploadAOIImageUsingPOST(projectUuid, imageDataUrl, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary uploadHydrogrpahImageBase64String
     * @param {string} projectUuid projectUuid
     * @param {string} aoiImageBase64String aoiImageBase64String
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataImageControllerApi
     */
    public uploadHydrogrpahImageBase64StringUsingPOST(projectUuid: string, aoiImageBase64String: string, authorization?: string, options?: AxiosRequestConfig) {
        return MetadataImageControllerApiFp(this.configuration).uploadHydrogrpahImageBase64StringUsingPOST(projectUuid, aoiImageBase64String, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary uploadImage
     * @param {string} projectUuid projectUuid
     * @param {any} image image
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataImageControllerApi
     */
    public uploadImageUsingPOST(projectUuid: string, image: any, authorization?: string, options?: AxiosRequestConfig) {
        return MetadataImageControllerApiFp(this.configuration).uploadImageUsingPOST(projectUuid, image, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MonitoringControllerApi - axios parameter creator
 * @export
 */
export const MonitoringControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary healthCheck2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck2UsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitoring2/healthCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MonitoringControllerApi - functional programming interface
 * @export
 */
export const MonitoringControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MonitoringControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary healthCheck2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheck2UsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheck2UsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MonitoringControllerApi - factory interface
 * @export
 */
export const MonitoringControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MonitoringControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary healthCheck2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck2UsingGET(options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.healthCheck2UsingGET(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MonitoringControllerApi - object-oriented interface
 * @export
 * @class MonitoringControllerApi
 * @extends {BaseAPI}
 */
export class MonitoringControllerApi extends BaseAPI {
    /**
     * 
     * @summary healthCheck2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringControllerApi
     */
    public healthCheck2UsingGET(options?: AxiosRequestConfig) {
        return MonitoringControllerApiFp(this.configuration).healthCheck2UsingGET(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NetsPreferenceControllerApi - axios parameter creator
 * @export
 */
export const NetsPreferenceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary This service is used to create preference entries in bulk
         * @param {Array<NetsPreferenceDto>} netsPreferenceDtos netsPreferenceDtos
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreferenceBulkUsingPOST: async (netsPreferenceDtos: Array<NetsPreferenceDto>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'netsPreferenceDtos' is not null or undefined
            assertParamExists('createPreferenceBulkUsingPOST', 'netsPreferenceDtos', netsPreferenceDtos)
            const localVarPath = `/netsPreference/createPreferenceBulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(netsPreferenceDtos, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to create an entry for a net preference
         * @param {NetsPreferenceDto} netsPreferenceDto netsPreferenceDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreferenceUsingPOST: async (netsPreferenceDto: NetsPreferenceDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'netsPreferenceDto' is not null or undefined
            assertParamExists('createPreferenceUsingPOST', 'netsPreferenceDto', netsPreferenceDto)
            const localVarPath = `/netsPreference/createPreference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(netsPreferenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to hard-delete a given preference by a unique id. Unrecoverable
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePreferenceByIdUsingDELETE: async (id: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePreferenceByIdUsingDELETE', 'id', id)
            const localVarPath = `/netsPreference/deletePreferenceById/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to retrieve all available nets preferences
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPreferencesUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/netsPreference/getAllPreferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to retrieve a preference by a unique id
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferenceByIdUsingGET: async (id: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPreferenceByIdUsingGET', 'id', id)
            const localVarPath = `/netsPreference/getPreferenceById/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to retrieve Nets Preference Dto from preferenceScope and preferenceTypeKey
         * @param {number} preferenceScope preferenceScope
         * @param {number} preferenceTypeKey preferenceTypeKey
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferenceJsonByPreferenceScopeAndPreferenceKeyIdUsingGET: async (preferenceScope: number, preferenceTypeKey: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceScope' is not null or undefined
            assertParamExists('getPreferenceJsonByPreferenceScopeAndPreferenceKeyIdUsingGET', 'preferenceScope', preferenceScope)
            // verify required parameter 'preferenceTypeKey' is not null or undefined
            assertParamExists('getPreferenceJsonByPreferenceScopeAndPreferenceKeyIdUsingGET', 'preferenceTypeKey', preferenceTypeKey)
            const localVarPath = `/netsPreference/getPreferenceJsonByPreferenceScopeAndPreferenceKeyId/{preferenceScope}/{preferenceTypeKey}`
                .replace(`{${"preferenceScope"}}`, encodeURIComponent(String(preferenceScope)))
                .replace(`{${"preferenceTypeKey"}}`, encodeURIComponent(String(preferenceTypeKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to retrieve a list of preference type keys
         * @param {number} preferenceScope preferenceScope
         * @param {number} projectType projectType
         * @param {number} designElementType designElementType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferenceTypeKeyListByScopeAndProjectTypeAndDesignElementTypeUsingGET: async (preferenceScope: number, projectType: number, designElementType: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceScope' is not null or undefined
            assertParamExists('getPreferenceTypeKeyListByScopeAndProjectTypeAndDesignElementTypeUsingGET', 'preferenceScope', preferenceScope)
            // verify required parameter 'projectType' is not null or undefined
            assertParamExists('getPreferenceTypeKeyListByScopeAndProjectTypeAndDesignElementTypeUsingGET', 'projectType', projectType)
            // verify required parameter 'designElementType' is not null or undefined
            assertParamExists('getPreferenceTypeKeyListByScopeAndProjectTypeAndDesignElementTypeUsingGET', 'designElementType', designElementType)
            const localVarPath = `/netsPreference/getPreferenceTypeKeyListByScopeAndProjectTypeAndDesignElementType/{preferenceScope}/{projectType}/{designElementType}`
                .replace(`{${"preferenceScope"}}`, encodeURIComponent(String(preferenceScope)))
                .replace(`{${"projectType"}}`, encodeURIComponent(String(projectType)))
                .replace(`{${"designElementType"}}`, encodeURIComponent(String(designElementType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to recover a previously soft-deleted preference record by a unique id
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreSoftDeletePreferenceByIdUsingPUT: async (id: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('restoreSoftDeletePreferenceByIdUsingPUT', 'id', id)
            const localVarPath = `/netsPreference/restoreSoftDeletePreferenceById/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to soft-delete a given preference by a unique id. Recoverable
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPreferenceToDeleteUsingPUT: async (id: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setPreferenceToDeleteUsingPUT', 'id', id)
            const localVarPath = `/netsPreference/setPreferenceToDelete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to update a preference record by a unique id
         * @param {number} id id
         * @param {NetsPreferenceDto} netsPreferenceDto netsPreferenceDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreferenceByIdUsingPUT: async (id: number, netsPreferenceDto: NetsPreferenceDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePreferenceByIdUsingPUT', 'id', id)
            // verify required parameter 'netsPreferenceDto' is not null or undefined
            assertParamExists('updatePreferenceByIdUsingPUT', 'netsPreferenceDto', netsPreferenceDto)
            const localVarPath = `/netsPreference/updatePreferenceById/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(netsPreferenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to update the preference value json with the nets preference id
         * @param {number} preferenceKeyTypeId preferenceKeyTypeId
         * @param {string} preferenceValueJson preferenceValueJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreferenceValueJsonByIdUsingPOST: async (preferenceKeyTypeId: number, preferenceValueJson: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceKeyTypeId' is not null or undefined
            assertParamExists('updatePreferenceValueJsonByIdUsingPOST', 'preferenceKeyTypeId', preferenceKeyTypeId)
            // verify required parameter 'preferenceValueJson' is not null or undefined
            assertParamExists('updatePreferenceValueJsonByIdUsingPOST', 'preferenceValueJson', preferenceValueJson)
            const localVarPath = `/netsPreference/updatePreferenceValueJsonById/{preferenceKeyTypeId}`
                .replace(`{${"preferenceKeyTypeId"}}`, encodeURIComponent(String(preferenceKeyTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(preferenceValueJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NetsPreferenceControllerApi - functional programming interface
 * @export
 */
export const NetsPreferenceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NetsPreferenceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary This service is used to create preference entries in bulk
         * @param {Array<NetsPreferenceDto>} netsPreferenceDtos netsPreferenceDtos
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPreferenceBulkUsingPOST(netsPreferenceDtos: Array<NetsPreferenceDto>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NetsPreferenceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPreferenceBulkUsingPOST(netsPreferenceDtos, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to create an entry for a net preference
         * @param {NetsPreferenceDto} netsPreferenceDto netsPreferenceDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPreferenceUsingPOST(netsPreferenceDto: NetsPreferenceDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NetsPreferenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPreferenceUsingPOST(netsPreferenceDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to hard-delete a given preference by a unique id. Unrecoverable
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePreferenceByIdUsingDELETE(id: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePreferenceByIdUsingDELETE(id, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to retrieve all available nets preferences
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPreferencesUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NetsPreferenceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPreferencesUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to retrieve a preference by a unique id
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPreferenceByIdUsingGET(id: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NetsPreferenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPreferenceByIdUsingGET(id, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to retrieve Nets Preference Dto from preferenceScope and preferenceTypeKey
         * @param {number} preferenceScope preferenceScope
         * @param {number} preferenceTypeKey preferenceTypeKey
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPreferenceJsonByPreferenceScopeAndPreferenceKeyIdUsingGET(preferenceScope: number, preferenceTypeKey: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NetsPreferenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPreferenceJsonByPreferenceScopeAndPreferenceKeyIdUsingGET(preferenceScope, preferenceTypeKey, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to retrieve a list of preference type keys
         * @param {number} preferenceScope preferenceScope
         * @param {number} projectType projectType
         * @param {number} designElementType designElementType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPreferenceTypeKeyListByScopeAndProjectTypeAndDesignElementTypeUsingGET(preferenceScope: number, projectType: number, designElementType: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPreferenceTypeKeyListByScopeAndProjectTypeAndDesignElementTypeUsingGET(preferenceScope, projectType, designElementType, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to recover a previously soft-deleted preference record by a unique id
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreSoftDeletePreferenceByIdUsingPUT(id: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NetsPreferenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreSoftDeletePreferenceByIdUsingPUT(id, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to soft-delete a given preference by a unique id. Recoverable
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPreferenceToDeleteUsingPUT(id: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NetsPreferenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPreferenceToDeleteUsingPUT(id, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to update a preference record by a unique id
         * @param {number} id id
         * @param {NetsPreferenceDto} netsPreferenceDto netsPreferenceDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePreferenceByIdUsingPUT(id: number, netsPreferenceDto: NetsPreferenceDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NetsPreferenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePreferenceByIdUsingPUT(id, netsPreferenceDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to update the preference value json with the nets preference id
         * @param {number} preferenceKeyTypeId preferenceKeyTypeId
         * @param {string} preferenceValueJson preferenceValueJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePreferenceValueJsonByIdUsingPOST(preferenceKeyTypeId: number, preferenceValueJson: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePreferenceValueJsonByIdUsingPOST(preferenceKeyTypeId, preferenceValueJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NetsPreferenceControllerApi - factory interface
 * @export
 */
export const NetsPreferenceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NetsPreferenceControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary This service is used to create preference entries in bulk
         * @param {Array<NetsPreferenceDto>} netsPreferenceDtos netsPreferenceDtos
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreferenceBulkUsingPOST(netsPreferenceDtos: Array<NetsPreferenceDto>, authorization?: string, options?: any): AxiosPromise<Array<NetsPreferenceDto>> {
            return localVarFp.createPreferenceBulkUsingPOST(netsPreferenceDtos, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to create an entry for a net preference
         * @param {NetsPreferenceDto} netsPreferenceDto netsPreferenceDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreferenceUsingPOST(netsPreferenceDto: NetsPreferenceDto, authorization?: string, options?: any): AxiosPromise<NetsPreferenceDto> {
            return localVarFp.createPreferenceUsingPOST(netsPreferenceDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to hard-delete a given preference by a unique id. Unrecoverable
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePreferenceByIdUsingDELETE(id: number, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deletePreferenceByIdUsingDELETE(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to retrieve all available nets preferences
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPreferencesUsingGET(authorization?: string, options?: any): AxiosPromise<Array<NetsPreferenceDto>> {
            return localVarFp.getAllPreferencesUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to retrieve a preference by a unique id
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferenceByIdUsingGET(id: number, authorization?: string, options?: any): AxiosPromise<NetsPreferenceDto> {
            return localVarFp.getPreferenceByIdUsingGET(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to retrieve Nets Preference Dto from preferenceScope and preferenceTypeKey
         * @param {number} preferenceScope preferenceScope
         * @param {number} preferenceTypeKey preferenceTypeKey
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferenceJsonByPreferenceScopeAndPreferenceKeyIdUsingGET(preferenceScope: number, preferenceTypeKey: number, authorization?: string, options?: any): AxiosPromise<NetsPreferenceDto> {
            return localVarFp.getPreferenceJsonByPreferenceScopeAndPreferenceKeyIdUsingGET(preferenceScope, preferenceTypeKey, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to retrieve a list of preference type keys
         * @param {number} preferenceScope preferenceScope
         * @param {number} projectType projectType
         * @param {number} designElementType designElementType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferenceTypeKeyListByScopeAndProjectTypeAndDesignElementTypeUsingGET(preferenceScope: number, projectType: number, designElementType: number, authorization?: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getPreferenceTypeKeyListByScopeAndProjectTypeAndDesignElementTypeUsingGET(preferenceScope, projectType, designElementType, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to recover a previously soft-deleted preference record by a unique id
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreSoftDeletePreferenceByIdUsingPUT(id: number, authorization?: string, options?: any): AxiosPromise<NetsPreferenceDto> {
            return localVarFp.restoreSoftDeletePreferenceByIdUsingPUT(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to soft-delete a given preference by a unique id. Recoverable
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPreferenceToDeleteUsingPUT(id: number, authorization?: string, options?: any): AxiosPromise<NetsPreferenceDto> {
            return localVarFp.setPreferenceToDeleteUsingPUT(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to update a preference record by a unique id
         * @param {number} id id
         * @param {NetsPreferenceDto} netsPreferenceDto netsPreferenceDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreferenceByIdUsingPUT(id: number, netsPreferenceDto: NetsPreferenceDto, authorization?: string, options?: any): AxiosPromise<NetsPreferenceDto> {
            return localVarFp.updatePreferenceByIdUsingPUT(id, netsPreferenceDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to update the preference value json with the nets preference id
         * @param {number} preferenceKeyTypeId preferenceKeyTypeId
         * @param {string} preferenceValueJson preferenceValueJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreferenceValueJsonByIdUsingPOST(preferenceKeyTypeId: number, preferenceValueJson: string, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.updatePreferenceValueJsonByIdUsingPOST(preferenceKeyTypeId, preferenceValueJson, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NetsPreferenceControllerApi - object-oriented interface
 * @export
 * @class NetsPreferenceControllerApi
 * @extends {BaseAPI}
 */
export class NetsPreferenceControllerApi extends BaseAPI {
    /**
     * 
     * @summary This service is used to create preference entries in bulk
     * @param {Array<NetsPreferenceDto>} netsPreferenceDtos netsPreferenceDtos
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetsPreferenceControllerApi
     */
    public createPreferenceBulkUsingPOST(netsPreferenceDtos: Array<NetsPreferenceDto>, authorization?: string, options?: AxiosRequestConfig) {
        return NetsPreferenceControllerApiFp(this.configuration).createPreferenceBulkUsingPOST(netsPreferenceDtos, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to create an entry for a net preference
     * @param {NetsPreferenceDto} netsPreferenceDto netsPreferenceDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetsPreferenceControllerApi
     */
    public createPreferenceUsingPOST(netsPreferenceDto: NetsPreferenceDto, authorization?: string, options?: AxiosRequestConfig) {
        return NetsPreferenceControllerApiFp(this.configuration).createPreferenceUsingPOST(netsPreferenceDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to hard-delete a given preference by a unique id. Unrecoverable
     * @param {number} id id
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetsPreferenceControllerApi
     */
    public deletePreferenceByIdUsingDELETE(id: number, authorization?: string, options?: AxiosRequestConfig) {
        return NetsPreferenceControllerApiFp(this.configuration).deletePreferenceByIdUsingDELETE(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to retrieve all available nets preferences
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetsPreferenceControllerApi
     */
    public getAllPreferencesUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return NetsPreferenceControllerApiFp(this.configuration).getAllPreferencesUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to retrieve a preference by a unique id
     * @param {number} id id
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetsPreferenceControllerApi
     */
    public getPreferenceByIdUsingGET(id: number, authorization?: string, options?: AxiosRequestConfig) {
        return NetsPreferenceControllerApiFp(this.configuration).getPreferenceByIdUsingGET(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to retrieve Nets Preference Dto from preferenceScope and preferenceTypeKey
     * @param {number} preferenceScope preferenceScope
     * @param {number} preferenceTypeKey preferenceTypeKey
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetsPreferenceControllerApi
     */
    public getPreferenceJsonByPreferenceScopeAndPreferenceKeyIdUsingGET(preferenceScope: number, preferenceTypeKey: number, authorization?: string, options?: AxiosRequestConfig) {
        return NetsPreferenceControllerApiFp(this.configuration).getPreferenceJsonByPreferenceScopeAndPreferenceKeyIdUsingGET(preferenceScope, preferenceTypeKey, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to retrieve a list of preference type keys
     * @param {number} preferenceScope preferenceScope
     * @param {number} projectType projectType
     * @param {number} designElementType designElementType
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetsPreferenceControllerApi
     */
    public getPreferenceTypeKeyListByScopeAndProjectTypeAndDesignElementTypeUsingGET(preferenceScope: number, projectType: number, designElementType: number, authorization?: string, options?: AxiosRequestConfig) {
        return NetsPreferenceControllerApiFp(this.configuration).getPreferenceTypeKeyListByScopeAndProjectTypeAndDesignElementTypeUsingGET(preferenceScope, projectType, designElementType, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to recover a previously soft-deleted preference record by a unique id
     * @param {number} id id
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetsPreferenceControllerApi
     */
    public restoreSoftDeletePreferenceByIdUsingPUT(id: number, authorization?: string, options?: AxiosRequestConfig) {
        return NetsPreferenceControllerApiFp(this.configuration).restoreSoftDeletePreferenceByIdUsingPUT(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to soft-delete a given preference by a unique id. Recoverable
     * @param {number} id id
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetsPreferenceControllerApi
     */
    public setPreferenceToDeleteUsingPUT(id: number, authorization?: string, options?: AxiosRequestConfig) {
        return NetsPreferenceControllerApiFp(this.configuration).setPreferenceToDeleteUsingPUT(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to update a preference record by a unique id
     * @param {number} id id
     * @param {NetsPreferenceDto} netsPreferenceDto netsPreferenceDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetsPreferenceControllerApi
     */
    public updatePreferenceByIdUsingPUT(id: number, netsPreferenceDto: NetsPreferenceDto, authorization?: string, options?: AxiosRequestConfig) {
        return NetsPreferenceControllerApiFp(this.configuration).updatePreferenceByIdUsingPUT(id, netsPreferenceDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to update the preference value json with the nets preference id
     * @param {number} preferenceKeyTypeId preferenceKeyTypeId
     * @param {string} preferenceValueJson preferenceValueJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetsPreferenceControllerApi
     */
    public updatePreferenceValueJsonByIdUsingPOST(preferenceKeyTypeId: number, preferenceValueJson: string, authorization?: string, options?: AxiosRequestConfig) {
        return NetsPreferenceControllerApiFp(this.configuration).updatePreferenceValueJsonByIdUsingPOST(preferenceKeyTypeId, preferenceValueJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProjectAttachmentControllerApi - axios parameter creator
 * @export
 */
export const ProjectAttachmentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createProjectAttachmentsByProjectUuid
         * @param {Array<ProjectAttachmentDto>} projectAttachmentsJson projectAttachmentsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectAttachmentsByProjectUuidUsingPOST: async (projectAttachmentsJson: Array<ProjectAttachmentDto>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectAttachmentsJson' is not null or undefined
            assertParamExists('createProjectAttachmentsByProjectUuidUsingPOST', 'projectAttachmentsJson', projectAttachmentsJson)
            const localVarPath = `/project/createProjectAttachmentsByProjectUuid/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectAttachmentsJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteProjectAttachmentsByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectAttachmentsByProjectUuidUsingGET: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('deleteProjectAttachmentsByProjectUuidUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/project/deleteProjectAttachmentsByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getProjectAttachmentsByOwnerName
         * @param {string} ownerName ownerName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectAttachmentsByOwnerNameUsingGET: async (ownerName: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ownerName' is not null or undefined
            assertParamExists('getProjectAttachmentsByOwnerNameUsingGET', 'ownerName', ownerName)
            const localVarPath = `/project/getProjectAttachmentsByOwnerName/{ownerName}`
                .replace(`{${"ownerName"}}`, encodeURIComponent(String(ownerName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getProjectAttachmentsByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectAttachmentsByProjectUuidUsingGET: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('getProjectAttachmentsByProjectUuidUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/project/getProjectAttachmentsByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateProjectAttachmentsByProjectUuid
         * @param {Array<ProjectAttachmentDto>} projectAttachmentsJson projectAttachmentsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectAttachmentsByProjectUuidUsingPOST: async (projectAttachmentsJson: Array<ProjectAttachmentDto>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectAttachmentsJson' is not null or undefined
            assertParamExists('updateProjectAttachmentsByProjectUuidUsingPOST', 'projectAttachmentsJson', projectAttachmentsJson)
            const localVarPath = `/project/updateProjectAttachmentsByProjectUuid/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectAttachmentsJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectAttachmentControllerApi - functional programming interface
 * @export
 */
export const ProjectAttachmentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectAttachmentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createProjectAttachmentsByProjectUuid
         * @param {Array<ProjectAttachmentDto>} projectAttachmentsJson projectAttachmentsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProjectAttachmentsByProjectUuidUsingPOST(projectAttachmentsJson: Array<ProjectAttachmentDto>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectAttachmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProjectAttachmentsByProjectUuidUsingPOST(projectAttachmentsJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteProjectAttachmentsByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProjectAttachmentsByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectAttachmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProjectAttachmentsByProjectUuidUsingGET(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getProjectAttachmentsByOwnerName
         * @param {string} ownerName ownerName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectAttachmentsByOwnerNameUsingGET(ownerName: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectAttachmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectAttachmentsByOwnerNameUsingGET(ownerName, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getProjectAttachmentsByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectAttachmentsByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectAttachmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectAttachmentsByProjectUuidUsingGET(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateProjectAttachmentsByProjectUuid
         * @param {Array<ProjectAttachmentDto>} projectAttachmentsJson projectAttachmentsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProjectAttachmentsByProjectUuidUsingPOST(projectAttachmentsJson: Array<ProjectAttachmentDto>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectAttachmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProjectAttachmentsByProjectUuidUsingPOST(projectAttachmentsJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProjectAttachmentControllerApi - factory interface
 * @export
 */
export const ProjectAttachmentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectAttachmentControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createProjectAttachmentsByProjectUuid
         * @param {Array<ProjectAttachmentDto>} projectAttachmentsJson projectAttachmentsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectAttachmentsByProjectUuidUsingPOST(projectAttachmentsJson: Array<ProjectAttachmentDto>, authorization?: string, options?: any): AxiosPromise<Array<ProjectAttachmentDto>> {
            return localVarFp.createProjectAttachmentsByProjectUuidUsingPOST(projectAttachmentsJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteProjectAttachmentsByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectAttachmentsByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: any): AxiosPromise<Array<ProjectAttachmentDto>> {
            return localVarFp.deleteProjectAttachmentsByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getProjectAttachmentsByOwnerName
         * @param {string} ownerName ownerName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectAttachmentsByOwnerNameUsingGET(ownerName: string, authorization?: string, options?: any): AxiosPromise<Array<ProjectAttachmentDto>> {
            return localVarFp.getProjectAttachmentsByOwnerNameUsingGET(ownerName, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getProjectAttachmentsByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectAttachmentsByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: any): AxiosPromise<Array<ProjectAttachmentDto>> {
            return localVarFp.getProjectAttachmentsByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateProjectAttachmentsByProjectUuid
         * @param {Array<ProjectAttachmentDto>} projectAttachmentsJson projectAttachmentsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectAttachmentsByProjectUuidUsingPOST(projectAttachmentsJson: Array<ProjectAttachmentDto>, authorization?: string, options?: any): AxiosPromise<Array<ProjectAttachmentDto>> {
            return localVarFp.updateProjectAttachmentsByProjectUuidUsingPOST(projectAttachmentsJson, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectAttachmentControllerApi - object-oriented interface
 * @export
 * @class ProjectAttachmentControllerApi
 * @extends {BaseAPI}
 */
export class ProjectAttachmentControllerApi extends BaseAPI {
    /**
     * 
     * @summary createProjectAttachmentsByProjectUuid
     * @param {Array<ProjectAttachmentDto>} projectAttachmentsJson projectAttachmentsJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectAttachmentControllerApi
     */
    public createProjectAttachmentsByProjectUuidUsingPOST(projectAttachmentsJson: Array<ProjectAttachmentDto>, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectAttachmentControllerApiFp(this.configuration).createProjectAttachmentsByProjectUuidUsingPOST(projectAttachmentsJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteProjectAttachmentsByProjectUuid
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectAttachmentControllerApi
     */
    public deleteProjectAttachmentsByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectAttachmentControllerApiFp(this.configuration).deleteProjectAttachmentsByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getProjectAttachmentsByOwnerName
     * @param {string} ownerName ownerName
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectAttachmentControllerApi
     */
    public getProjectAttachmentsByOwnerNameUsingGET(ownerName: string, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectAttachmentControllerApiFp(this.configuration).getProjectAttachmentsByOwnerNameUsingGET(ownerName, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getProjectAttachmentsByProjectUuid
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectAttachmentControllerApi
     */
    public getProjectAttachmentsByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectAttachmentControllerApiFp(this.configuration).getProjectAttachmentsByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateProjectAttachmentsByProjectUuid
     * @param {Array<ProjectAttachmentDto>} projectAttachmentsJson projectAttachmentsJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectAttachmentControllerApi
     */
    public updateProjectAttachmentsByProjectUuidUsingPOST(projectAttachmentsJson: Array<ProjectAttachmentDto>, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectAttachmentControllerApiFp(this.configuration).updateProjectAttachmentsByProjectUuidUsingPOST(projectAttachmentsJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProjectCommentControllerApi - axios parameter creator
 * @export
 */
export const ProjectCommentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createProjectCommentByProjectUuid
         * @param {ProjectCommentRequest} projectCommentDtoJson projectCommentDtoJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectCommentByProjectUuidUsingPOST: async (projectCommentDtoJson: ProjectCommentRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectCommentDtoJson' is not null or undefined
            assertParamExists('createProjectCommentByProjectUuidUsingPOST', 'projectCommentDtoJson', projectCommentDtoJson)
            const localVarPath = `/project/createProjectCommentByProjectUuid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectCommentDtoJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteProjectCommentsByProjectCommentIds
         * @param {ProjectCommentsDeleteRequest} projectCommentDtoListJson projectCommentDtoListJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectCommentsByProjectCommentIdsUsingPOST: async (projectCommentDtoListJson: ProjectCommentsDeleteRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectCommentDtoListJson' is not null or undefined
            assertParamExists('deleteProjectCommentsByProjectCommentIdsUsingPOST', 'projectCommentDtoListJson', projectCommentDtoListJson)
            const localVarPath = `/project/deleteProjectCommentsByProjectCommentIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectCommentDtoListJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary editProjectCommentByProjectCommentId
         * @param {ProjectCommentResponse} projectCommentDtoJson projectCommentDtoJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editProjectCommentByProjectCommentIdUsingPOST: async (projectCommentDtoJson: ProjectCommentResponse, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectCommentDtoJson' is not null or undefined
            assertParamExists('editProjectCommentByProjectCommentIdUsingPOST', 'projectCommentDtoJson', projectCommentDtoJson)
            const localVarPath = `/project/editProjectCommentByProjectCommentId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectCommentDtoJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getProjectCommentsByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectCommentsByProjectUuidUsingGET: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('getProjectCommentsByProjectUuidUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/project/getProjectCommentsByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectCommentControllerApi - functional programming interface
 * @export
 */
export const ProjectCommentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectCommentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createProjectCommentByProjectUuid
         * @param {ProjectCommentRequest} projectCommentDtoJson projectCommentDtoJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProjectCommentByProjectUuidUsingPOST(projectCommentDtoJson: ProjectCommentRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectCommentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProjectCommentByProjectUuidUsingPOST(projectCommentDtoJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteProjectCommentsByProjectCommentIds
         * @param {ProjectCommentsDeleteRequest} projectCommentDtoListJson projectCommentDtoListJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProjectCommentsByProjectCommentIdsUsingPOST(projectCommentDtoListJson: ProjectCommentsDeleteRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProjectCommentsByProjectCommentIdsUsingPOST(projectCommentDtoListJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary editProjectCommentByProjectCommentId
         * @param {ProjectCommentResponse} projectCommentDtoJson projectCommentDtoJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editProjectCommentByProjectCommentIdUsingPOST(projectCommentDtoJson: ProjectCommentResponse, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectCommentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editProjectCommentByProjectCommentIdUsingPOST(projectCommentDtoJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getProjectCommentsByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectCommentsByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectCommentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectCommentsByProjectUuidUsingGET(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProjectCommentControllerApi - factory interface
 * @export
 */
export const ProjectCommentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectCommentControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createProjectCommentByProjectUuid
         * @param {ProjectCommentRequest} projectCommentDtoJson projectCommentDtoJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectCommentByProjectUuidUsingPOST(projectCommentDtoJson: ProjectCommentRequest, authorization?: string, options?: any): AxiosPromise<ProjectCommentResponse> {
            return localVarFp.createProjectCommentByProjectUuidUsingPOST(projectCommentDtoJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteProjectCommentsByProjectCommentIds
         * @param {ProjectCommentsDeleteRequest} projectCommentDtoListJson projectCommentDtoListJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectCommentsByProjectCommentIdsUsingPOST(projectCommentDtoListJson: ProjectCommentsDeleteRequest, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteProjectCommentsByProjectCommentIdsUsingPOST(projectCommentDtoListJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary editProjectCommentByProjectCommentId
         * @param {ProjectCommentResponse} projectCommentDtoJson projectCommentDtoJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editProjectCommentByProjectCommentIdUsingPOST(projectCommentDtoJson: ProjectCommentResponse, authorization?: string, options?: any): AxiosPromise<ProjectCommentResponse> {
            return localVarFp.editProjectCommentByProjectCommentIdUsingPOST(projectCommentDtoJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getProjectCommentsByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectCommentsByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: any): AxiosPromise<Array<ProjectCommentResponse>> {
            return localVarFp.getProjectCommentsByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectCommentControllerApi - object-oriented interface
 * @export
 * @class ProjectCommentControllerApi
 * @extends {BaseAPI}
 */
export class ProjectCommentControllerApi extends BaseAPI {
    /**
     * 
     * @summary createProjectCommentByProjectUuid
     * @param {ProjectCommentRequest} projectCommentDtoJson projectCommentDtoJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectCommentControllerApi
     */
    public createProjectCommentByProjectUuidUsingPOST(projectCommentDtoJson: ProjectCommentRequest, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectCommentControllerApiFp(this.configuration).createProjectCommentByProjectUuidUsingPOST(projectCommentDtoJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteProjectCommentsByProjectCommentIds
     * @param {ProjectCommentsDeleteRequest} projectCommentDtoListJson projectCommentDtoListJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectCommentControllerApi
     */
    public deleteProjectCommentsByProjectCommentIdsUsingPOST(projectCommentDtoListJson: ProjectCommentsDeleteRequest, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectCommentControllerApiFp(this.configuration).deleteProjectCommentsByProjectCommentIdsUsingPOST(projectCommentDtoListJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary editProjectCommentByProjectCommentId
     * @param {ProjectCommentResponse} projectCommentDtoJson projectCommentDtoJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectCommentControllerApi
     */
    public editProjectCommentByProjectCommentIdUsingPOST(projectCommentDtoJson: ProjectCommentResponse, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectCommentControllerApiFp(this.configuration).editProjectCommentByProjectCommentIdUsingPOST(projectCommentDtoJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getProjectCommentsByProjectUuid
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectCommentControllerApi
     */
    public getProjectCommentsByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectCommentControllerApiFp(this.configuration).getProjectCommentsByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProjectElementCommentControllerApi - axios parameter creator
 * @export
 */
export const ProjectElementCommentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createProjectElementCommentByProjectUuid
         * @param {ProjectElementCommentRequest} projectElementCommentDtoJson projectElementCommentDtoJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectElementCommentByProjectUuidUsingPOST: async (projectElementCommentDtoJson: ProjectElementCommentRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectElementCommentDtoJson' is not null or undefined
            assertParamExists('createProjectElementCommentByProjectUuidUsingPOST', 'projectElementCommentDtoJson', projectElementCommentDtoJson)
            const localVarPath = `/project/createProjectElementCommentByProjectUuid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectElementCommentDtoJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to delete a project element comment record by Design Element Id
         * @param {number} designElementId designElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByDesignElementIdUsingDELETE: async (designElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designElementId' is not null or undefined
            assertParamExists('deleteByDesignElementIdUsingDELETE', 'designElementId', designElementId)
            const localVarPath = `/project/deleteCommentByDesignElementId/{designElementId}`
                .replace(`{${"designElementId"}}`, encodeURIComponent(String(designElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteProjectElementCommentsByProjectElementCommentIds
         * @param {ProjectElementCommentsDeleteRequest} projectElementCommentDtoListJson projectElementCommentDtoListJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectElementCommentsByProjectElementCommentIdsUsingPOST: async (projectElementCommentDtoListJson: ProjectElementCommentsDeleteRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectElementCommentDtoListJson' is not null or undefined
            assertParamExists('deleteProjectElementCommentsByProjectElementCommentIdsUsingPOST', 'projectElementCommentDtoListJson', projectElementCommentDtoListJson)
            const localVarPath = `/project/deleteProjectElementCommentsByProjectElementCommentIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectElementCommentDtoListJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary editProjectElementCommentByProjectElementCommentId
         * @param {ProjectElementCommentResponse} projectElementCommentDtoJson projectElementCommentDtoJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editProjectElementCommentByProjectElementCommentIdUsingPOST: async (projectElementCommentDtoJson: ProjectElementCommentResponse, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectElementCommentDtoJson' is not null or undefined
            assertParamExists('editProjectElementCommentByProjectElementCommentIdUsingPOST', 'projectElementCommentDtoJson', projectElementCommentDtoJson)
            const localVarPath = `/project/editProjectElementCommentByProjectElementCommentId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectElementCommentDtoJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getProjectElementCommentsByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectElementCommentsByProjectUuidUsingGET: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('getProjectElementCommentsByProjectUuidUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/project/getProjectElementCommentsByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectElementCommentControllerApi - functional programming interface
 * @export
 */
export const ProjectElementCommentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectElementCommentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createProjectElementCommentByProjectUuid
         * @param {ProjectElementCommentRequest} projectElementCommentDtoJson projectElementCommentDtoJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProjectElementCommentByProjectUuidUsingPOST(projectElementCommentDtoJson: ProjectElementCommentRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectElementCommentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProjectElementCommentByProjectUuidUsingPOST(projectElementCommentDtoJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to delete a project element comment record by Design Element Id
         * @param {number} designElementId designElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteByDesignElementIdUsingDELETE(designElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteByDesignElementIdUsingDELETE(designElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteProjectElementCommentsByProjectElementCommentIds
         * @param {ProjectElementCommentsDeleteRequest} projectElementCommentDtoListJson projectElementCommentDtoListJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProjectElementCommentsByProjectElementCommentIdsUsingPOST(projectElementCommentDtoListJson: ProjectElementCommentsDeleteRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProjectElementCommentsByProjectElementCommentIdsUsingPOST(projectElementCommentDtoListJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary editProjectElementCommentByProjectElementCommentId
         * @param {ProjectElementCommentResponse} projectElementCommentDtoJson projectElementCommentDtoJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editProjectElementCommentByProjectElementCommentIdUsingPOST(projectElementCommentDtoJson: ProjectElementCommentResponse, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectElementCommentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editProjectElementCommentByProjectElementCommentIdUsingPOST(projectElementCommentDtoJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getProjectElementCommentsByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectElementCommentsByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectElementCommentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectElementCommentsByProjectUuidUsingGET(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProjectElementCommentControllerApi - factory interface
 * @export
 */
export const ProjectElementCommentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectElementCommentControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createProjectElementCommentByProjectUuid
         * @param {ProjectElementCommentRequest} projectElementCommentDtoJson projectElementCommentDtoJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectElementCommentByProjectUuidUsingPOST(projectElementCommentDtoJson: ProjectElementCommentRequest, authorization?: string, options?: any): AxiosPromise<ProjectElementCommentResponse> {
            return localVarFp.createProjectElementCommentByProjectUuidUsingPOST(projectElementCommentDtoJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to delete a project element comment record by Design Element Id
         * @param {number} designElementId designElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByDesignElementIdUsingDELETE(designElementId: number, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteByDesignElementIdUsingDELETE(designElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteProjectElementCommentsByProjectElementCommentIds
         * @param {ProjectElementCommentsDeleteRequest} projectElementCommentDtoListJson projectElementCommentDtoListJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectElementCommentsByProjectElementCommentIdsUsingPOST(projectElementCommentDtoListJson: ProjectElementCommentsDeleteRequest, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteProjectElementCommentsByProjectElementCommentIdsUsingPOST(projectElementCommentDtoListJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary editProjectElementCommentByProjectElementCommentId
         * @param {ProjectElementCommentResponse} projectElementCommentDtoJson projectElementCommentDtoJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editProjectElementCommentByProjectElementCommentIdUsingPOST(projectElementCommentDtoJson: ProjectElementCommentResponse, authorization?: string, options?: any): AxiosPromise<ProjectElementCommentResponse> {
            return localVarFp.editProjectElementCommentByProjectElementCommentIdUsingPOST(projectElementCommentDtoJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getProjectElementCommentsByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectElementCommentsByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: any): AxiosPromise<Array<ProjectElementCommentResponse>> {
            return localVarFp.getProjectElementCommentsByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectElementCommentControllerApi - object-oriented interface
 * @export
 * @class ProjectElementCommentControllerApi
 * @extends {BaseAPI}
 */
export class ProjectElementCommentControllerApi extends BaseAPI {
    /**
     * 
     * @summary createProjectElementCommentByProjectUuid
     * @param {ProjectElementCommentRequest} projectElementCommentDtoJson projectElementCommentDtoJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectElementCommentControllerApi
     */
    public createProjectElementCommentByProjectUuidUsingPOST(projectElementCommentDtoJson: ProjectElementCommentRequest, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectElementCommentControllerApiFp(this.configuration).createProjectElementCommentByProjectUuidUsingPOST(projectElementCommentDtoJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to delete a project element comment record by Design Element Id
     * @param {number} designElementId designElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectElementCommentControllerApi
     */
    public deleteByDesignElementIdUsingDELETE(designElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectElementCommentControllerApiFp(this.configuration).deleteByDesignElementIdUsingDELETE(designElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteProjectElementCommentsByProjectElementCommentIds
     * @param {ProjectElementCommentsDeleteRequest} projectElementCommentDtoListJson projectElementCommentDtoListJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectElementCommentControllerApi
     */
    public deleteProjectElementCommentsByProjectElementCommentIdsUsingPOST(projectElementCommentDtoListJson: ProjectElementCommentsDeleteRequest, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectElementCommentControllerApiFp(this.configuration).deleteProjectElementCommentsByProjectElementCommentIdsUsingPOST(projectElementCommentDtoListJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary editProjectElementCommentByProjectElementCommentId
     * @param {ProjectElementCommentResponse} projectElementCommentDtoJson projectElementCommentDtoJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectElementCommentControllerApi
     */
    public editProjectElementCommentByProjectElementCommentIdUsingPOST(projectElementCommentDtoJson: ProjectElementCommentResponse, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectElementCommentControllerApiFp(this.configuration).editProjectElementCommentByProjectElementCommentIdUsingPOST(projectElementCommentDtoJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getProjectElementCommentsByProjectUuid
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectElementCommentControllerApi
     */
    public getProjectElementCommentsByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectElementCommentControllerApiFp(this.configuration).getProjectElementCommentsByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProjectStatusLogControllerApi - axios parameter creator
 * @export
 */
export const ProjectStatusLogControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createProjectStatusLogByProjectUuid
         * @param {ProjectStatusLogRequestDTO} projectStatusLogRequestJson projectStatusLogRequestJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectStatusLogByProjectUuidUsingPOST: async (projectStatusLogRequestJson: ProjectStatusLogRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectStatusLogRequestJson' is not null or undefined
            assertParamExists('createProjectStatusLogByProjectUuidUsingPOST', 'projectStatusLogRequestJson', projectStatusLogRequestJson)
            const localVarPath = `/projectStatusLog/createProjectStatusLogByProjectUuid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectStatusLogRequestJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectStatusLogControllerApi - functional programming interface
 * @export
 */
export const ProjectStatusLogControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectStatusLogControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createProjectStatusLogByProjectUuid
         * @param {ProjectStatusLogRequestDTO} projectStatusLogRequestJson projectStatusLogRequestJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProjectStatusLogByProjectUuidUsingPOST(projectStatusLogRequestJson: ProjectStatusLogRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectStatusLogResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProjectStatusLogByProjectUuidUsingPOST(projectStatusLogRequestJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProjectStatusLogControllerApi - factory interface
 * @export
 */
export const ProjectStatusLogControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectStatusLogControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createProjectStatusLogByProjectUuid
         * @param {ProjectStatusLogRequestDTO} projectStatusLogRequestJson projectStatusLogRequestJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectStatusLogByProjectUuidUsingPOST(projectStatusLogRequestJson: ProjectStatusLogRequestDTO, authorization?: string, options?: any): AxiosPromise<ProjectStatusLogResponseDTO> {
            return localVarFp.createProjectStatusLogByProjectUuidUsingPOST(projectStatusLogRequestJson, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectStatusLogControllerApi - object-oriented interface
 * @export
 * @class ProjectStatusLogControllerApi
 * @extends {BaseAPI}
 */
export class ProjectStatusLogControllerApi extends BaseAPI {
    /**
     * 
     * @summary createProjectStatusLogByProjectUuid
     * @param {ProjectStatusLogRequestDTO} projectStatusLogRequestJson projectStatusLogRequestJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectStatusLogControllerApi
     */
    public createProjectStatusLogByProjectUuidUsingPOST(projectStatusLogRequestJson: ProjectStatusLogRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectStatusLogControllerApiFp(this.configuration).createProjectStatusLogByProjectUuidUsingPOST(projectStatusLogRequestJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProjectionMetadataControllerApi - axios parameter creator
 * @export
 */
export const ProjectionMetadataControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary This API retrieves the distinct coordinate types available
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoordinateTypeListUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/projectionmetadata/getCoordinateTypeList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API determines the zone and projection name based on the input parameters coordinate  type and centroid  in case of stateplan xmin, xmax, ymin,ymax in case of UTM
         * @param {ProjectionMetadataReqDto} reqDTO reqDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectionByLocationUsingPOST: async (reqDTO: ProjectionMetadataReqDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reqDTO' is not null or undefined
            assertParamExists('getProjectionByLocationUsingPOST', 'reqDTO', reqDTO)
            const localVarPath = `/projectionmetadata/getProjectionByLocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reqDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectionMetadataControllerApi - functional programming interface
 * @export
 */
export const ProjectionMetadataControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectionMetadataControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary This API retrieves the distinct coordinate types available
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCoordinateTypeListUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCoordinateTypeListUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API determines the zone and projection name based on the input parameters coordinate  type and centroid  in case of stateplan xmin, xmax, ymin,ymax in case of UTM
         * @param {ProjectionMetadataReqDto} reqDTO reqDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectionByLocationUsingPOST(reqDTO: ProjectionMetadataReqDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectionMetadataRespDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectionByLocationUsingPOST(reqDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProjectionMetadataControllerApi - factory interface
 * @export
 */
export const ProjectionMetadataControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectionMetadataControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary This API retrieves the distinct coordinate types available
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoordinateTypeListUsingGET(authorization?: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getCoordinateTypeListUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API determines the zone and projection name based on the input parameters coordinate  type and centroid  in case of stateplan xmin, xmax, ymin,ymax in case of UTM
         * @param {ProjectionMetadataReqDto} reqDTO reqDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectionByLocationUsingPOST(reqDTO: ProjectionMetadataReqDto, authorization?: string, options?: any): AxiosPromise<Array<ProjectionMetadataRespDto>> {
            return localVarFp.getProjectionByLocationUsingPOST(reqDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectionMetadataControllerApi - object-oriented interface
 * @export
 * @class ProjectionMetadataControllerApi
 * @extends {BaseAPI}
 */
export class ProjectionMetadataControllerApi extends BaseAPI {
    /**
     * 
     * @summary This API retrieves the distinct coordinate types available
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectionMetadataControllerApi
     */
    public getCoordinateTypeListUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return ProjectionMetadataControllerApiFp(this.configuration).getCoordinateTypeListUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API determines the zone and projection name based on the input parameters coordinate  type and centroid  in case of stateplan xmin, xmax, ymin,ymax in case of UTM
     * @param {ProjectionMetadataReqDto} reqDTO reqDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectionMetadataControllerApi
     */
    public getProjectionByLocationUsingPOST(reqDTO: ProjectionMetadataReqDto, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectionMetadataControllerApiFp(this.configuration).getProjectionByLocationUsingPOST(reqDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProjectionMetadataCustomizedControllerApi - axios parameter creator
 * @export
 */
export const ProjectionMetadataCustomizedControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createProjectionMetadataCustomizeds
         * @param {Array<ProjectionMetadataCustomizedRequestDto>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectionMetadataCustomizedsUsingPOST: async (input: Array<ProjectionMetadataCustomizedRequestDto>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'input' is not null or undefined
            assertParamExists('createProjectionMetadataCustomizedsUsingPOST', 'input', input)
            const localVarPath = `/projectionmetadatacustomized/createProjectionMetadataCustomizeds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(input, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteProjectionMetadataCustomizedsByProjectionName
         * @param {string} projectionName projectionName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectionMetadataCustomizedsByProjectionNameUsingPOST: async (projectionName: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectionName' is not null or undefined
            assertParamExists('deleteProjectionMetadataCustomizedsByProjectionNameUsingPOST', 'projectionName', projectionName)
            const localVarPath = `/projectionmetadatacustomized/deleteProjectionMetadataCustomizedsByProjectionName/{projectionName}`
                .replace(`{${"projectionName"}}`, encodeURIComponent(String(projectionName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteProjectionMetadataCustomizedsBypProjectionMetadataCustomizedIds
         * @param {Array<number>} projectionMetadataCustomizedIds projectionMetadataCustomizedIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectionMetadataCustomizedsBypProjectionMetadataCustomizedIdsUsingPOST: async (projectionMetadataCustomizedIds: Array<number>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectionMetadataCustomizedIds' is not null or undefined
            assertParamExists('deleteProjectionMetadataCustomizedsBypProjectionMetadataCustomizedIdsUsingPOST', 'projectionMetadataCustomizedIds', projectionMetadataCustomizedIds)
            const localVarPath = `/projectionmetadatacustomized/deleteProjectionMetadataCustomizedsByProjectionMetadataCustomizedIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectionMetadataCustomizedIds, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllProjectionMetadataCustomizedWithInvalidWKTs
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectionMetadataCustomizedWithInvalidWKTsUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/projectionmetadatacustomized/getAllProjectionMetadataCustomizedWithInvalidWKTs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getProjectionMetadataCustomizedsByProjectionMetadataCustomizedIds
         * @param {Array<number>} projectionMetadataCustomizedIds projectionMetadataCustomizedIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectionMetadataCustomizedsByProjectionMetadataCustomizedIdsUsingGET: async (projectionMetadataCustomizedIds: Array<number>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectionMetadataCustomizedIds' is not null or undefined
            assertParamExists('getProjectionMetadataCustomizedsByProjectionMetadataCustomizedIdsUsingGET', 'projectionMetadataCustomizedIds', projectionMetadataCustomizedIds)
            const localVarPath = `/projectionmetadatacustomized/getProjectionMetadataCustomizedsByProjectionMetadataCustomizedIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectionMetadataCustomizedIds, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getProjectionMetadataCustomizedsByProjectionName
         * @param {string} projectionName projectionName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectionMetadataCustomizedsByProjectionNameUsingGET: async (projectionName: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectionName' is not null or undefined
            assertParamExists('getProjectionMetadataCustomizedsByProjectionNameUsingGET', 'projectionName', projectionName)
            const localVarPath = `/projectionmetadatacustomized/getProjectionMetadataCustomizedsByProjectionName/{projectionName}`
                .replace(`{${"projectionName"}}`, encodeURIComponent(String(projectionName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateOffsetStations
         * @param {Array<ProjectionMetadataCustomizedRequestDto>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOffsetStationsUsingPOST: async (input: Array<ProjectionMetadataCustomizedRequestDto>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'input' is not null or undefined
            assertParamExists('updateOffsetStationsUsingPOST', 'input', input)
            const localVarPath = `/projectionmetadatacustomized/updateProjectionMetadataCustomizeds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(input, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectionMetadataCustomizedControllerApi - functional programming interface
 * @export
 */
export const ProjectionMetadataCustomizedControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectionMetadataCustomizedControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createProjectionMetadataCustomizeds
         * @param {Array<ProjectionMetadataCustomizedRequestDto>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProjectionMetadataCustomizedsUsingPOST(input: Array<ProjectionMetadataCustomizedRequestDto>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectionMetadataCustomizedResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProjectionMetadataCustomizedsUsingPOST(input, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteProjectionMetadataCustomizedsByProjectionName
         * @param {string} projectionName projectionName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProjectionMetadataCustomizedsByProjectionNameUsingPOST(projectionName: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProjectionMetadataCustomizedsByProjectionNameUsingPOST(projectionName, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteProjectionMetadataCustomizedsBypProjectionMetadataCustomizedIds
         * @param {Array<number>} projectionMetadataCustomizedIds projectionMetadataCustomizedIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProjectionMetadataCustomizedsBypProjectionMetadataCustomizedIdsUsingPOST(projectionMetadataCustomizedIds: Array<number>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProjectionMetadataCustomizedsBypProjectionMetadataCustomizedIdsUsingPOST(projectionMetadataCustomizedIds, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllProjectionMetadataCustomizedWithInvalidWKTs
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProjectionMetadataCustomizedWithInvalidWKTsUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectionMetadataCustomizedResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProjectionMetadataCustomizedWithInvalidWKTsUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getProjectionMetadataCustomizedsByProjectionMetadataCustomizedIds
         * @param {Array<number>} projectionMetadataCustomizedIds projectionMetadataCustomizedIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectionMetadataCustomizedsByProjectionMetadataCustomizedIdsUsingGET(projectionMetadataCustomizedIds: Array<number>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectionMetadataCustomizedResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectionMetadataCustomizedsByProjectionMetadataCustomizedIdsUsingGET(projectionMetadataCustomizedIds, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getProjectionMetadataCustomizedsByProjectionName
         * @param {string} projectionName projectionName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectionMetadataCustomizedsByProjectionNameUsingGET(projectionName: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectionMetadataCustomizedResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectionMetadataCustomizedsByProjectionNameUsingGET(projectionName, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateOffsetStations
         * @param {Array<ProjectionMetadataCustomizedRequestDto>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOffsetStationsUsingPOST(input: Array<ProjectionMetadataCustomizedRequestDto>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectionMetadataCustomizedResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOffsetStationsUsingPOST(input, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProjectionMetadataCustomizedControllerApi - factory interface
 * @export
 */
export const ProjectionMetadataCustomizedControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectionMetadataCustomizedControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createProjectionMetadataCustomizeds
         * @param {Array<ProjectionMetadataCustomizedRequestDto>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectionMetadataCustomizedsUsingPOST(input: Array<ProjectionMetadataCustomizedRequestDto>, authorization?: string, options?: any): AxiosPromise<Array<ProjectionMetadataCustomizedResponseDto>> {
            return localVarFp.createProjectionMetadataCustomizedsUsingPOST(input, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteProjectionMetadataCustomizedsByProjectionName
         * @param {string} projectionName projectionName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectionMetadataCustomizedsByProjectionNameUsingPOST(projectionName: string, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteProjectionMetadataCustomizedsByProjectionNameUsingPOST(projectionName, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteProjectionMetadataCustomizedsBypProjectionMetadataCustomizedIds
         * @param {Array<number>} projectionMetadataCustomizedIds projectionMetadataCustomizedIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectionMetadataCustomizedsBypProjectionMetadataCustomizedIdsUsingPOST(projectionMetadataCustomizedIds: Array<number>, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteProjectionMetadataCustomizedsBypProjectionMetadataCustomizedIdsUsingPOST(projectionMetadataCustomizedIds, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllProjectionMetadataCustomizedWithInvalidWKTs
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectionMetadataCustomizedWithInvalidWKTsUsingGET(authorization?: string, options?: any): AxiosPromise<Array<ProjectionMetadataCustomizedResponseDto>> {
            return localVarFp.getAllProjectionMetadataCustomizedWithInvalidWKTsUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getProjectionMetadataCustomizedsByProjectionMetadataCustomizedIds
         * @param {Array<number>} projectionMetadataCustomizedIds projectionMetadataCustomizedIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectionMetadataCustomizedsByProjectionMetadataCustomizedIdsUsingGET(projectionMetadataCustomizedIds: Array<number>, authorization?: string, options?: any): AxiosPromise<Array<ProjectionMetadataCustomizedResponseDto>> {
            return localVarFp.getProjectionMetadataCustomizedsByProjectionMetadataCustomizedIdsUsingGET(projectionMetadataCustomizedIds, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getProjectionMetadataCustomizedsByProjectionName
         * @param {string} projectionName projectionName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectionMetadataCustomizedsByProjectionNameUsingGET(projectionName: string, authorization?: string, options?: any): AxiosPromise<Array<ProjectionMetadataCustomizedResponseDto>> {
            return localVarFp.getProjectionMetadataCustomizedsByProjectionNameUsingGET(projectionName, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateOffsetStations
         * @param {Array<ProjectionMetadataCustomizedRequestDto>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOffsetStationsUsingPOST(input: Array<ProjectionMetadataCustomizedRequestDto>, authorization?: string, options?: any): AxiosPromise<Array<ProjectionMetadataCustomizedResponseDto>> {
            return localVarFp.updateOffsetStationsUsingPOST(input, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectionMetadataCustomizedControllerApi - object-oriented interface
 * @export
 * @class ProjectionMetadataCustomizedControllerApi
 * @extends {BaseAPI}
 */
export class ProjectionMetadataCustomizedControllerApi extends BaseAPI {
    /**
     * 
     * @summary createProjectionMetadataCustomizeds
     * @param {Array<ProjectionMetadataCustomizedRequestDto>} input input
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectionMetadataCustomizedControllerApi
     */
    public createProjectionMetadataCustomizedsUsingPOST(input: Array<ProjectionMetadataCustomizedRequestDto>, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectionMetadataCustomizedControllerApiFp(this.configuration).createProjectionMetadataCustomizedsUsingPOST(input, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteProjectionMetadataCustomizedsByProjectionName
     * @param {string} projectionName projectionName
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectionMetadataCustomizedControllerApi
     */
    public deleteProjectionMetadataCustomizedsByProjectionNameUsingPOST(projectionName: string, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectionMetadataCustomizedControllerApiFp(this.configuration).deleteProjectionMetadataCustomizedsByProjectionNameUsingPOST(projectionName, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteProjectionMetadataCustomizedsBypProjectionMetadataCustomizedIds
     * @param {Array<number>} projectionMetadataCustomizedIds projectionMetadataCustomizedIds
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectionMetadataCustomizedControllerApi
     */
    public deleteProjectionMetadataCustomizedsBypProjectionMetadataCustomizedIdsUsingPOST(projectionMetadataCustomizedIds: Array<number>, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectionMetadataCustomizedControllerApiFp(this.configuration).deleteProjectionMetadataCustomizedsBypProjectionMetadataCustomizedIdsUsingPOST(projectionMetadataCustomizedIds, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllProjectionMetadataCustomizedWithInvalidWKTs
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectionMetadataCustomizedControllerApi
     */
    public getAllProjectionMetadataCustomizedWithInvalidWKTsUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return ProjectionMetadataCustomizedControllerApiFp(this.configuration).getAllProjectionMetadataCustomizedWithInvalidWKTsUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getProjectionMetadataCustomizedsByProjectionMetadataCustomizedIds
     * @param {Array<number>} projectionMetadataCustomizedIds projectionMetadataCustomizedIds
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectionMetadataCustomizedControllerApi
     */
    public getProjectionMetadataCustomizedsByProjectionMetadataCustomizedIdsUsingGET(projectionMetadataCustomizedIds: Array<number>, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectionMetadataCustomizedControllerApiFp(this.configuration).getProjectionMetadataCustomizedsByProjectionMetadataCustomizedIdsUsingGET(projectionMetadataCustomizedIds, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getProjectionMetadataCustomizedsByProjectionName
     * @param {string} projectionName projectionName
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectionMetadataCustomizedControllerApi
     */
    public getProjectionMetadataCustomizedsByProjectionNameUsingGET(projectionName: string, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectionMetadataCustomizedControllerApiFp(this.configuration).getProjectionMetadataCustomizedsByProjectionNameUsingGET(projectionName, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateOffsetStations
     * @param {Array<ProjectionMetadataCustomizedRequestDto>} input input
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectionMetadataCustomizedControllerApi
     */
    public updateOffsetStationsUsingPOST(input: Array<ProjectionMetadataCustomizedRequestDto>, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectionMetadataCustomizedControllerApiFp(this.configuration).updateOffsetStationsUsingPOST(input, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReleaseNoteControllerApi - axios parameter creator
 * @export
 */
export const ReleaseNoteControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary This service is used to create a new release note record.
         * @param {ReleaseNoteDto} releaseNoteDto releaseNoteDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewReleaseNoteUsingPOST: async (releaseNoteDto: ReleaseNoteDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'releaseNoteDto' is not null or undefined
            assertParamExists('createNewReleaseNoteUsingPOST', 'releaseNoteDto', releaseNoteDto)
            const localVarPath = `/releaseNotes/createReleaseNote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(releaseNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to create new release note records in bulk.
         * @param {Array<ReleaseNoteDto>} releaseNoteDtoList releaseNoteDtoList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewReleaseNotesUsingPOST: async (releaseNoteDtoList: Array<ReleaseNoteDto>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'releaseNoteDtoList' is not null or undefined
            assertParamExists('createNewReleaseNotesUsingPOST', 'releaseNoteDtoList', releaseNoteDtoList)
            const localVarPath = `/releaseNotes/createReleaseNoteBulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(releaseNoteDtoList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to delete a release note record by Id
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReleaseNoteByIdUsingDELETE: async (id: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteReleaseNoteByIdUsingDELETE', 'id', id)
            const localVarPath = `/releaseNotes/remove/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to retrieve all available release note records.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/releaseNotes/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to a release note record by Id.
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReleaseByIdUsingGET: async (id: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getReleaseByIdUsingGET', 'id', id)
            const localVarPath = `/releaseNotes/fetch/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to retrieve top 3 most recent release note records.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTop3ByReleaseDateUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/releaseNotes/getTopReleaseNotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to update a release note record by Id.
         * @param {number} id id
         * @param {ReleaseNoteDto} releaseNoteDto releaseNoteDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReleaseNoteUsingPOST: async (id: number, releaseNoteDto: ReleaseNoteDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateReleaseNoteUsingPOST', 'id', id)
            // verify required parameter 'releaseNoteDto' is not null or undefined
            assertParamExists('updateReleaseNoteUsingPOST', 'releaseNoteDto', releaseNoteDto)
            const localVarPath = `/releaseNotes/updateReleaseNote/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(releaseNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReleaseNoteControllerApi - functional programming interface
 * @export
 */
export const ReleaseNoteControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReleaseNoteControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary This service is used to create a new release note record.
         * @param {ReleaseNoteDto} releaseNoteDto releaseNoteDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNewReleaseNoteUsingPOST(releaseNoteDto: ReleaseNoteDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReleaseNoteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNewReleaseNoteUsingPOST(releaseNoteDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to create new release note records in bulk.
         * @param {Array<ReleaseNoteDto>} releaseNoteDtoList releaseNoteDtoList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNewReleaseNotesUsingPOST(releaseNoteDtoList: Array<ReleaseNoteDto>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReleaseNoteDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNewReleaseNotesUsingPOST(releaseNoteDtoList, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to delete a release note record by Id
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReleaseNoteByIdUsingDELETE(id: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReleaseNoteByIdUsingDELETE(id, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to retrieve all available release note records.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReleaseNoteDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to a release note record by Id.
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReleaseByIdUsingGET(id: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReleaseNoteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReleaseByIdUsingGET(id, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to retrieve top 3 most recent release note records.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTop3ByReleaseDateUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReleaseNoteDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTop3ByReleaseDateUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to update a release note record by Id.
         * @param {number} id id
         * @param {ReleaseNoteDto} releaseNoteDto releaseNoteDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReleaseNoteUsingPOST(id: number, releaseNoteDto: ReleaseNoteDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReleaseNoteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReleaseNoteUsingPOST(id, releaseNoteDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReleaseNoteControllerApi - factory interface
 * @export
 */
export const ReleaseNoteControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReleaseNoteControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary This service is used to create a new release note record.
         * @param {ReleaseNoteDto} releaseNoteDto releaseNoteDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewReleaseNoteUsingPOST(releaseNoteDto: ReleaseNoteDto, authorization?: string, options?: any): AxiosPromise<ReleaseNoteDto> {
            return localVarFp.createNewReleaseNoteUsingPOST(releaseNoteDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to create new release note records in bulk.
         * @param {Array<ReleaseNoteDto>} releaseNoteDtoList releaseNoteDtoList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewReleaseNotesUsingPOST(releaseNoteDtoList: Array<ReleaseNoteDto>, authorization?: string, options?: any): AxiosPromise<Array<ReleaseNoteDto>> {
            return localVarFp.createNewReleaseNotesUsingPOST(releaseNoteDtoList, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to delete a release note record by Id
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReleaseNoteByIdUsingDELETE(id: number, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteReleaseNoteByIdUsingDELETE(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to retrieve all available release note records.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsingGET(authorization?: string, options?: any): AxiosPromise<Array<ReleaseNoteDto>> {
            return localVarFp.getAllUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to a release note record by Id.
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReleaseByIdUsingGET(id: number, authorization?: string, options?: any): AxiosPromise<ReleaseNoteDto> {
            return localVarFp.getReleaseByIdUsingGET(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to retrieve top 3 most recent release note records.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTop3ByReleaseDateUsingGET(authorization?: string, options?: any): AxiosPromise<Array<ReleaseNoteDto>> {
            return localVarFp.getTop3ByReleaseDateUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to update a release note record by Id.
         * @param {number} id id
         * @param {ReleaseNoteDto} releaseNoteDto releaseNoteDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReleaseNoteUsingPOST(id: number, releaseNoteDto: ReleaseNoteDto, authorization?: string, options?: any): AxiosPromise<ReleaseNoteDto> {
            return localVarFp.updateReleaseNoteUsingPOST(id, releaseNoteDto, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReleaseNoteControllerApi - object-oriented interface
 * @export
 * @class ReleaseNoteControllerApi
 * @extends {BaseAPI}
 */
export class ReleaseNoteControllerApi extends BaseAPI {
    /**
     * 
     * @summary This service is used to create a new release note record.
     * @param {ReleaseNoteDto} releaseNoteDto releaseNoteDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReleaseNoteControllerApi
     */
    public createNewReleaseNoteUsingPOST(releaseNoteDto: ReleaseNoteDto, authorization?: string, options?: AxiosRequestConfig) {
        return ReleaseNoteControllerApiFp(this.configuration).createNewReleaseNoteUsingPOST(releaseNoteDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to create new release note records in bulk.
     * @param {Array<ReleaseNoteDto>} releaseNoteDtoList releaseNoteDtoList
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReleaseNoteControllerApi
     */
    public createNewReleaseNotesUsingPOST(releaseNoteDtoList: Array<ReleaseNoteDto>, authorization?: string, options?: AxiosRequestConfig) {
        return ReleaseNoteControllerApiFp(this.configuration).createNewReleaseNotesUsingPOST(releaseNoteDtoList, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to delete a release note record by Id
     * @param {number} id id
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReleaseNoteControllerApi
     */
    public deleteReleaseNoteByIdUsingDELETE(id: number, authorization?: string, options?: AxiosRequestConfig) {
        return ReleaseNoteControllerApiFp(this.configuration).deleteReleaseNoteByIdUsingDELETE(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to retrieve all available release note records.
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReleaseNoteControllerApi
     */
    public getAllUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return ReleaseNoteControllerApiFp(this.configuration).getAllUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to a release note record by Id.
     * @param {number} id id
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReleaseNoteControllerApi
     */
    public getReleaseByIdUsingGET(id: number, authorization?: string, options?: AxiosRequestConfig) {
        return ReleaseNoteControllerApiFp(this.configuration).getReleaseByIdUsingGET(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to retrieve top 3 most recent release note records.
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReleaseNoteControllerApi
     */
    public getTop3ByReleaseDateUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return ReleaseNoteControllerApiFp(this.configuration).getTop3ByReleaseDateUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to update a release note record by Id.
     * @param {number} id id
     * @param {ReleaseNoteDto} releaseNoteDto releaseNoteDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReleaseNoteControllerApi
     */
    public updateReleaseNoteUsingPOST(id: number, releaseNoteDto: ReleaseNoteDto, authorization?: string, options?: AxiosRequestConfig) {
        return ReleaseNoteControllerApiFp(this.configuration).updateReleaseNoteUsingPOST(id, releaseNoteDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RoadmapControllerApi - axios parameter creator
 * @export
 */
export const RoadmapControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getAllRoadmaps
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRoadmapsUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/roadmap/getAllRoadmaps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateRoadmap
         * @param {RoadmapResponseDto} repsonseDtoJson repsonseDtoJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoadmapUsingPOST: async (repsonseDtoJson: RoadmapResponseDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repsonseDtoJson' is not null or undefined
            assertParamExists('updateRoadmapUsingPOST', 'repsonseDtoJson', repsonseDtoJson)
            const localVarPath = `/roadmap/updateRoadmap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repsonseDtoJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoadmapControllerApi - functional programming interface
 * @export
 */
export const RoadmapControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoadmapControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getAllRoadmaps
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRoadmapsUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoadmapResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRoadmapsUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateRoadmap
         * @param {RoadmapResponseDto} repsonseDtoJson repsonseDtoJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRoadmapUsingPOST(repsonseDtoJson: RoadmapResponseDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoadmapResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoadmapUsingPOST(repsonseDtoJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RoadmapControllerApi - factory interface
 * @export
 */
export const RoadmapControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoadmapControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary getAllRoadmaps
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRoadmapsUsingGET(authorization?: string, options?: any): AxiosPromise<Array<RoadmapResponseDto>> {
            return localVarFp.getAllRoadmapsUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateRoadmap
         * @param {RoadmapResponseDto} repsonseDtoJson repsonseDtoJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoadmapUsingPOST(repsonseDtoJson: RoadmapResponseDto, authorization?: string, options?: any): AxiosPromise<RoadmapResponseDto> {
            return localVarFp.updateRoadmapUsingPOST(repsonseDtoJson, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoadmapControllerApi - object-oriented interface
 * @export
 * @class RoadmapControllerApi
 * @extends {BaseAPI}
 */
export class RoadmapControllerApi extends BaseAPI {
    /**
     * 
     * @summary getAllRoadmaps
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoadmapControllerApi
     */
    public getAllRoadmapsUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return RoadmapControllerApiFp(this.configuration).getAllRoadmapsUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateRoadmap
     * @param {RoadmapResponseDto} repsonseDtoJson repsonseDtoJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoadmapControllerApi
     */
    public updateRoadmapUsingPOST(repsonseDtoJson: RoadmapResponseDto, authorization?: string, options?: AxiosRequestConfig) {
        return RoadmapControllerApiFp(this.configuration).updateRoadmapUsingPOST(repsonseDtoJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SchedulerControllerApi - axios parameter creator
 * @export
 */
export const SchedulerControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createScheduler
         * @param {SchedulerDto} schedulerDto schedulerDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSchedulerUsingPOST: async (schedulerDto: SchedulerDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schedulerDto' is not null or undefined
            assertParamExists('createSchedulerUsingPOST', 'schedulerDto', schedulerDto)
            const localVarPath = `/scheduler/createScheduler`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(schedulerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteSchedulerById
         * @param {number} schedulerId schedulerId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSchedulerByIdUsingDELETE: async (schedulerId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schedulerId' is not null or undefined
            assertParamExists('deleteSchedulerByIdUsingDELETE', 'schedulerId', schedulerId)
            const localVarPath = `/scheduler/deleteSchedulerById/{schedulerId}`
                .replace(`{${"schedulerId"}}`, encodeURIComponent(String(schedulerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllScheduler
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSchedulerUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/scheduler/getAllScheduler`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getSchedulerById
         * @param {number} schedulerId schedulerId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulerByIdUsingGET: async (schedulerId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schedulerId' is not null or undefined
            assertParamExists('getSchedulerByIdUsingGET', 'schedulerId', schedulerId)
            const localVarPath = `/scheduler/getSchedulerById/{schedulerId}`
                .replace(`{${"schedulerId"}}`, encodeURIComponent(String(schedulerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateScheduler
         * @param {SchedulerDto} schedulerDto schedulerDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchedulerUsingPOST: async (schedulerDto: SchedulerDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schedulerDto' is not null or undefined
            assertParamExists('updateSchedulerUsingPOST', 'schedulerDto', schedulerDto)
            const localVarPath = `/scheduler/updateScheduler`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(schedulerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchedulerControllerApi - functional programming interface
 * @export
 */
export const SchedulerControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchedulerControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createScheduler
         * @param {SchedulerDto} schedulerDto schedulerDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSchedulerUsingPOST(schedulerDto: SchedulerDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchedulerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSchedulerUsingPOST(schedulerDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteSchedulerById
         * @param {number} schedulerId schedulerId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSchedulerByIdUsingDELETE(schedulerId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchedulerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSchedulerByIdUsingDELETE(schedulerId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllScheduler
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSchedulerUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SchedulerDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSchedulerUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getSchedulerById
         * @param {number} schedulerId schedulerId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSchedulerByIdUsingGET(schedulerId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchedulerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSchedulerByIdUsingGET(schedulerId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateScheduler
         * @param {SchedulerDto} schedulerDto schedulerDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSchedulerUsingPOST(schedulerDto: SchedulerDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchedulerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSchedulerUsingPOST(schedulerDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SchedulerControllerApi - factory interface
 * @export
 */
export const SchedulerControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchedulerControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createScheduler
         * @param {SchedulerDto} schedulerDto schedulerDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSchedulerUsingPOST(schedulerDto: SchedulerDto, authorization?: string, options?: any): AxiosPromise<SchedulerDto> {
            return localVarFp.createSchedulerUsingPOST(schedulerDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteSchedulerById
         * @param {number} schedulerId schedulerId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSchedulerByIdUsingDELETE(schedulerId: number, authorization?: string, options?: any): AxiosPromise<SchedulerDto> {
            return localVarFp.deleteSchedulerByIdUsingDELETE(schedulerId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllScheduler
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSchedulerUsingGET(authorization?: string, options?: any): AxiosPromise<Array<SchedulerDto>> {
            return localVarFp.getAllSchedulerUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getSchedulerById
         * @param {number} schedulerId schedulerId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulerByIdUsingGET(schedulerId: number, authorization?: string, options?: any): AxiosPromise<SchedulerDto> {
            return localVarFp.getSchedulerByIdUsingGET(schedulerId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateScheduler
         * @param {SchedulerDto} schedulerDto schedulerDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchedulerUsingPOST(schedulerDto: SchedulerDto, authorization?: string, options?: any): AxiosPromise<SchedulerDto> {
            return localVarFp.updateSchedulerUsingPOST(schedulerDto, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SchedulerControllerApi - object-oriented interface
 * @export
 * @class SchedulerControllerApi
 * @extends {BaseAPI}
 */
export class SchedulerControllerApi extends BaseAPI {
    /**
     * 
     * @summary createScheduler
     * @param {SchedulerDto} schedulerDto schedulerDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerControllerApi
     */
    public createSchedulerUsingPOST(schedulerDto: SchedulerDto, authorization?: string, options?: AxiosRequestConfig) {
        return SchedulerControllerApiFp(this.configuration).createSchedulerUsingPOST(schedulerDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteSchedulerById
     * @param {number} schedulerId schedulerId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerControllerApi
     */
    public deleteSchedulerByIdUsingDELETE(schedulerId: number, authorization?: string, options?: AxiosRequestConfig) {
        return SchedulerControllerApiFp(this.configuration).deleteSchedulerByIdUsingDELETE(schedulerId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllScheduler
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerControllerApi
     */
    public getAllSchedulerUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return SchedulerControllerApiFp(this.configuration).getAllSchedulerUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getSchedulerById
     * @param {number} schedulerId schedulerId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerControllerApi
     */
    public getSchedulerByIdUsingGET(schedulerId: number, authorization?: string, options?: AxiosRequestConfig) {
        return SchedulerControllerApiFp(this.configuration).getSchedulerByIdUsingGET(schedulerId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateScheduler
     * @param {SchedulerDto} schedulerDto schedulerDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerControllerApi
     */
    public updateSchedulerUsingPOST(schedulerDto: SchedulerDto, authorization?: string, options?: AxiosRequestConfig) {
        return SchedulerControllerApiFp(this.configuration).updateSchedulerUsingPOST(schedulerDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ServiceStatusControllerApi - axios parameter creator
 * @export
 */
export const ServiceStatusControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary entityCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entityCheckUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/entityCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary healthCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/healthCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary manifestCheck_core
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestCheckCoreUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/manifestCheck_core`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary manifestCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestCheckUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/manifestCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary profileCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileCheckUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/profileCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceStatusControllerApi - functional programming interface
 * @export
 */
export const ServiceStatusControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceStatusControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary entityCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async entityCheckUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.entityCheckUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary healthCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary manifestCheck_core
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manifestCheckCoreUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manifestCheckCoreUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary manifestCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manifestCheckUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manifestCheckUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary profileCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileCheckUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileCheckUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ServiceStatusControllerApi - factory interface
 * @export
 */
export const ServiceStatusControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceStatusControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary entityCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entityCheckUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.entityCheckUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary healthCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.healthCheckUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary manifestCheck_core
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestCheckCoreUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.manifestCheckCoreUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary manifestCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestCheckUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.manifestCheckUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary profileCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileCheckUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.profileCheckUsingGET(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceStatusControllerApi - object-oriented interface
 * @export
 * @class ServiceStatusControllerApi
 * @extends {BaseAPI}
 */
export class ServiceStatusControllerApi extends BaseAPI {
    /**
     * 
     * @summary entityCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public entityCheckUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).entityCheckUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary healthCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public healthCheckUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).healthCheckUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary manifestCheck_core
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public manifestCheckCoreUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).manifestCheckCoreUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary manifestCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public manifestCheckUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).manifestCheckUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary profileCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public profileCheckUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).profileCheckUsingGET(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SpatialRefControllerApi - axios parameter creator
 * @export
 */
export const SpatialRefControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createSpatialRef
         * @param {SpatialRefRequestDto} requestDto requestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSpatialRefUsingPOST: async (requestDto: SpatialRefRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestDto' is not null or undefined
            assertParamExists('createSpatialRefUsingPOST', 'requestDto', requestDto)
            const localVarPath = `/project/createSpatialRef`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteSpatialRef
         * @param {number} projectSpatialRefId projectSpatialRefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSpatialRefUsingDELETE: async (projectSpatialRefId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectSpatialRefId' is not null or undefined
            assertParamExists('deleteSpatialRefUsingDELETE', 'projectSpatialRefId', projectSpatialRefId)
            const localVarPath = `/project/deleteSpatialRefByprojectSpatialRefId/{projectSpatialRefId}`
                .replace(`{${"projectSpatialRefId"}}`, encodeURIComponent(String(projectSpatialRefId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to retrieve all available spatial ref records.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSpatialRefUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/project/getAllSpatialRef`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to retrieve an spatial ref record by Id.
         * @param {number} projectSpatialRefId projectSpatialRefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpatialRefByProjectSpatialRefIdUsingGET: async (projectSpatialRefId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectSpatialRefId' is not null or undefined
            assertParamExists('getSpatialRefByProjectSpatialRefIdUsingGET', 'projectSpatialRefId', projectSpatialRefId)
            const localVarPath = `/project/getSpatialRefByprojectSpatialRefId/{projectSpatialRefId}`
                .replace(`{${"projectSpatialRefId"}}`, encodeURIComponent(String(projectSpatialRefId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to get spatial reference json by project uuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpatialRefByProjectUuidUsingGET: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('getSpatialRefByProjectUuidUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/project/getSpatialRefByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateSpatialRefByProjectSpatialRefId
         * @param {SpatialRefRequestDto} spatialRefRequestDto spatialRefRequestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSpatialRefByProjectSpatialRefIdUsingPUT: async (spatialRefRequestDto: SpatialRefRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'spatialRefRequestDto' is not null or undefined
            assertParamExists('updateSpatialRefByProjectSpatialRefIdUsingPUT', 'spatialRefRequestDto', spatialRefRequestDto)
            const localVarPath = `/project/updateSpatialRefByProjectUuid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(spatialRefRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SpatialRefControllerApi - functional programming interface
 * @export
 */
export const SpatialRefControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SpatialRefControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createSpatialRef
         * @param {SpatialRefRequestDto} requestDto requestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSpatialRefUsingPOST(requestDto: SpatialRefRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpatialRefResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSpatialRefUsingPOST(requestDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteSpatialRef
         * @param {number} projectSpatialRefId projectSpatialRefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSpatialRefUsingDELETE(projectSpatialRefId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSpatialRefUsingDELETE(projectSpatialRefId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to retrieve all available spatial ref records.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSpatialRefUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SpatialRefResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSpatialRefUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to retrieve an spatial ref record by Id.
         * @param {number} projectSpatialRefId projectSpatialRefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpatialRefByProjectSpatialRefIdUsingGET(projectSpatialRefId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpatialRefResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpatialRefByProjectSpatialRefIdUsingGET(projectSpatialRefId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to get spatial reference json by project uuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpatialRefByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpatialRefResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpatialRefByProjectUuidUsingGET(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateSpatialRefByProjectSpatialRefId
         * @param {SpatialRefRequestDto} spatialRefRequestDto spatialRefRequestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSpatialRefByProjectSpatialRefIdUsingPUT(spatialRefRequestDto: SpatialRefRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpatialRefResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSpatialRefByProjectSpatialRefIdUsingPUT(spatialRefRequestDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SpatialRefControllerApi - factory interface
 * @export
 */
export const SpatialRefControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SpatialRefControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createSpatialRef
         * @param {SpatialRefRequestDto} requestDto requestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSpatialRefUsingPOST(requestDto: SpatialRefRequestDto, authorization?: string, options?: any): AxiosPromise<SpatialRefResponseDto> {
            return localVarFp.createSpatialRefUsingPOST(requestDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteSpatialRef
         * @param {number} projectSpatialRefId projectSpatialRefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSpatialRefUsingDELETE(projectSpatialRefId: number, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteSpatialRefUsingDELETE(projectSpatialRefId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to retrieve all available spatial ref records.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSpatialRefUsingGET(authorization?: string, options?: any): AxiosPromise<Array<SpatialRefResponseDto>> {
            return localVarFp.getAllSpatialRefUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to retrieve an spatial ref record by Id.
         * @param {number} projectSpatialRefId projectSpatialRefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpatialRefByProjectSpatialRefIdUsingGET(projectSpatialRefId: number, authorization?: string, options?: any): AxiosPromise<SpatialRefResponseDto> {
            return localVarFp.getSpatialRefByProjectSpatialRefIdUsingGET(projectSpatialRefId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to get spatial reference json by project uuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpatialRefByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: any): AxiosPromise<SpatialRefResponseDto> {
            return localVarFp.getSpatialRefByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateSpatialRefByProjectSpatialRefId
         * @param {SpatialRefRequestDto} spatialRefRequestDto spatialRefRequestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSpatialRefByProjectSpatialRefIdUsingPUT(spatialRefRequestDto: SpatialRefRequestDto, authorization?: string, options?: any): AxiosPromise<SpatialRefResponseDto> {
            return localVarFp.updateSpatialRefByProjectSpatialRefIdUsingPUT(spatialRefRequestDto, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SpatialRefControllerApi - object-oriented interface
 * @export
 * @class SpatialRefControllerApi
 * @extends {BaseAPI}
 */
export class SpatialRefControllerApi extends BaseAPI {
    /**
     * 
     * @summary createSpatialRef
     * @param {SpatialRefRequestDto} requestDto requestDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpatialRefControllerApi
     */
    public createSpatialRefUsingPOST(requestDto: SpatialRefRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return SpatialRefControllerApiFp(this.configuration).createSpatialRefUsingPOST(requestDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteSpatialRef
     * @param {number} projectSpatialRefId projectSpatialRefId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpatialRefControllerApi
     */
    public deleteSpatialRefUsingDELETE(projectSpatialRefId: number, authorization?: string, options?: AxiosRequestConfig) {
        return SpatialRefControllerApiFp(this.configuration).deleteSpatialRefUsingDELETE(projectSpatialRefId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to retrieve all available spatial ref records.
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpatialRefControllerApi
     */
    public getAllSpatialRefUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return SpatialRefControllerApiFp(this.configuration).getAllSpatialRefUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to retrieve an spatial ref record by Id.
     * @param {number} projectSpatialRefId projectSpatialRefId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpatialRefControllerApi
     */
    public getSpatialRefByProjectSpatialRefIdUsingGET(projectSpatialRefId: number, authorization?: string, options?: AxiosRequestConfig) {
        return SpatialRefControllerApiFp(this.configuration).getSpatialRefByProjectSpatialRefIdUsingGET(projectSpatialRefId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to get spatial reference json by project uuid
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpatialRefControllerApi
     */
    public getSpatialRefByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return SpatialRefControllerApiFp(this.configuration).getSpatialRefByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateSpatialRefByProjectSpatialRefId
     * @param {SpatialRefRequestDto} spatialRefRequestDto spatialRefRequestDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpatialRefControllerApi
     */
    public updateSpatialRefByProjectSpatialRefIdUsingPUT(spatialRefRequestDto: SpatialRefRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return SpatialRefControllerApiFp(this.configuration).updateSpatialRefByProjectSpatialRefIdUsingPUT(spatialRefRequestDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StateCountyControllerApi - axios parameter creator
 * @export
 */
export const StateCountyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getAllStates
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllStatesUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stateCounty/getAllStates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getCountiesByState
         * @param {string} stateCode stateCode
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountiesByStateUsingGET: async (stateCode: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getCountiesByStateUsingGET', 'stateCode', stateCode)
            const localVarPath = `/stateCounty/getCountiesByState/{stateCode}`
                .replace(`{${"stateCode"}}`, encodeURIComponent(String(stateCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getStateNameByStateCode
         * @param {string} stateCode stateCode
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateNameByStateCodeUsingGET: async (stateCode: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getStateNameByStateCodeUsingGET', 'stateCode', stateCode)
            const localVarPath = `/stateCounty/getStateNameByStateCode/{stateCode}`
                .replace(`{${"stateCode"}}`, encodeURIComponent(String(stateCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getXYByStateCounty
         * @param {string} stateCode stateCode
         * @param {string} countyName countyName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getXYByStateCountyUsingGET: async (stateCode: string, countyName: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getXYByStateCountyUsingGET', 'stateCode', stateCode)
            // verify required parameter 'countyName' is not null or undefined
            assertParamExists('getXYByStateCountyUsingGET', 'countyName', countyName)
            const localVarPath = `/stateCounty/getXYByStateCounty/{stateCode}/{countyName}`
                .replace(`{${"stateCode"}}`, encodeURIComponent(String(stateCode)))
                .replace(`{${"countyName"}}`, encodeURIComponent(String(countyName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StateCountyControllerApi - functional programming interface
 * @export
 */
export const StateCountyControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StateCountyControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getAllStates
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllStatesUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllStatesUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getCountiesByState
         * @param {string} stateCode stateCode
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountiesByStateUsingGET(stateCode: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StateCountyDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountiesByStateUsingGET(stateCode, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getStateNameByStateCode
         * @param {string} stateCode stateCode
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStateNameByStateCodeUsingGET(stateCode: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStateNameByStateCodeUsingGET(stateCode, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getXYByStateCounty
         * @param {string} stateCode stateCode
         * @param {string} countyName countyName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getXYByStateCountyUsingGET(stateCode: string, countyName: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StateCountyXYdto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getXYByStateCountyUsingGET(stateCode, countyName, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StateCountyControllerApi - factory interface
 * @export
 */
export const StateCountyControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StateCountyControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary getAllStates
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllStatesUsingGET(authorization?: string, options?: any): AxiosPromise<Array<StateDto>> {
            return localVarFp.getAllStatesUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getCountiesByState
         * @param {string} stateCode stateCode
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountiesByStateUsingGET(stateCode: string, authorization?: string, options?: any): AxiosPromise<Array<StateCountyDto>> {
            return localVarFp.getCountiesByStateUsingGET(stateCode, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getStateNameByStateCode
         * @param {string} stateCode stateCode
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateNameByStateCodeUsingGET(stateCode: string, authorization?: string, options?: any): AxiosPromise<object> {
            return localVarFp.getStateNameByStateCodeUsingGET(stateCode, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getXYByStateCounty
         * @param {string} stateCode stateCode
         * @param {string} countyName countyName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getXYByStateCountyUsingGET(stateCode: string, countyName: string, authorization?: string, options?: any): AxiosPromise<StateCountyXYdto> {
            return localVarFp.getXYByStateCountyUsingGET(stateCode, countyName, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StateCountyControllerApi - object-oriented interface
 * @export
 * @class StateCountyControllerApi
 * @extends {BaseAPI}
 */
export class StateCountyControllerApi extends BaseAPI {
    /**
     * 
     * @summary getAllStates
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StateCountyControllerApi
     */
    public getAllStatesUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return StateCountyControllerApiFp(this.configuration).getAllStatesUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getCountiesByState
     * @param {string} stateCode stateCode
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StateCountyControllerApi
     */
    public getCountiesByStateUsingGET(stateCode: string, authorization?: string, options?: AxiosRequestConfig) {
        return StateCountyControllerApiFp(this.configuration).getCountiesByStateUsingGET(stateCode, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getStateNameByStateCode
     * @param {string} stateCode stateCode
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StateCountyControllerApi
     */
    public getStateNameByStateCodeUsingGET(stateCode: string, authorization?: string, options?: AxiosRequestConfig) {
        return StateCountyControllerApiFp(this.configuration).getStateNameByStateCodeUsingGET(stateCode, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getXYByStateCounty
     * @param {string} stateCode stateCode
     * @param {string} countyName countyName
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StateCountyControllerApi
     */
    public getXYByStateCountyUsingGET(stateCode: string, countyName: string, authorization?: string, options?: AxiosRequestConfig) {
        return StateCountyControllerApiFp(this.configuration).getXYByStateCountyUsingGET(stateCode, countyName, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserInfoControllerApi - axios parameter creator
 * @export
 */
export const UserInfoControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getByUserId
         * @param {number} userId userId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByUserIdUsingGET: async (userId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getByUserIdUsingGET', 'userId', userId)
            const localVarPath = `/userInfo/getByUserId/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getByUserName
         * @param {string} userName userName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByUserNameUsingGET: async (userName: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userName' is not null or undefined
            assertParamExists('getByUserNameUsingGET', 'userName', userName)
            const localVarPath = `/userInfo/getByUserName/{userName}`
                .replace(`{${"userName"}}`, encodeURIComponent(String(userName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary selfRegister
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfRegisterUsingPOST: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/userInfo/selfRegister`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserInfoControllerApi - functional programming interface
 * @export
 */
export const UserInfoControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserInfoControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getByUserId
         * @param {number} userId userId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByUserIdUsingGET(userId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByUserIdUsingGET(userId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getByUserName
         * @param {string} userName userName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByUserNameUsingGET(userName: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByUserNameUsingGET(userName, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary selfRegister
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selfRegisterUsingPOST(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.selfRegisterUsingPOST(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserInfoControllerApi - factory interface
 * @export
 */
export const UserInfoControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserInfoControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary getByUserId
         * @param {number} userId userId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByUserIdUsingGET(userId: number, authorization?: string, options?: any): AxiosPromise<UserInfoDto> {
            return localVarFp.getByUserIdUsingGET(userId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getByUserName
         * @param {string} userName userName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByUserNameUsingGET(userName: string, authorization?: string, options?: any): AxiosPromise<UserInfoDto> {
            return localVarFp.getByUserNameUsingGET(userName, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary selfRegister
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfRegisterUsingPOST(authorization?: string, options?: any): AxiosPromise<UserInfoDto> {
            return localVarFp.selfRegisterUsingPOST(authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserInfoControllerApi - object-oriented interface
 * @export
 * @class UserInfoControllerApi
 * @extends {BaseAPI}
 */
export class UserInfoControllerApi extends BaseAPI {
    /**
     * 
     * @summary getByUserId
     * @param {number} userId userId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserInfoControllerApi
     */
    public getByUserIdUsingGET(userId: number, authorization?: string, options?: AxiosRequestConfig) {
        return UserInfoControllerApiFp(this.configuration).getByUserIdUsingGET(userId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getByUserName
     * @param {string} userName userName
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserInfoControllerApi
     */
    public getByUserNameUsingGET(userName: string, authorization?: string, options?: AxiosRequestConfig) {
        return UserInfoControllerApiFp(this.configuration).getByUserNameUsingGET(userName, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary selfRegister
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserInfoControllerApi
     */
    public selfRegisterUsingPOST(authorization?: string, options?: AxiosRequestConfig) {
        return UserInfoControllerApiFp(this.configuration).selfRegisterUsingPOST(authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserInputsControllerApi - axios parameter creator
 * @export
 */
export const UserInputsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getUserInputsByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInputsByProjectUuidUsingGET: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('getUserInputsByProjectUuidUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/metadata/getUserInputsByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateUserInputsByProjectUuid
         * @param {HydroUserInputsDto} userInputsJson userInputsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserInputsByProjectUuidUsingPOST: async (userInputsJson: HydroUserInputsDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userInputsJson' is not null or undefined
            assertParamExists('updateUserInputsByProjectUuidUsingPOST', 'userInputsJson', userInputsJson)
            const localVarPath = `/metadata/updateUserInputsByProjectUuid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userInputsJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserInputsControllerApi - functional programming interface
 * @export
 */
export const UserInputsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserInputsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getUserInputsByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserInputsByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HydroUserInputsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserInputsByProjectUuidUsingGET(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateUserInputsByProjectUuid
         * @param {HydroUserInputsDto} userInputsJson userInputsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserInputsByProjectUuidUsingPOST(userInputsJson: HydroUserInputsDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HydroUserInputsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserInputsByProjectUuidUsingPOST(userInputsJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserInputsControllerApi - factory interface
 * @export
 */
export const UserInputsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserInputsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary getUserInputsByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInputsByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: any): AxiosPromise<HydroUserInputsDto> {
            return localVarFp.getUserInputsByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateUserInputsByProjectUuid
         * @param {HydroUserInputsDto} userInputsJson userInputsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserInputsByProjectUuidUsingPOST(userInputsJson: HydroUserInputsDto, authorization?: string, options?: any): AxiosPromise<HydroUserInputsDto> {
            return localVarFp.updateUserInputsByProjectUuidUsingPOST(userInputsJson, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserInputsControllerApi - object-oriented interface
 * @export
 * @class UserInputsControllerApi
 * @extends {BaseAPI}
 */
export class UserInputsControllerApi extends BaseAPI {
    /**
     * 
     * @summary getUserInputsByProjectUuid
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserInputsControllerApi
     */
    public getUserInputsByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return UserInputsControllerApiFp(this.configuration).getUserInputsByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateUserInputsByProjectUuid
     * @param {HydroUserInputsDto} userInputsJson userInputsJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserInputsControllerApi
     */
    public updateUserInputsByProjectUuidUsingPOST(userInputsJson: HydroUserInputsDto, authorization?: string, options?: AxiosRequestConfig) {
        return UserInputsControllerApiFp(this.configuration).updateUserInputsByProjectUuidUsingPOST(userInputsJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserPreferenceControllerApi - axios parameter creator
 * @export
 */
export const UserPreferenceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary deleteUserPreferenceByType
         * @param {string} currentUser currentUser
         * @param {string} preferenceType preferenceType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserPreferenceByTypeUsingDELETE: async (currentUser: string, preferenceType: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currentUser' is not null or undefined
            assertParamExists('deleteUserPreferenceByTypeUsingDELETE', 'currentUser', currentUser)
            // verify required parameter 'preferenceType' is not null or undefined
            assertParamExists('deleteUserPreferenceByTypeUsingDELETE', 'preferenceType', preferenceType)
            const localVarPath = `/userPreferences/deleteUserPreference/{preferenceType}`
                .replace(`{${"preferenceType"}}`, encodeURIComponent(String(preferenceType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (currentUser !== undefined) {
                localVarQueryParameter['currentUser'] = currentUser;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteUserPreference
         * @param {string} currentUser currentUser
         * @param {string} key key
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserPreferenceUsingDELETE: async (currentUser: string, key: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currentUser' is not null or undefined
            assertParamExists('deleteUserPreferenceUsingDELETE', 'currentUser', currentUser)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('deleteUserPreferenceUsingDELETE', 'key', key)
            const localVarPath = `/userPreferences/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (currentUser !== undefined) {
                localVarQueryParameter['currentUser'] = currentUser;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllPreferencesByUser
         * @param {string} currentUser currentUser
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPreferencesByUserUsingGET: async (currentUser: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currentUser' is not null or undefined
            assertParamExists('getAllPreferencesByUserUsingGET', 'currentUser', currentUser)
            const localVarPath = `/userPreferences/getAllPreferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (currentUser !== undefined) {
                localVarQueryParameter['currentUser'] = currentUser;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllUserPreferences
         * @param {string} currentUser currentUser
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUserPreferencesUsingGET: async (currentUser: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currentUser' is not null or undefined
            assertParamExists('getAllUserPreferencesUsingGET', 'currentUser', currentUser)
            const localVarPath = `/userPreferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (currentUser !== undefined) {
                localVarQueryParameter['currentUser'] = currentUser;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getLandLevellling
         * @param {string} currentUser currentUser
         * @param {string} preferenceType preferenceType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandLevelllingUsingGET: async (currentUser: string, preferenceType: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currentUser' is not null or undefined
            assertParamExists('getLandLevelllingUsingGET', 'currentUser', currentUser)
            // verify required parameter 'preferenceType' is not null or undefined
            assertParamExists('getLandLevelllingUsingGET', 'preferenceType', preferenceType)
            const localVarPath = `/userPreferences/getLandLevelling/{preferenceType}`
                .replace(`{${"preferenceType"}}`, encodeURIComponent(String(preferenceType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (currentUser !== undefined) {
                localVarQueryParameter['currentUser'] = currentUser;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getUserPreferenceByType
         * @param {string} currentUser currentUser
         * @param {string} preferenceType preferenceType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPreferenceByTypeUsingGET: async (currentUser: string, preferenceType: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currentUser' is not null or undefined
            assertParamExists('getUserPreferenceByTypeUsingGET', 'currentUser', currentUser)
            // verify required parameter 'preferenceType' is not null or undefined
            assertParamExists('getUserPreferenceByTypeUsingGET', 'preferenceType', preferenceType)
            const localVarPath = `/userPreferences/getUserPreference/{preferenceType}`
                .replace(`{${"preferenceType"}}`, encodeURIComponent(String(preferenceType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (currentUser !== undefined) {
                localVarQueryParameter['currentUser'] = currentUser;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getUserPreference
         * @param {string} currentUser currentUser
         * @param {string} key key
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPreferenceUsingGET: async (currentUser: string, key: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currentUser' is not null or undefined
            assertParamExists('getUserPreferenceUsingGET', 'currentUser', currentUser)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getUserPreferenceUsingGET', 'key', key)
            const localVarPath = `/userPreferences/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (currentUser !== undefined) {
                localVarQueryParameter['currentUser'] = currentUser;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary saveUserPreferenceByType
         * @param {string} currentUser currentUser
         * @param {string} preferenceType preferenceType
         * @param {UserPreferencesDto} userPreference userPreference
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserPreferenceByTypeUsingPOST: async (currentUser: string, preferenceType: string, userPreference: UserPreferencesDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currentUser' is not null or undefined
            assertParamExists('saveUserPreferenceByTypeUsingPOST', 'currentUser', currentUser)
            // verify required parameter 'preferenceType' is not null or undefined
            assertParamExists('saveUserPreferenceByTypeUsingPOST', 'preferenceType', preferenceType)
            // verify required parameter 'userPreference' is not null or undefined
            assertParamExists('saveUserPreferenceByTypeUsingPOST', 'userPreference', userPreference)
            const localVarPath = `/userPreferences/saveUserPreference/{preferenceType}`
                .replace(`{${"preferenceType"}}`, encodeURIComponent(String(preferenceType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (currentUser !== undefined) {
                localVarQueryParameter['currentUser'] = currentUser;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userPreference, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary saveUserPreference
         * @param {string} currentUser currentUser
         * @param {string} key key
         * @param {UserPreferenceDto} body body
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserPreferenceUsingPOST: async (currentUser: string, key: string, body: UserPreferenceDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currentUser' is not null or undefined
            assertParamExists('saveUserPreferenceUsingPOST', 'currentUser', currentUser)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('saveUserPreferenceUsingPOST', 'key', key)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveUserPreferenceUsingPOST', 'body', body)
            const localVarPath = `/userPreferences/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (currentUser !== undefined) {
                localVarQueryParameter['currentUser'] = currentUser;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserPreferenceControllerApi - functional programming interface
 * @export
 */
export const UserPreferenceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserPreferenceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary deleteUserPreferenceByType
         * @param {string} currentUser currentUser
         * @param {string} preferenceType preferenceType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserPreferenceByTypeUsingDELETE(currentUser: string, preferenceType: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserPreferenceByTypeUsingDELETE(currentUser, preferenceType, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteUserPreference
         * @param {string} currentUser currentUser
         * @param {string} key key
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserPreferenceUsingDELETE(currentUser: string, key: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserPreferenceUsingDELETE(currentUser, key, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllPreferencesByUser
         * @param {string} currentUser currentUser
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPreferencesByUserUsingGET(currentUser: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserPreferencesDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPreferencesByUserUsingGET(currentUser, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllUserPreferences
         * @param {string} currentUser currentUser
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUserPreferencesUsingGET(currentUser: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserPreferenceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUserPreferencesUsingGET(currentUser, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getLandLevellling
         * @param {string} currentUser currentUser
         * @param {string} preferenceType preferenceType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLandLevelllingUsingGET(currentUser: string, preferenceType: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LandLevelingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLandLevelllingUsingGET(currentUser, preferenceType, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getUserPreferenceByType
         * @param {string} currentUser currentUser
         * @param {string} preferenceType preferenceType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserPreferenceByTypeUsingGET(currentUser: string, preferenceType: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPreferencesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserPreferenceByTypeUsingGET(currentUser, preferenceType, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getUserPreference
         * @param {string} currentUser currentUser
         * @param {string} key key
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserPreferenceUsingGET(currentUser: string, key: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPreferenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserPreferenceUsingGET(currentUser, key, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary saveUserPreferenceByType
         * @param {string} currentUser currentUser
         * @param {string} preferenceType preferenceType
         * @param {UserPreferencesDto} userPreference userPreference
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveUserPreferenceByTypeUsingPOST(currentUser: string, preferenceType: string, userPreference: UserPreferencesDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPreferencesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveUserPreferenceByTypeUsingPOST(currentUser, preferenceType, userPreference, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary saveUserPreference
         * @param {string} currentUser currentUser
         * @param {string} key key
         * @param {UserPreferenceDto} body body
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveUserPreferenceUsingPOST(currentUser: string, key: string, body: UserPreferenceDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPreferenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveUserPreferenceUsingPOST(currentUser, key, body, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserPreferenceControllerApi - factory interface
 * @export
 */
export const UserPreferenceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserPreferenceControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary deleteUserPreferenceByType
         * @param {string} currentUser currentUser
         * @param {string} preferenceType preferenceType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserPreferenceByTypeUsingDELETE(currentUser: string, preferenceType: string, authorization?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.deleteUserPreferenceByTypeUsingDELETE(currentUser, preferenceType, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteUserPreference
         * @param {string} currentUser currentUser
         * @param {string} key key
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserPreferenceUsingDELETE(currentUser: string, key: string, authorization?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.deleteUserPreferenceUsingDELETE(currentUser, key, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllPreferencesByUser
         * @param {string} currentUser currentUser
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPreferencesByUserUsingGET(currentUser: string, authorization?: string, options?: any): AxiosPromise<Array<UserPreferencesDto>> {
            return localVarFp.getAllPreferencesByUserUsingGET(currentUser, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllUserPreferences
         * @param {string} currentUser currentUser
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUserPreferencesUsingGET(currentUser: string, authorization?: string, options?: any): AxiosPromise<Array<UserPreferenceDto>> {
            return localVarFp.getAllUserPreferencesUsingGET(currentUser, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getLandLevellling
         * @param {string} currentUser currentUser
         * @param {string} preferenceType preferenceType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandLevelllingUsingGET(currentUser: string, preferenceType: string, authorization?: string, options?: any): AxiosPromise<LandLevelingDto> {
            return localVarFp.getLandLevelllingUsingGET(currentUser, preferenceType, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getUserPreferenceByType
         * @param {string} currentUser currentUser
         * @param {string} preferenceType preferenceType
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPreferenceByTypeUsingGET(currentUser: string, preferenceType: string, authorization?: string, options?: any): AxiosPromise<UserPreferencesDto> {
            return localVarFp.getUserPreferenceByTypeUsingGET(currentUser, preferenceType, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getUserPreference
         * @param {string} currentUser currentUser
         * @param {string} key key
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPreferenceUsingGET(currentUser: string, key: string, authorization?: string, options?: any): AxiosPromise<UserPreferenceDto> {
            return localVarFp.getUserPreferenceUsingGET(currentUser, key, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary saveUserPreferenceByType
         * @param {string} currentUser currentUser
         * @param {string} preferenceType preferenceType
         * @param {UserPreferencesDto} userPreference userPreference
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserPreferenceByTypeUsingPOST(currentUser: string, preferenceType: string, userPreference: UserPreferencesDto, authorization?: string, options?: any): AxiosPromise<UserPreferencesDto> {
            return localVarFp.saveUserPreferenceByTypeUsingPOST(currentUser, preferenceType, userPreference, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary saveUserPreference
         * @param {string} currentUser currentUser
         * @param {string} key key
         * @param {UserPreferenceDto} body body
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserPreferenceUsingPOST(currentUser: string, key: string, body: UserPreferenceDto, authorization?: string, options?: any): AxiosPromise<UserPreferenceDto> {
            return localVarFp.saveUserPreferenceUsingPOST(currentUser, key, body, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserPreferenceControllerApi - object-oriented interface
 * @export
 * @class UserPreferenceControllerApi
 * @extends {BaseAPI}
 */
export class UserPreferenceControllerApi extends BaseAPI {
    /**
     * 
     * @summary deleteUserPreferenceByType
     * @param {string} currentUser currentUser
     * @param {string} preferenceType preferenceType
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPreferenceControllerApi
     */
    public deleteUserPreferenceByTypeUsingDELETE(currentUser: string, preferenceType: string, authorization?: string, options?: AxiosRequestConfig) {
        return UserPreferenceControllerApiFp(this.configuration).deleteUserPreferenceByTypeUsingDELETE(currentUser, preferenceType, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteUserPreference
     * @param {string} currentUser currentUser
     * @param {string} key key
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPreferenceControllerApi
     */
    public deleteUserPreferenceUsingDELETE(currentUser: string, key: string, authorization?: string, options?: AxiosRequestConfig) {
        return UserPreferenceControllerApiFp(this.configuration).deleteUserPreferenceUsingDELETE(currentUser, key, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllPreferencesByUser
     * @param {string} currentUser currentUser
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPreferenceControllerApi
     */
    public getAllPreferencesByUserUsingGET(currentUser: string, authorization?: string, options?: AxiosRequestConfig) {
        return UserPreferenceControllerApiFp(this.configuration).getAllPreferencesByUserUsingGET(currentUser, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllUserPreferences
     * @param {string} currentUser currentUser
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPreferenceControllerApi
     */
    public getAllUserPreferencesUsingGET(currentUser: string, authorization?: string, options?: AxiosRequestConfig) {
        return UserPreferenceControllerApiFp(this.configuration).getAllUserPreferencesUsingGET(currentUser, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getLandLevellling
     * @param {string} currentUser currentUser
     * @param {string} preferenceType preferenceType
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPreferenceControllerApi
     */
    public getLandLevelllingUsingGET(currentUser: string, preferenceType: string, authorization?: string, options?: AxiosRequestConfig) {
        return UserPreferenceControllerApiFp(this.configuration).getLandLevelllingUsingGET(currentUser, preferenceType, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getUserPreferenceByType
     * @param {string} currentUser currentUser
     * @param {string} preferenceType preferenceType
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPreferenceControllerApi
     */
    public getUserPreferenceByTypeUsingGET(currentUser: string, preferenceType: string, authorization?: string, options?: AxiosRequestConfig) {
        return UserPreferenceControllerApiFp(this.configuration).getUserPreferenceByTypeUsingGET(currentUser, preferenceType, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getUserPreference
     * @param {string} currentUser currentUser
     * @param {string} key key
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPreferenceControllerApi
     */
    public getUserPreferenceUsingGET(currentUser: string, key: string, authorization?: string, options?: AxiosRequestConfig) {
        return UserPreferenceControllerApiFp(this.configuration).getUserPreferenceUsingGET(currentUser, key, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary saveUserPreferenceByType
     * @param {string} currentUser currentUser
     * @param {string} preferenceType preferenceType
     * @param {UserPreferencesDto} userPreference userPreference
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPreferenceControllerApi
     */
    public saveUserPreferenceByTypeUsingPOST(currentUser: string, preferenceType: string, userPreference: UserPreferencesDto, authorization?: string, options?: AxiosRequestConfig) {
        return UserPreferenceControllerApiFp(this.configuration).saveUserPreferenceByTypeUsingPOST(currentUser, preferenceType, userPreference, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary saveUserPreference
     * @param {string} currentUser currentUser
     * @param {string} key key
     * @param {UserPreferenceDto} body body
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPreferenceControllerApi
     */
    public saveUserPreferenceUsingPOST(currentUser: string, key: string, body: UserPreferenceDto, authorization?: string, options?: AxiosRequestConfig) {
        return UserPreferenceControllerApiFp(this.configuration).saveUserPreferenceUsingPOST(currentUser, key, body, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ValueDomainControllerApi - axios parameter creator
 * @export
 */
export const ValueDomainControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getAllDataSourceTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDataSourceTypesUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/valueDomains/dataSourceTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllDesignElementClasses
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDesignElementClassesUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/valueDomains/designElementClasses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllProjectClasses
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectClassesUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/valueDomains/projectClasses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllProjectStatusTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectStatusTypesUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/valueDomains/projectStatusTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllResourceTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllResourceTypesUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/valueDomains/resourceTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllSessionTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSessionTypesUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/valueDomains/sessionTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllSurfaceDefClasses
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSurfaceDefClassesUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/valueDomains/surfaceDefClasses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllSurfaceDefTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSurfaceDefTypesUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/valueDomains/surfaceDefTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllUserInputStateTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUserInputStateTypesUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/valueDomains/userInputStateTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllUserPreferenceTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUserPreferenceTypesUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/valueDomains/userPreferenceTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllValueDomains
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllValueDomainsUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/valueDomains`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllZUnitTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllZUnitTypesUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/valueDomains/zUnitTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValueDomainControllerApi - functional programming interface
 * @export
 */
export const ValueDomainControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ValueDomainControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getAllDataSourceTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDataSourceTypesUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValueDomainItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDataSourceTypesUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllDesignElementClasses
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDesignElementClassesUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValueDomainItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDesignElementClassesUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllProjectClasses
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProjectClassesUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValueDomainItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProjectClassesUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllProjectStatusTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProjectStatusTypesUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValueDomainItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProjectStatusTypesUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllResourceTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllResourceTypesUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValueDomainItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllResourceTypesUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllSessionTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSessionTypesUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValueDomainItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSessionTypesUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllSurfaceDefClasses
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSurfaceDefClassesUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValueDomainItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSurfaceDefClassesUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllSurfaceDefTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSurfaceDefTypesUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValueDomainItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSurfaceDefTypesUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllUserInputStateTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUserInputStateTypesUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValueDomainItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUserInputStateTypesUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllUserPreferenceTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUserPreferenceTypesUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValueDomainItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUserPreferenceTypesUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllValueDomains
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllValueDomainsUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValueDomainDictionaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllValueDomainsUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllZUnitTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllZUnitTypesUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValueDomainItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllZUnitTypesUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ValueDomainControllerApi - factory interface
 * @export
 */
export const ValueDomainControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ValueDomainControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary getAllDataSourceTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDataSourceTypesUsingGET(authorization?: string, options?: any): AxiosPromise<Array<ValueDomainItemDto>> {
            return localVarFp.getAllDataSourceTypesUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllDesignElementClasses
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDesignElementClassesUsingGET(authorization?: string, options?: any): AxiosPromise<Array<ValueDomainItemDto>> {
            return localVarFp.getAllDesignElementClassesUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllProjectClasses
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectClassesUsingGET(authorization?: string, options?: any): AxiosPromise<Array<ValueDomainItemDto>> {
            return localVarFp.getAllProjectClassesUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllProjectStatusTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectStatusTypesUsingGET(authorization?: string, options?: any): AxiosPromise<Array<ValueDomainItemDto>> {
            return localVarFp.getAllProjectStatusTypesUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllResourceTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllResourceTypesUsingGET(authorization?: string, options?: any): AxiosPromise<Array<ValueDomainItemDto>> {
            return localVarFp.getAllResourceTypesUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllSessionTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSessionTypesUsingGET(authorization?: string, options?: any): AxiosPromise<Array<ValueDomainItemDto>> {
            return localVarFp.getAllSessionTypesUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllSurfaceDefClasses
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSurfaceDefClassesUsingGET(authorization?: string, options?: any): AxiosPromise<Array<ValueDomainItemDto>> {
            return localVarFp.getAllSurfaceDefClassesUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllSurfaceDefTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSurfaceDefTypesUsingGET(authorization?: string, options?: any): AxiosPromise<Array<ValueDomainItemDto>> {
            return localVarFp.getAllSurfaceDefTypesUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllUserInputStateTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUserInputStateTypesUsingGET(authorization?: string, options?: any): AxiosPromise<Array<ValueDomainItemDto>> {
            return localVarFp.getAllUserInputStateTypesUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllUserPreferenceTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUserPreferenceTypesUsingGET(authorization?: string, options?: any): AxiosPromise<Array<ValueDomainItemDto>> {
            return localVarFp.getAllUserPreferenceTypesUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllValueDomains
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllValueDomainsUsingGET(authorization?: string, options?: any): AxiosPromise<ValueDomainDictionaryDto> {
            return localVarFp.getAllValueDomainsUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllZUnitTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllZUnitTypesUsingGET(authorization?: string, options?: any): AxiosPromise<Array<ValueDomainItemDto>> {
            return localVarFp.getAllZUnitTypesUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ValueDomainControllerApi - object-oriented interface
 * @export
 * @class ValueDomainControllerApi
 * @extends {BaseAPI}
 */
export class ValueDomainControllerApi extends BaseAPI {
    /**
     * 
     * @summary getAllDataSourceTypes
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValueDomainControllerApi
     */
    public getAllDataSourceTypesUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return ValueDomainControllerApiFp(this.configuration).getAllDataSourceTypesUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllDesignElementClasses
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValueDomainControllerApi
     */
    public getAllDesignElementClassesUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return ValueDomainControllerApiFp(this.configuration).getAllDesignElementClassesUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllProjectClasses
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValueDomainControllerApi
     */
    public getAllProjectClassesUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return ValueDomainControllerApiFp(this.configuration).getAllProjectClassesUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllProjectStatusTypes
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValueDomainControllerApi
     */
    public getAllProjectStatusTypesUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return ValueDomainControllerApiFp(this.configuration).getAllProjectStatusTypesUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllResourceTypes
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValueDomainControllerApi
     */
    public getAllResourceTypesUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return ValueDomainControllerApiFp(this.configuration).getAllResourceTypesUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllSessionTypes
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValueDomainControllerApi
     */
    public getAllSessionTypesUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return ValueDomainControllerApiFp(this.configuration).getAllSessionTypesUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllSurfaceDefClasses
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValueDomainControllerApi
     */
    public getAllSurfaceDefClassesUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return ValueDomainControllerApiFp(this.configuration).getAllSurfaceDefClassesUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllSurfaceDefTypes
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValueDomainControllerApi
     */
    public getAllSurfaceDefTypesUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return ValueDomainControllerApiFp(this.configuration).getAllSurfaceDefTypesUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllUserInputStateTypes
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValueDomainControllerApi
     */
    public getAllUserInputStateTypesUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return ValueDomainControllerApiFp(this.configuration).getAllUserInputStateTypesUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllUserPreferenceTypes
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValueDomainControllerApi
     */
    public getAllUserPreferenceTypesUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return ValueDomainControllerApiFp(this.configuration).getAllUserPreferenceTypesUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllValueDomains
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValueDomainControllerApi
     */
    public getAllValueDomainsUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return ValueDomainControllerApiFp(this.configuration).getAllValueDomainsUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllZUnitTypes
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValueDomainControllerApi
     */
    public getAllZUnitTypesUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return ValueDomainControllerApiFp(this.configuration).getAllZUnitTypesUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


